(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6120],{

/***/ 95759:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...slug]]",
      function () {
        return __webpack_require__(25005);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Icon__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82218);



/***/ }),

/***/ 23127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const useLockBodyScroll = (stop)=>{
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(()=>{
        if (stop) {
            document.body.style.overflowY = "hidden";
            // position relative makes this work for safari
            document.body.style.position = "relative";
            document.body.style.overflowX = "clip";
        } else {
            document.body.style.overflowY = "scroll";
            document.body.style.overflowX = "clip";
        }
    }, [
        stop
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useLockBodyScroll);


/***/ }),

/***/ 25005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// NAMESPACE OBJECT: ./blocks/index.ts
var blocks_namespaceObject = {};
__webpack_require__.r(blocks_namespaceObject);
__webpack_require__.d(blocks_namespaceObject, {
  "AboutHero": function() { return AboutHero; },
  "AboutItem": function() { return AboutItem; },
  "AnimatedColumnBlock": function() { return AnimatedColumnBlock; },
  "AnimatedMap": function() { return AnimatedMap; },
  "BackgroundImage": function() { return BackgroundImage; },
  "BlendedContactBlock": function() { return BlendedContactBlock; },
  "BlendedText": function() { return BlendedText; },
  "CGRRiverBlock": function() { return CGRRiverBlock; },
  "ChipBlock": function() { return ChipBlock; },
  "ContactForm": function() { return ContactForm; },
  "ContainedImage": function() { return ContainedImage; },
  "FullWidthImage": function() { return FullWidthImage; },
  "HorizontalSlideshow": function() { return HorizontalSlideshow; },
  "KitchenSink": function() { return KitchenSink; },
  "Landing": function() { return Landing; },
  "NumbersBlock": function() { return NumbersBlock; },
  "PageHero": function() { return PageHero; },
  "ProcessBlock": function() { return ProcessBlock; },
  "ProgressCirclesBlock": function() { return ProgressCirclesBlock; },
  "ProjectHero": function() { return ProjectHero; },
  "ProjectListBlock": function() { return ProjectListBlock; },
  "ProjectsIndex": function() { return ProjectsIndex; },
  "QuoteBlock": function() { return QuoteBlock; },
  "QuoteShowcase": function() { return QuoteShowcase; },
  "QuoteWithAuthor": function() { return QuoteWithAuthor; },
  "ResultsBlock": function() { return ResultsBlock; },
  "ScrollableImage": function() { return ScrollableImage; },
  "SpacerBlock": function() { return SpacerBlock; },
  "Team": function() { return Team; },
  "TextAndIcons": function() { return TextAndIcons; },
  "TextBlock": function() { return TextBlock; },
  "TextImageBlock": function() { return TextImageBlock; },
  "TextWithColumnsBlock": function() { return TextWithColumnsBlock; },
  "ThemeSliderBlock": function() { return ThemeSliderBlock; },
  "ThreeColumnImageAndTextBlock": function() { return ThreeColumnImageAndTextBlock; },
  "ToolsBlock": function() { return ToolsBlock; },
  "VideoBlock": function() { return VideoBlock; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __webpack_require__(57557);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/tinycolor2/esm/tinycolor.js
var tinycolor = __webpack_require__(97234);
// EXTERNAL MODULE: ./theme/mixins/padding.ts
var padding = __webpack_require__(54986);
;// CONCATENATED MODULE: ./public/svg/footer-logo-mobile.svg
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgFooterLogoMobile = function SvgFooterLogoMobile(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#footer-logo-mobile_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M109.968 24.966H24.97v19.407h75.288v6.22H19.421V19.407h99.335V0H9.711C4.348 0 0 4.344 0 9.704v50.592C0 65.656 4.348 70 9.71 70h100.258c5.363 0 9.711-4.344 9.711-9.704V34.67c0-5.36-4.348-9.703-9.711-9.703Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/react.createElement("path", {
    fill: props.color,
    d: "M0 0h19.351v19.356H0z",
    stroke: props.color
  }), /*#__PURE__*/react.createElement("path", {
    d: "M13.797 4.257 12.04 6.022 10.274 7.78 8.514 9.545l1.032 1.025 1.758-1.758.734.733-2.5 2.492-2.492-2.492 3.524-3.523L9.54 4.991 5.504 9.033v1.025l3.523 3.523h1.025l3.524-3.523V9.033L12.329 7.78l.734-.733 2.5 2.498-6.023 6.023-6.016-6.023L9.54 3.523l1.765 1.765 1.024-1.031-2.27-2.277H9.027L1.98 9.033v1.025l7.047 7.046h1.025l7.047-7.046V9.033l-3.004-3.01.734-.735 4.257 4.257-9.546 9.546L0 9.545 9.547 0l4.25 4.257ZM124.85 9.717v60.284h19.421V44.373h99.879V24.966h-99.879V19.42h99.879V.014H134.56c-5.363 0-9.71 4.344-9.71 9.703ZM359.289 31.897c5.363 0 9.711-4.344 9.711-9.704V.013h-19.421V12.49H269.12V.014h-19.421v22.18c0 5.359 4.348 9.703 9.711 9.703h40.229v5.545H259.41c-5.363 0-9.711 4.344-9.711 9.704V70h19.421V56.849h80.459v13.152H369V47.145c0-5.36-4.348-9.704-9.711-9.704H319.06v-5.545h40.229Z",
    fill: props.color,
    stroke: props.color
  })), /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "footer-logo-mobile_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: props.color,
    d: "M0 0h369v70H0z",
    stroke: props.color
  }))));
};
/* harmony default export */ var footer_logo_mobile = (SvgFooterLogoMobile);
;// CONCATENATED MODULE: ./public/svg/footer-logo-desktop.svg
function footer_logo_desktop_extends() { footer_logo_desktop_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return footer_logo_desktop_extends.apply(this, arguments); }

var SvgFooterLogoDesktop = function SvgFooterLogoDesktop(props) {
  return /*#__PURE__*/react.createElement("svg", footer_logo_desktop_extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#footer-logo-desktop_svg__a)",
    fill: "#fff"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M188.047 45.106H45.42v33.812h125.594v11.268l-136.949-.02V33.813h169.336V0H17.033C7.626 0 0 7.569 0 16.906v90.164c0 9.336 7.624 16.904 17.03 16.906l171.014.024h.003a17.1 17.1 0 0 0 12.043-4.95 16.848 16.848 0 0 0 4.989-11.956V62.012c0-9.337-7.625-16.906-17.032-16.906ZM1373.97 56.352c9.4 0 17.03-7.568 17.03-16.905V0h-34.06v22.541h-102.2V0h-34.07v39.447c0 9.337 7.63 16.905 17.04 16.905h51.09v11.271h-51.09c-9.41 0-17.04 7.569-17.04 16.906v39.447h34.07v-22.541h102.2v22.541H1391V84.529c0-9.337-7.63-16.906-17.03-16.906h-51.1v-11.27h51.1ZM635.886 45.082h-11.355c-9.407 0-17.033 7.569-17.033 16.906v28.176h-17.032V61.988c0-9.337-7.626-16.906-17.033-16.906h-10.668V0H528.7v61.988c0 9.337 7.626 16.906 17.033 16.906H556.4v28.176c0 9.337 7.626 16.906 17.033 16.906h51.098c9.407 0 17.033-7.569 17.033-16.906V78.894h11.355c9.407 0 17.032-7.57 17.032-16.906V0h-34.065v45.082ZM505.99 0H382.551c-9.407 0-17.032 7.569-17.032 16.906v100.879l-31.347-38.891h8.637c9.407 0 17.032-7.57 17.032-16.906V16.906C359.841 7.569 352.216 0 342.809 0H227.102c-9.407 0-17.033 7.569-17.033 16.906v107.07h34.066V78.894h46.412l36.337 45.082h72.7V78.894h89.373v45.082h34.065V16.906C523.022 7.569 515.397 0 505.99 0ZM244.135 33.812h81.641v11.27h-81.641v-11.27Zm155.449 11.27v-11.27h89.373v11.27h-89.373ZM675.629 16.906v90.164c0 9.337 7.625 16.906 17.033 16.906h124.906V90.164H709.694v-11.27h107.874V45.082H709.694v-11.27h107.874V0H692.662c-9.408 0-17.033 7.569-17.033 16.906ZM1073.06 16.906v90.164c0 9.337 7.62 16.906 17.03 16.906H1215V90.164h-107.88v-11.27H1215V45.082h-107.88v-11.27H1215V0h-124.91c-9.41 0-17.03 7.569-17.03 16.906ZM823.245 16.906v107.07h34.065V78.894h90.841V45.082H857.31v-11.27h90.841V0H840.278c-9.407 0-17.033 7.569-17.033 16.906ZM987.893 0h-34.065v107.07c0 9.337 7.626 16.906 17.033 16.906h96.519V90.164h-79.487V0Z",
    fill: props.color,
    stroke: props.color
  })), /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "footer-logo-desktop_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: props.color,
    d: "M0 0h1391v124H0z",
    stroke: props.color
  }))));
};
/* harmony default export */ var footer_logo_desktop = (SvgFooterLogoDesktop);
;// CONCATENATED MODULE: ./components/Footer/Footer.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  align-content: space-between;\n  justify-items: center;\n  z-index: 2;\n  gap: 1rem;\n  ",
        ";\n  padding-bottom: 1rem;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-columns: 1fr max-content;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 1.5rem;\n    grid-template-columns: 1fr 1fr 1fr max-content;\n    justify-content: space-between;\n    gap: 2rem;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  width: 100%;\n  border: solid #666 1px;\n  background: ",
        ";\n  color: ",
        ";\n  position: relative;\n  left: 0;\n  bottom: 0;\n  border-radius: 1rem;\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: 1fr max-content;\n  padding: 1rem;\n\n  ",
        "\n\n  ",
        "\n\n  small {\n    color: ",
        ";\n    font-size: 0.75rem;\n    line-height: 1;\n  }\n\n  a {\n    transition: opacity 0.2s;\n    opacity: 1;\n    font-family: SpaceGroteskLight;\n    font-weight: 300;\n    color: ",
        ";\n\n    &:hover {\n      opacity: 0.8;\n    }\n\n    &:focus {\n      opacity: 0.7;\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    &:first-child, &:last-child {\n      grid-column: span 2;\n    }\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      justify-content: space-between;\n      grid-template-columns: 1fr max-content;\n      text-align: left;\n    "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    &:nth-child(2) {\n      text-align: right;\n      justify-content: end;\n    }\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-rows: 3rem max-content;\n  "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  align-content: space-between;\n\n  ",
        "\n\n  &:last-child {\n    text-align: right;\n    justify-content: end;\n\n    ",
        "\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.125rem !important;\n  color: ",
        ";\n  padding: 0;\n  margin: 0;\n  line-height: 0.9 !important;\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style-type: none;\n  font-size: 1.125rem;\n  align-self: end;\n  padding-left: 0 !important;\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 !important;\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    svg path {\n      fill: ",
        ";\n    }\n  "
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  overflow: hidden;\n  width: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    path:nth-child(2) {\n      fill: ",
        ";\n    }\n  "
    ]);
    _templateObject14 = function() {
        return data;
    };
    return data;
}
function _templateObject15() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n  "
    ]);
    _templateObject15 = function() {
        return data;
    };
    return data;
}
function _templateObject16() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  aspect-ratio: 369 / 70;\n  display: block;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject16 = function() {
        return data;
    };
    return data;
}
function _templateObject17() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: block;\n  "
    ]);
    _templateObject17 = function() {
        return data;
    };
    return data;
}
function _templateObject18() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  aspect-ratio: 1391 / 124;\n\n  ",
        "\n"
    ]);
    _templateObject18 = function() {
        return data;
    };
    return data;
}








const FooterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dfe43c58-0"
})(_templateObject(), (0,padding/* blockPadH */.XA)());
const FooterContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dfe43c58-1"
})(_templateObject3(), (0,padding/* blockW */.g5)(), (param)=>{
    let { theme: { themeColors  }  } = param;
    return (0,tinycolor/* default */.Z)(themeColors.bg).setAlpha(0.5).toRgbString();
}, (param)=>{
    let { theme: { themeColors  }  } = param;
    return themeColors.fg;
}, (param)=>{
    let { theme: { mq  }  } = param;
    return mq.sm(_templateObject1());
}, (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(_templateObject2());
}, (param)=>{
    let { theme: { themeColors  }  } = param;
    return (0,tinycolor/* default */.Z)(themeColors.fg).setAlpha(0.8).toRgbString();
}, (param)=>{
    let { theme: { themeColors  }  } = param;
    return themeColors.fg;
});
const FooterColumn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dfe43c58-2"
})(_templateObject8(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.ltSm(_templateObject4());
}, (param)=>{
    let { theme: { mq  }  } = param;
    return mq.ltSm(_templateObject5());
}, (param)=>{
    let { theme: { mq  }  } = param;
    return mq.smOnly(_templateObject6());
}, (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(_templateObject7());
});
const FooterColumnHeader = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    componentId: "sc-dfe43c58-3"
})(_templateObject9(), (param)=>{
    let { theme: { themeColors  }  } = param;
    return (0,tinycolor/* default */.Z)(themeColors.fg).setAlpha(0.5).toRgbString();
});
const FooterColumnList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-dfe43c58-4"
})(_templateObject10());
const FooterColumnItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-dfe43c58-5"
})(_templateObject11());
const LogoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dfe43c58-6"
})(_templateObject13(), (0,padding/* blockW */.g5)(), (param)=>{
    let { theme: { themeColors  }  } = param;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject12(), themeColors.fg);
});
const FooterLogoMobile = (0,styled_components_browser_esm/* default */.ZP)(footer_logo_mobile).withConfig({
    componentId: "sc-dfe43c58-7"
})(_templateObject16(), (param)=>{
    let { theme: { themeColors  }  } = param;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject14(), themeColors.bg);
}, (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(_templateObject15());
});
const FooterLogoDesktop = (0,styled_components_browser_esm/* default */.ZP)(footer_logo_desktop).withConfig({
    componentId: "sc-dfe43c58-8"
})(_templateObject18(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(_templateObject17());
});
const Footer = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterColumn, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterColumnHeader, {
                                children: "Contact"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterColumnList, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterColumnItem, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "mailto: dispatch@graveflex.com",
                                            children: "dispatch@graveflex.com"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterColumnItem, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "tel: +13122100686",
                                            children: "(312) 210-0686"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterColumn, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterColumnHeader, {
                                children: "Follow Us"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterColumnList, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterColumnItem, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://www.instagram.com/graveflex_/?hl=en",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: "Instagram"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterColumnItem, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://www.linkedin.com/company/graveflex/",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: "LinkedIn"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterColumn, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterColumnHeader, {
                                children: "Links"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterColumnList, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterColumnItem, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/projects",
                                            children: "Work"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterColumnItem, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/team",
                                            children: "Team"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterColumn, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterColumnHeader, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                    children: [
                                        "Graveflex",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "All rights reserved"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterColumnList, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterColumnItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                        children: [
                                            "\xa9 ",
                                            new Date().getFullYear()
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LogoContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLogoMobile, {
                        viewBox: "0 0 369 70"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLogoDesktop, {
                        viewBox: "0 0 1391 124"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Footer_Footer = (Footer);

;// CONCATENATED MODULE: ./components/Footer/index.ts


// EXTERNAL MODULE: ./hooks/useLockBodyScroll.tsx
var useLockBodyScroll = __webpack_require__(23127);
// EXTERNAL MODULE: ./context/Contact.tsx
var Contact = __webpack_require__(54328);
// EXTERNAL MODULE: ./node_modules/@react-spring/web/dist/react-spring_web.modern.mjs
var react_spring_web_modern = __webpack_require__(85273);
;// CONCATENATED MODULE: ./public/svg/logo.svg
function logo_extends() { logo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return logo_extends.apply(this, arguments); }

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/react.createElement("svg", logo_extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M118.617 36.603 103.5 51.78 88.323 66.897 73.206 82.074l8.868 8.808L97.19 75.765l6.309 6.309L82.014 103.5 60.588 82.074 90.882 51.78l-8.868-8.868-34.698 34.757v8.809l30.294 30.294h8.808l30.294-30.294v-8.809l-10.713-10.772 6.309-6.309 21.486 21.486-51.78 51.779-51.72-51.78 51.72-51.779 15.177 15.177 8.808-8.868-19.521-19.581H77.61L17.022 77.669v8.809l60.588 60.588h8.808l60.588-60.588v-8.809l-25.83-25.89 6.309-6.308 36.603 36.603-82.074 82.073L0 82.074 82.074 0l36.543 36.603Z",
    fill: props.color,
    stroke: props.color
  }));
};
/* harmony default export */ var logo = (SvgLogo);
;// CONCATENATED MODULE: ./public/svg/menu-closed.svg
function menu_closed_extends() { menu_closed_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return menu_closed_extends.apply(this, arguments); }

var SvgMenuClosed = function SvgMenuClosed(props) {
  return /*#__PURE__*/react.createElement("svg", menu_closed_extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M8 10h24M8 20h24M8 30h24",
    stroke: props.color,
    strokeWidth: 2,
    strokeLinecap: "round",
    fill: props.color
  }));
};
/* harmony default export */ var menu_closed = (SvgMenuClosed);
;// CONCATENATED MODULE: ./components/landing/AppContainer/index.tsx

function AppContainer_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    path {\n      fill: ",
        ";\n    }\n  "
    ]);
    AppContainer_templateObject = function() {
        return data;
    };
    return data;
}
function AppContainer_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 70px;\n  height: 70px;\n\n  ",
        "\n"
    ]);
    AppContainer_templateObject1 = function() {
        return data;
    };
    return data;
}
function AppContainer_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    path {\n      stroke: ",
        ";\n    }\n  "
    ]);
    AppContainer_templateObject2 = function() {
        return data;
    };
    return data;
}
function AppContainer_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    AppContainer_templateObject3 = function() {
        return data;
    };
    return data;
}
function AppContainer_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-top: 70px;\n    "
    ]);
    AppContainer_templateObject4 = function() {
        return data;
    };
    return data;
}
function AppContainer_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  align-self: stretch;\n  min-height: 100svh;\n  grid-template-rows: max-content 1fr max-content;\n  ",
        "\n"
    ]);
    AppContainer_templateObject5 = function() {
        return data;
    };
    return data;
}
function AppContainer_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      position: sticky;\n    "
    ]);
    AppContainer_templateObject6 = function() {
        return data;
    };
    return data;
}
function AppContainer_templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: solid rgba(127, 127, 127, 0.5) 1px;\n  display: flex;\n  position: fixed;\n  top: 0;\n  background: ",
        ";\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  z-index: 3;\n\n  ",
        "\n"
    ]);
    AppContainer_templateObject7 = function() {
        return data;
    };
    return data;
}
function AppContainer_templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: brand;\n"
    ]);
    AppContainer_templateObject8 = function() {
        return data;
    };
    return data;
}
function AppContainer_templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 70px;\n  height: 70px;\n\n  img {\n    object-fit: contain;\n  }\n"
    ]);
    AppContainer_templateObject9 = function() {
        return data;
    };
    return data;
}
function AppContainer_templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n  "
    ]);
    AppContainer_templateObject10 = function() {
        return data;
    };
    return data;
}
function AppContainer_templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 0;\n  border-left: solid rgba(127, 127, 127, 0.5) 1px;\n  background: transparent;\n  outline: 0;\n  width: 70px;\n\n  ",
        "\n"
    ]);
    AppContainer_templateObject11 = function() {
        return data;
    };
    return data;
}
function AppContainer_templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    top: 0;\n  "
    ]);
    AppContainer_templateObject12 = function() {
        return data;
    };
    return data;
}
function AppContainer_templateObject13() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 100%;\n  right: 0;\n  overflow: hidden;\n  display: grid;\n  align-content: center;\n\n  ",
        "\n"
    ]);
    AppContainer_templateObject13 = function() {
        return data;
    };
    return data;
}
function AppContainer_templateObject14() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    transition: unset;\n    transform: translate3d(0, 0, 0);\n    padding: unset;\n    align-items: center;\n    padding: 0 1rem;\n    top: 0;\n    opacity: 1 !important;\n    transform: unset !important;\n  "
    ]);
    AppContainer_templateObject14 = function() {
        return data;
    };
    return data;
}
function AppContainer_templateObject15() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: menu;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n  list-style-type: none;\n  gap: 1rem;\n  padding: 1rem;\n  position: relative;\n  top: -100%;\n\n  ",
        "\n"
    ]);
    AppContainer_templateObject15 = function() {
        return data;
    };
    return data;
}
function AppContainer_templateObject16() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  margin: 0 !important;\n"
    ]);
    AppContainer_templateObject16 = function() {
        return data;
    };
    return data;
}
function AppContainer_templateObject17() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  outline: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: ",
        " !important;\n  font-weight: 500 !important;\n  font-family: SpaceGroteskRegular;\n  font-size: 1rem !important;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    AppContainer_templateObject17 = function() {
        return data;
    };
    return data;
}
function AppContainer_templateObject18() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    AppContainer_templateObject18 = function() {
        return data;
    };
    return data;
}
function _templateObject19() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject19 = function() {
        return data;
    };
    return data;
}
function _templateObject20() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: none;\n    "
    ]);
    _templateObject20 = function() {
        return data;
    };
    return data;
}
function _templateObject21() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none !important;\n  "
    ]);
    _templateObject21 = function() {
        return data;
    };
    return data;
}
function _templateObject22() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  background: ",
        ";\n  z-index: 2;\n  backdrop-filter: blur(2px);\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject22 = function() {
        return data;
    };
    return data;
}
function _templateObject23() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  max-width: 100%;\n"
    ]);
    _templateObject23 = function() {
        return data;
    };
    return data;
}
function _templateObject24() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject24 = function() {
        return data;
    };
    return data;
}











const HeaderLogo = (0,styled_components_browser_esm/* default */.ZP)(logo).withConfig({
    componentId: "sc-cdc92d7d-0"
})(AppContainer_templateObject1(), (param)=>{
    let { theme: { themeColors  }  } = param;
    return (0,styled_components_browser_esm/* css */.iv)(AppContainer_templateObject(), themeColors.fg);
});
const MenuToggle = (0,styled_components_browser_esm/* default */.ZP)(menu_closed).withConfig({
    componentId: "sc-cdc92d7d-1"
})(AppContainer_templateObject3(), (param)=>{
    let { theme: { themeColors  }  } = param;
    return (0,styled_components_browser_esm/* css */.iv)(AppContainer_templateObject2(), themeColors.fg);
});
const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cdc92d7d-2"
})(AppContainer_templateObject5(), (param)=>{
    let { $pad  } = param;
    return $pad && (0,styled_components_browser_esm/* css */.iv)(AppContainer_templateObject4());
});
const Header = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-cdc92d7d-3"
})(AppContainer_templateObject7(), (param)=>{
    let { theme: { themeColors  }  } = param;
    return themeColors.bg;
}, (param)=>{
    let { $sticky  } = param;
    return $sticky && (0,styled_components_browser_esm/* css */.iv)(AppContainer_templateObject6());
});
const BrandContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cdc92d7d-4"
})(AppContainer_templateObject8());
const Brand = (0,styled_components_browser_esm/* default */.ZP)((link_default())).withConfig({
    componentId: "sc-cdc92d7d-5"
})(AppContainer_templateObject9());
const HeaderMenuToggle = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-cdc92d7d-6"
})(AppContainer_templateObject11(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(AppContainer_templateObject10());
});
const HeaderMenuContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cdc92d7d-7"
})(AppContainer_templateObject13(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(AppContainer_templateObject12());
});
const HeaderMenu = (0,styled_components_browser_esm/* default */.ZP)(react_spring_web_modern/* animated.ul */.q.ul).withConfig({
    componentId: "sc-cdc92d7d-8"
})(AppContainer_templateObject15(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(AppContainer_templateObject14());
});
const HeaderMenuItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-cdc92d7d-9"
})(AppContainer_templateObject16());
const menuLinkCss = (0,styled_components_browser_esm/* css */.iv)(AppContainer_templateObject17(), (param)=>{
    let { theme: { themeColors  }  } = param;
    return themeColors.fg;
}, (param)=>{
    let { theme: { themeColors  }  } = param;
    return themeColors.fg;
});
const HeaderMenuLink = (0,styled_components_browser_esm/* default */.ZP)((link_default())).withConfig({
    componentId: "sc-cdc92d7d-10"
})(AppContainer_templateObject18(), menuLinkCss);
const HeaderMenuButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-cdc92d7d-11"
})(_templateObject19(), menuLinkCss);
const HeaderScreen = (0,styled_components_browser_esm/* default */.ZP)(react_spring_web_modern/* animated.div */.q.div).withConfig({
    componentId: "sc-cdc92d7d-12"
})(_templateObject22(), (param)=>{
    let { theme: { themeColors  }  } = param;
    return (0,tinycolor/* default */.Z)(themeColors.bg).setAlpha(0.7).toRgbString();
}, (param)=>{
    let { $open  } = param;
    return $open && (0,styled_components_browser_esm/* css */.iv)(_templateObject20());
}, (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(_templateObject21());
});
const Main = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
    componentId: "sc-cdc92d7d-13"
})(_templateObject23());
const AppContainer = (param)=>{
    let { children , className , pad =true , sticky =false , showFooter =true  } = param;
    const [menuOpen, setMenuOpen] = (0,react.useState)(false);
    const screenOpacity = (0,react_spring_web_modern/* useSpringValue */.zk)(0);
    const { contactModalOpen , showContactModal  } = (0,Contact/* useContactModal */.s)();
    (0,useLockBodyScroll/* default */.Z)(menuOpen || contactModalOpen);
    (0,react.useEffect)(()=>{
        setMenuOpen(false);
    }, []);
    const toggleMenu = (0,react.useCallback)(()=>{
        setMenuOpen(!menuOpen);
        screenOpacity.start(menuOpen ? 0 : 1);
    }, [
        screenOpacity,
        menuOpen
    ]);
    // close menu if window is resized past mobile
    (0,react.useEffect)(()=>{
        const handleResize = ()=>{
            if (window.innerWidth > 768) {
                setMenuOpen(false);
                screenOpacity.start(0);
            }
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, [
        screenOpacity
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        $pad: pad,
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                $sticky: sticky,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Brand, {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLogo, {
                                width: 70,
                                height: 70,
                                viewBox: "0 0 165 165"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuToggle, {
                        onClick: toggleMenu,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuToggle, {
                            width: 40,
                            height: 40,
                            viewBox: "0 0 40 40"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderMenu, {
                            style: {
                                opacity: screenOpacity,
                                transform: screenOpacity.to((val)=>"translate3d(0, ".concat(val * 100, "%, 0)"))
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuLink, {
                                        href: "/projects",
                                        children: "Work"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuLink, {
                                        href: "/team",
                                        children: "Team"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenuButton, {
                                        onClick: showContactModal,
                                        children: "Contact"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Main, {
                children: children
            }),
            showFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Footer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderScreen, {
                onClick: toggleMenu,
                style: {
                    opacity: screenOpacity,
                    display: screenOpacity.to((val)=>val > 0 ? "block" : "none")
                },
                $open: menuOpen
            })
        ]
    });
};
/* harmony default export */ var landing_AppContainer = ((0,styled_components_browser_esm/* default */.ZP)(AppContainer).withConfig({
    componentId: "sc-cdc92d7d-14"
})(_templateObject24()));

// EXTERNAL MODULE: ./node_modules/@react-three/fiber/dist/index-673ef987.esm.js + 1 modules
var index_673ef987_esm = __webpack_require__(29544);
// EXTERNAL MODULE: ./node_modules/@react-three/fiber/dist/react-three-fiber.esm.js + 3 modules
var react_three_fiber_esm = __webpack_require__(49606);
// EXTERNAL MODULE: ./node_modules/@react-spring/three/dist/react-spring_three.modern.mjs
var react_spring_three_modern = __webpack_require__(1900);
// EXTERNAL MODULE: ./node_modules/@react-three/drei/core/useGLTF.js + 4 modules
var useGLTF = __webpack_require__(74664);
// EXTERNAL MODULE: ./node_modules/@react-three/drei/core/useProgress.js
var useProgress = __webpack_require__(29521);
// EXTERNAL MODULE: ./node_modules/maath/easing/dist/maath-easing.esm.js + 5 modules
var maath_easing_esm = __webpack_require__(42102);
// EXTERNAL MODULE: ./node_modules/three/build/three.module.js
var three_module = __webpack_require__(99477);
;// CONCATENATED MODULE: ./hooks/useElementScrollPercentage.ts


// returns a value between 0 and 1 that represents the amount of an element that has been scrolled
// through. when the `startAtTop` option is `true`, the percentage will start when the element has
// reached the top of the page. otherwise the percentage starts when the element scrolls in from the
// bottom of the page. the percentage will reach 1 when the page has scrolled past the element
const useElementScrollPercentage = (param)=>{
    let { startAtTop , inertia , springConfig ={}  } = param;
    const visible = (0,react_spring_web_modern/* useSpring */.q_)({
        from: {
            value: false
        }
    });
    const [onScreen, setOnScreen] = (0,react.useState)(false);
    const ref = (0,react.useRef)();
    const getScrollPercentage = (0,react.useCallback)(()=>{
        if (!ref.current) {
            return 0;
        }
        const { top , bottom  } = ref.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const startY = startAtTop ? top + windowHeight : top;
        let elementHeight = bottom - top;
        if (!startAtTop) {
            elementHeight += windowHeight;
        }
        // the percentage of the element that is visible
        let percentage = (windowHeight - startY) / elementHeight;
        // if the element is above the viewport, the percentage will be negative
        if (percentage < 0) {
            percentage = 0;
        }
        // if the element is below the viewport, the percentage will be greater than 1
        if (percentage > 1) {
            percentage = 1;
        }
        return percentage;
    }, [
        startAtTop
    ]);
    const scrollPercentage = (0,react_spring_web_modern/* useSpring */.q_)({
        from: {
            value: getScrollPercentage()
        },
        config: springConfig
    });
    (0,react.useEffect)(()=>{
        let observer;
        if (ref.current) {
            // Create a new Intersection Observer
            observer = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    setOnScreen(entry.isIntersecting);
                });
            });
            observer.observe(ref.current);
        }
        const handleScroll = ()=>{
            const percentage = getScrollPercentage();
            if (typeof percentage === "undefined") {
                return;
            }
            visible.value.start(percentage > 0);
            if (inertia) {
                scrollPercentage.value.start(percentage);
            } else {
                scrollPercentage.value.set(percentage);
            }
        };
        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleScroll);
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    }, [
        ref,
        startAtTop,
        scrollPercentage,
        inertia,
        onScreen,
        visible,
        getScrollPercentage
    ]);
    return {
        ref: ref,
        scrollPercentage,
        visible,
        onScreen
    };
};

;// CONCATENATED MODULE: ./components/landing/Tree/index.tsx

function Tree_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  height: 100lvh;\n  position: sticky;\n  width: 100%;\n  align-content: stretch;\n  justify-content: stretch;\n  top: 0;\n"
    ]);
    Tree_templateObject = function() {
        return data;
    };
    return data;
}
function Tree_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border: dotted blue 4px;\n\n      ",
        " {\n        border: dotted green 4px;\n      }\n    "
    ]);
    Tree_templateObject1 = function() {
        return data;
    };
    return data;
}
function Tree_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 300lvh;\n  width: 100%;\n  max-width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  ",
        "\n"
    ]);
    Tree_templateObject2 = function() {
        return data;
    };
    return data;
}










react_spring_three_modern/* Globals.assign */.OH.assign({
    frameLoop: "always"
});
const Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bc204fc5-0"
})(Tree_templateObject());
const Tree_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bc204fc5-1"
})(Tree_templateObject2(), (param)=>{
    let { $debug  } = param;
    return $debug && (0,styled_components_browser_esm/* css */.iv)(Tree_templateObject1(), Content);
});
const Scene = (param)=>{
    let { progress  } = param;
    const gltf = (0,useGLTF/* useGLTF */.L)("/objects/tree.glb");
    const ref = (0,react.useRef)();
    (0,index_673ef987_esm.A)((state, dt)=>{
        // state.camera.lookAt(0, 0, 0);
        const y = progress.value.to([
            0,
            1
        ], [
            28.3,
            5
        ]).get();
        maath_easing_esm/* damp3 */.G0(state.camera.position, [
            1.332,
            y,
            10.167
        ], 0.25, dt);
        if (ref.current) {
            const r = progress.value.to([
                0,
                1
            ], [
                0.2,
                0.7
            ]).get();
            maath_easing_esm/* dampE */.Tp(ref.current.rotation, [
                0,
                Math.PI * r,
                0
            ], 0.25, dt);
            // spin the disco ball
            gltf.scenes[0].children[2].rotation.y += 0.001;
        }
    });
    (0,react.useEffect)(()=>{
        const material = new three_module.MeshStandardMaterial({
            color: 0xffffff,
            roughness: 0,
            metalness: 0.75 // set the metalness of the material to 1 for a metallic look
        });
        gltf.scenes[0].children[2].material = material;
    }, [
        gltf.scenes
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("primitive", {
        object: gltf.scene,
        ref: ref,
        rotation: [
            0,
            0.6283185307179586,
            0
        ]
    });
};
const TreeSceneContainer = (param)=>{
    let { scrollPercentage , play  } = param;
    const loadProgress = (0,useProgress/* useProgress */.S)();
    const lightValue = (0,react_spring_web_modern/* useSpring */.q_)({
        from: {
            value: 0
        }
    });
    (0,react.useEffect)(()=>{
        if (loadProgress.progress === 100) {
            lightValue.value.start(1);
        }
    }, [
        loadProgress,
        lightValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_three_fiber_esm/* Canvas */.Xz, {
            frameloop: play ? "always" : "never",
            camera: {
                position: [
                    1.332,
                    28.3,
                    10.167
                ],
                rotation: [
                    -0.393,
                    -0.087,
                    -0.032
                ]
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern/* animated.pointLight */.q.pointLight, {
                    intensity: lightValue.value.to((val)=>230 * val),
                    position: [
                        0,
                        30,
                        30
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern/* animated.pointLight */.q.pointLight, {
                    intensity: lightValue.value.to((val)=>1500 * val),
                    position: [
                        -10,
                        0,
                        -30
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Scene, {
                    progress: scrollPercentage
                })
            ]
        })
    });
};
const Tree = (param)=>{
    let { debug  } = param;
    const { ref , scrollPercentage , onScreen  } = useElementScrollPercentage({
        startAtTop: true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tree_Container, {
        ref: ref,
        $debug: debug,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
            children: !debug && /*#__PURE__*/ (0,jsx_runtime.jsx)(TreeSceneContainer, {
                scrollPercentage: scrollPercentage,
                play: onScreen
            })
        })
    });
};
/* harmony default export */ var landing_Tree = (Tree);

;// CONCATENATED MODULE: ./components/FadeInText/index.tsx

function FadeInText_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      font-size: 5vw;\n    "
    ]);
    FadeInText_templateObject = function() {
        return data;
    };
    return data;
}
function FadeInText_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transition: opacity 0.2s, filter 2s;\n\n  ",
        "\n"
    ]);
    FadeInText_templateObject1 = function() {
        return data;
    };
    return data;
}




const Letter = (0,styled_components_browser_esm/* default */.ZP)(react_spring_web_modern/* animated.span */.q.span).withConfig({
    componentId: "sc-cbe7dc-0"
})(FadeInText_templateObject1(), (param)=>{
    let { $isSpace  } = param;
    return $isSpace && (0,styled_components_browser_esm/* css */.iv)(FadeInText_templateObject());
});
const FadeInText = (param)=>{
    let { progress , children  } = param;
    const letters = react.Children.toArray(children).map((child)=>{
        if (typeof child === "string") {
            return child.split("");
        }
        return child;
    }).flat();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: letters.map((letter, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Letter, {
                $isElement: typeof letter !== "string",
                $isSpace: letter === " ",
                style: {
                    opacity: progress.value.to((val)=>index === 0 || val >= (index + 1) / letters.length ? 1 : 0.2),
                    filter: progress.value.to((val)=>"grayscale(".concat(val >= (index + 1) / letters.length ? 0 : 1, ")"))
                },
                children: letter
            }, index))
    });
};
/* harmony default export */ var components_FadeInText = (FadeInText);

;// CONCATENATED MODULE: ./hooks/useIsVisible.ts

const useIsVisible = ()=>{
    const ref = (0,react.useRef)(null);
    const [isVisible, setIsVisible] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        let observer;
        if (ref.current) {
            // Create a new Intersection Observer
            const observer1 = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    setIsVisible(entry.isIntersecting);
                });
            });
            observer1.observe(ref.current);
        }
        return ()=>{
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    }, []);
    return {
        ref,
        isVisible
    };
};
/* harmony default export */ var hooks_useIsVisible = (useIsVisible);

;// CONCATENATED MODULE: ./components/landing/Intro/index.tsx

function Intro_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border: dotted red 2px;\n    "
    ]);
    Intro_templateObject = function() {
        return data;
    };
    return data;
}
function Intro_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: 200lvh;\n  padding: 0 2rem;\n\n  ",
        "\n"
    ]);
    Intro_templateObject1 = function() {
        return data;
    };
    return data;
}
function Intro_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n  "
    ]);
    Intro_templateObject2 = function() {
        return data;
    };
    return data;
}
function Intro_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Intro_templateObject3 = function() {
        return data;
    };
    return data;
}
function Intro_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: unset;\n  "
    ]);
    Intro_templateObject4 = function() {
        return data;
    };
    return data;
}
function Intro_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  ",
        "\n"
    ]);
    Intro_templateObject5 = function() {
        return data;
    };
    return data;
}
function Intro_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  height: 80lvh;\n"
    ]);
    Intro_templateObject6 = function() {
        return data;
    };
    return data;
}
function Intro_templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: clamp(4rem, 7vw, 8rem);\n  "
    ]);
    Intro_templateObject7 = function() {
        return data;
    };
    return data;
}
function Intro_templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border: dotted pink 4px;\n    "
    ]);
    Intro_templateObject8 = function() {
        return data;
    };
    return data;
}
function Intro_templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 8vw;\n  border-radius: 16rem;\n  display: inline-block;\n  position: relative;\n  overflow: hidden;\n  aspect-ratio: 1.7/1;\n  background: rgba(255, 255, 255, 0.5);\n  position: relative;\n  top: 0.7vw;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    Intro_templateObject9 = function() {
        return data;
    };
    return data;
}
function Intro_templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border: dotted blanchedalmond 4px;\n    "
    ]);
    Intro_templateObject10 = function() {
        return data;
    };
    return data;
}
function Intro_templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: center;\n    font-size: clamp(4rem, 7vw, 8rem);\n  "
    ]);
    Intro_templateObject11 = function() {
        return data;
    };
    return data;
}
function Intro_templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: sticky;\n  top: 0;\n  width: 100%;\n  height: 100lvh;\n  display: grid;\n  align-items: center;\n  justify-content: center;\n  font-family: SpaceGroteskLight;\n  font-weight: 300;\n  font-size: 10vw;\n  min-width: 100%;\n  line-height: 1.05;\n\n  ",
        "\n\n  ",
        " {\n    ",
        " {\n      opacity: 1 !important;\n    }\n  }\n\n  ",
        "\n"
    ]);
    Intro_templateObject12 = function() {
        return data;
    };
    return data;
}
function Intro_templateObject13() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  opacity: 0;\n  transition: opacity 0.2s;\n\n  &.active {\n    opacity: 1;\n  }\n"
    ]);
    Intro_templateObject13 = function() {
        return data;
    };
    return data;
}






const IntroTextContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-e84463ae-0"
})(Intro_templateObject1(), (param)=>{
    let { $debug  } = param;
    return $debug && (0,styled_components_browser_esm/* css */.iv)(Intro_templateObject());
});
const MobileBr = styled_components_browser_esm/* default.br.withConfig */.ZP.br.withConfig({
    componentId: "sc-e84463ae-1"
})(Intro_templateObject3(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(Intro_templateObject2());
});
const DesktopBr = styled_components_browser_esm/* default.br.withConfig */.ZP.br.withConfig({
    componentId: "sc-e84463ae-2"
})(Intro_templateObject5(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(Intro_templateObject4());
});
const IntroTextRevealProgress = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-e84463ae-3"
})(Intro_templateObject6());
const VideoPill = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e84463ae-4"
})(Intro_templateObject9(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(Intro_templateObject7());
}, (param)=>{
    let { $debug  } = param;
    return $debug && (0,styled_components_browser_esm/* css */.iv)(Intro_templateObject8());
});
const IntroText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e84463ae-5"
})(Intro_templateObject12(), (param)=>{
    let { $debug  } = param;
    return $debug && (0,styled_components_browser_esm/* css */.iv)(Intro_templateObject10());
}, Letter, VideoPill, (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(Intro_templateObject11());
});
const Video = styled_components_browser_esm/* default.video.withConfig */.ZP.video.withConfig({
    componentId: "sc-e84463ae-6"
})(Intro_templateObject13());
const VPill = (param)=>{
    let { src , poster , debug , ...props } = param;
    const { ref  } = hooks_useIsVisible();
    const videoRef = (0,react.useRef)(null);
    const updateVisibility = (0,react.useCallback)(()=>{
        var ref1, ref2, ref3;
        const opacity = parseFloat(((ref1 = ref.current) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.parentElement) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.style) === null || ref3 === void 0 ? void 0 : ref3.opacity) || "0.2");
        if (opacity > 0.2) {
            var ref4;
            (ref4 = videoRef.current) === null || ref4 === void 0 ? void 0 : ref4.classList.add("active");
        } else {
            var ref5;
            (ref5 = videoRef.current) === null || ref5 === void 0 ? void 0 : ref5.classList.remove("active");
        }
    }, [
        ref
    ]);
    (0,react.useEffect)(()=>{
        var ref1;
        const config = {
            attributes: true,
            attributeFilter: [
                "style"
            ]
        };
        const observer = new MutationObserver((mutations)=>{
            mutations.forEach((mutation)=>{
                if (mutation.type === "attributes" && mutation.attributeName === "style") {
                    updateVisibility();
                }
            });
        });
        if ((ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.parentElement) {
            observer.observe(ref.current.parentElement, config);
            updateVisibility();
        }
        return ()=>{
            observer.disconnect();
        };
    }, [
        ref,
        updateVisibility
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPill, {
        $debug: debug,
        ref: ref,
        ...props,
        children: !debug && /*#__PURE__*/ (0,jsx_runtime.jsx)(Video, {
            autoPlay: true,
            muted: true,
            loop: true,
            controls: false,
            playsInline: true,
            poster: poster,
            ref: videoRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                src: src,
                type: "video/mp4"
            })
        })
    });
};
const Intro = (param)=>{
    let { debug  } = param;
    const { ref: introRef , scrollPercentage: introScrollPercentage  } = useElementScrollPercentage({
        startAtTop: true,
        inertia: true,
        springConfig: {
            tension: 0
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(IntroTextContainer, {
        $debug: debug,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroTextRevealProgress, {
                ref: introRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroText, {
                $debug: debug,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_FadeInText, {
                    progress: introScrollPercentage,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Graveflex"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileBr, {}),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VPill, {
                            debug: debug,
                            src: "/videos/video-blob-1.mp4",
                            poster: "/images/blob-1-poster.png"
                        }),
                        " ",
                        "is a ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileBr, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopBr, {}),
                        "creative",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VPill, {
                            debug: debug,
                            src: "/videos/video-blob-2.mp4",
                            poster: "/images/blob-2-poster.png"
                        }),
                        " ",
                        "technology",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileBr, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopBr, {}),
                        " agency",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileBr, {}),
                        " in",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VPill, {
                            debug: debug,
                            src: "/videos/video-blob-3.mp4",
                            poster: "/images/blob-3-poster.png"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileBr, {}),
                        " Chicago"
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var landing_Intro = (Intro);

;// CONCATENATED MODULE: ./components/landing/WhatWeDo/index.tsx

function WhatWeDo_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: min(65vw, 1050px);\n  "
    ]);
    WhatWeDo_templateObject = function() {
        return data;
    };
    return data;
}
function WhatWeDo_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  top: 0;\n  height: 120lvh;\n  display: grid;\n  align-items: start;\n  padding: 2rem;\n  max-width: 600px;\n  margin: -10lvh auto 0;\n\n  ",
        "\n"
    ]);
    WhatWeDo_templateObject1 = function() {
        return data;
    };
    return data;
}
function WhatWeDo_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  border-color: purple;\n  width: 100%;\n  height: 100lvh;\n  top: 0;\n  pointer-events: none;\n  z-index: 0;\n"
    ]);
    WhatWeDo_templateObject2 = function() {
        return data;
    };
    return data;
}
function WhatWeDo_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: sticky;\n  top: 0;\n  width: 100%;\n  height: 100lvh;\n  margin-top: -50lvh;\n  display: grid;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  z-index: 0;\n"
    ]);
    WhatWeDo_templateObject3 = function() {
        return data;
    };
    return data;
}
function WhatWeDo_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #666;\n  font-weight: 700;\n  font-size: 1.125rem;\n  text-align: center;\n  text-transform: uppercase;\n  font-family: SpaceMonoRegular;\n"
    ]);
    WhatWeDo_templateObject4 = function() {
        return data;
    };
    return data;
}
function WhatWeDo_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: clamp(2.5rem, 3vw, 3.25rem);\n  "
    ]);
    WhatWeDo_templateObject5 = function() {
        return data;
    };
    return data;
}
function WhatWeDo_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: transparent;\n  font-size: 1.875rem;\n  line-height: 1.2;\n  text-align: center;\n  font-family: SpaceGroteskLight;\n  background-color: transparent;\n  background-clip: text;\n\n  ",
        "\n"
    ]);
    WhatWeDo_templateObject6 = function() {
        return data;
    };
    return data;
}





const WhatWeDoContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-17e0fd6b-0"
})(WhatWeDo_templateObject1(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(WhatWeDo_templateObject());
});
const WhatWeDoMaskPosition = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-17e0fd6b-1"
})(WhatWeDo_templateObject2());
const WhatWeDoInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-17e0fd6b-2"
})(WhatWeDo_templateObject3());
const WhatWeDoEyebrow = (0,styled_components_browser_esm/* default */.ZP)(react_spring_web_modern/* animated.h3 */.q.h3).withConfig({
    componentId: "sc-17e0fd6b-3"
})(WhatWeDo_templateObject4());
const WhatWeDoText = (0,styled_components_browser_esm/* default */.ZP)(react_spring_web_modern/* animated.p */.q.p).withConfig({
    componentId: "sc-17e0fd6b-4"
})(WhatWeDo_templateObject6(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(WhatWeDo_templateObject5());
});
const WhatWeDo = ()=>{
    const { ref: whatWeDoRef , scrollPercentage: whatWeDoScrollPercentage  } = useElementScrollPercentage({
        startAtTop: false
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhatWeDoContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhatWeDoInner, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatWeDoEyebrow, {
                        style: {
                            opacity: whatWeDoScrollPercentage.value.to([
                                0.45,
                                0.55
                            ], [
                                0,
                                1
                            ], "clamp")
                        },
                        children: "What We Do"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatWeDoText, {
                        style: {
                            pointerEvents: whatWeDoScrollPercentage.value.to((val)=>val > 0 ? "all" : "none"),
                            backgroundImage: whatWeDoScrollPercentage.value.to((val)=>"radial-gradient(circle at 50% ".concat((-0.25 + (1 - val)) * 400, "vh, rgb(252, 252, 252) 4.25758vh, rgb(252, 252, 252) 56.2879vh, rgb(116, 116, 116) 89.5455vh, rgba(0, 0, 0, 0) 119.546vh)"))
                        },
                        children: "We partner with everyone from emerging startups to multinational brands to efficiently solve big (& small) problems with design and code."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatWeDoMaskPosition, {
                ref: whatWeDoRef
            })
        ]
    });
};
/* harmony default export */ var landing_WhatWeDo = (WhatWeDo);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/landing/CTAButton.tsx

function CTAButton_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 1.25rem 4.25rem;\n    font-size: 1.5rem;\n  "
    ]);
    CTAButton_templateObject = function() {
        return data;
    };
    return data;
}
function CTAButton_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #fff;\n  color: #000;\n  border: none;\n  outline: none;\n  font-size: 1.125rem;\n  letter-spacing: -0.075rem;\n  font-weight: 700;\n  border: solid #000 1px;\n  border-radius: 5.875rem;\n  padding: 1rem 3.5rem;\n  transition: background-color 0.2s;\n  font-family: SpaceGroteskLight;\n  white-space: nowrap;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.8);\n  }\n\n  &:focus {\n    background: rgba(255, 255, 255, 0.7);\n  }\n\n  ",
        "\n"
    ]);
    CTAButton_templateObject1 = function() {
        return data;
    };
    return data;
}


const CTAButton = (0,styled_components_browser_esm/* default */.ZP)(react_spring_web_modern/* animated.button */.q.button).withConfig({
    componentId: "sc-a9ab2836-0"
})(CTAButton_templateObject1(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(CTAButton_templateObject());
});
/* harmony default export */ var landing_CTAButton = (CTAButton);

;// CONCATENATED MODULE: ./components/landing/Slides/index.tsx

function Slides_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 20lvh;\n  border-radius: 1rem;\n  aspect-ratio: 9/6;\n  position: relative;\n  overflow: hidden;\n\n  img,\n  video {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    pointer-events: none;\n  }\n"
    ]);
    Slides_templateObject = function() {
        return data;
    };
    return data;
}
function Slides_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        border: dotted blanchedalmond 4px;\n      }\n    "
    ]);
    Slides_templateObject1 = function() {
        return data;
    };
    return data;
}
function Slides_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  position: relative;\n  gap: 0.5rem;\n  overflow: hidden;\n  max-width: 100vw;\n  width: 100%;\n\n  ",
        "\n"
    ]);
    Slides_templateObject2 = function() {
        return data;
    };
    return data;
}
function Slides_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      right: unset;\n    "
    ]);
    Slides_templateObject3 = function() {
        return data;
    };
    return data;
}
function Slides_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n        right: unset;\n      "
    ]);
    Slides_templateObject4 = function() {
        return data;
    };
    return data;
}
function Slides_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n  "
    ]);
    Slides_templateObject5 = function() {
        return data;
    };
    return data;
}
function Slides_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: no-wrap;\n  position: relative;\n  gap: 0.5rem;\n  right: calc(100% - 100vw);\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    Slides_templateObject6 = function() {
        return data;
    };
    return data;
}
function Slides_templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate3d(-50%, -50%, 0);\n"
    ]);
    Slides_templateObject7 = function() {
        return data;
    };
    return data;
}









const track1 = [
    {
        src: "/videos/thumbnail-01.mp4",
        type: "video",
        alt: "Lapto in the bushes"
    },
    {
        src: "/images/thumbnail-02.jpg",
        type: "image",
        alt: "View from the fire escape of the Chicago office"
    },
    {
        src: "/videos/thumbnail-03.mp4",
        type: "video",
        alt: "Goodfriend on the floor"
    },
    {
        src: "/images/thumbnail-04.jpg",
        type: "image",
        alt: "Refract black prism"
    },
    {
        src: "/images/thumbnail-05.jpg",
        type: "image",
        alt: "Silhouette doing important science"
    }
];
const track2 = [
    {
        src: "/images/thumbnail-06.jpg",
        type: "image",
        alt: "Starface on a mobile device"
    },
    {
        src: "/videos/thumbnail-07.mp4",
        type: "video",
        alt: "Myopic books logo"
    },
    {
        src: "/images/thumbnail-08.jpg",
        type: "image",
        alt: "The old Chicago office"
    },
    {
        src: "/images/thumbnail-09.jpg",
        type: "image",
        alt: "#Halfthestory on a mobile device"
    },
    {
        src: "/images/thumbnail-10.jpg",
        type: "image",
        alt: "Interior view of the Chicago office"
    }
];
const track3 = [
    {
        src: "/images/thumbnail-11.jpg",
        type: "image",
        alt: "Our video production camera"
    },
    {
        src: "/videos/thumbnail-12.mp4",
        type: "video",
        alt: "Stacked cupbes"
    },
    {
        src: "/images/thumbnail-13.jpg",
        type: "image",
        alt: "Interior view of the Chicago office"
    },
    {
        src: "/images/thumbnail-14.jpg",
        type: "image",
        alt: "Laptop displaying a graphic we made for Plume"
    },
    {
        src: "/images/thumbnail-15.jpg",
        type: "image",
        alt: "Action shot of the Chicago conference room"
    }
];
const Slide = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-75b8f859-0"
})(Slides_templateObject());
const SlidesContainer = (0,styled_components_browser_esm/* default */.ZP)(react_spring_web_modern/* animated.section */.q.section).withConfig({
    componentId: "sc-75b8f859-1"
})(Slides_templateObject2(), (param)=>{
    let { $debug  } = param;
    return $debug && (0,styled_components_browser_esm/* css */.iv)(Slides_templateObject1(), Slide);
});
const SlideTrack = (0,styled_components_browser_esm/* default */.ZP)(react_spring_web_modern/* animated.div */.q.div).withConfig({
    componentId: "sc-75b8f859-2"
})(Slides_templateObject6(), (param)=>{
    let { $rtl  } = param;
    return $rtl && (0,styled_components_browser_esm/* css */.iv)(Slides_templateObject3());
}, (param)=>{
    let { $rtl , theme: { mq  }  } = param;
    return mq.md(Slides_templateObject5(), $rtl && (0,styled_components_browser_esm/* css */.iv)(Slides_templateObject4()));
});
const SCTAButton = (0,styled_components_browser_esm/* default */.ZP)(landing_CTAButton).withConfig({
    componentId: "sc-75b8f859-3"
})(Slides_templateObject7());
const Slides_Video = (param)=>{
    let { src , alt  } = param;
    const { ref , isVisible  } = hooks_useIsVisible();
    (0,react.useEffect)(()=>{
        if (ref.current) {
            if (isVisible) {
                ref.current.play();
            } else {
                ref.current.pause();
            }
        }
    }, [
        isVisible,
        ref
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
        autoPlay: true,
        muted: true,
        loop: true,
        controls: false,
        playsInline: true,
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                src: src,
                type: "video/mp4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: alt
            })
        ]
    });
};
const Slides = (param)=>{
    let { debug  } = param;
    const { ref: slidesRef , scrollPercentage: slidesScrollPercentage  } = useElementScrollPercentage({
        startAtTop: false,
        inertia: false
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SlidesContainer, {
        $debug: debug,
        ref: slidesRef,
        style: {
            opacity: slidesScrollPercentage.value.to([
                0,
                0.3
            ], [
                0,
                1
            ], "clamp")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideTrack, {
                style: {
                    transform: slidesScrollPercentage.value.to((val)=>"translate3d(".concat(val * 100 * 0.1, "%, 0, 0)"))
                },
                children: [
                    ...track1,
                    ...track1
                ].map((asset, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Slide, {
                        children: !debug && (asset.type === "video" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Slides_Video, {
                            src: asset.src,
                            alt: asset.alt
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            priority: true,
                            src: asset.src,
                            width: 640,
                            height: 480,
                            alt: asset.alt
                        }))
                    }, "".concat(asset.src, "-").concat(i)))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideTrack, {
                $rtl: true,
                style: {
                    transform: slidesScrollPercentage.value.to((val)=>"translate3d(-".concat(val * 100 * 0.1, "%, 0, 0)"))
                },
                children: [
                    ...track2,
                    ...track2
                ].map((asset, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Slide, {
                        children: !debug && (asset.type === "video" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Slides_Video, {
                            src: asset.src,
                            alt: asset.alt
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            priority: true,
                            src: asset.src,
                            width: 640,
                            height: 480,
                            alt: asset.alt
                        }))
                    }, "".concat(asset.src, "-").concat(i)))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideTrack, {
                style: {
                    transform: slidesScrollPercentage.value.to((val)=>"translate3d(".concat(val * 100 * 0.1, "%, 0, 0)"))
                },
                children: [
                    ...track3,
                    ...track3
                ].map((asset, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Slide, {
                        children: !debug && (asset.type === "video" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Slides_Video, {
                            src: asset.src,
                            alt: asset.alt
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            priority: true,
                            src: asset.src,
                            width: 640,
                            height: 480,
                            alt: asset.alt
                        }))
                    }, "".concat(asset.src, "-").concat(i)))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/projects",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SCTAButton, {
                    children: "See Our Work"
                })
            })
        ]
    });
};
/* harmony default export */ var landing_Slides = (Slides);

;// CONCATENATED MODULE: ./components/landing/SelectedClients/svg/figo.svg
function figo_extends() { figo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return figo_extends.apply(this, arguments); }

var SvgFigo = function SvgFigo(props) {
  return /*#__PURE__*/react.createElement("svg", figo_extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/react.createElement("g", {
    opacity: 0.5,
    fill: "#fff"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M26.014 1.308c.006-.304-.087-.364-.373-.364C18.605.952 11.569.95 4.533.951 3.046.95 1.56.96.074.965L0 .894v26.03c1.436-.002 2.872-.014 4.308 0 .285.001.346-.078.345-.353-.01-2.886.002-5.772-.015-8.658-.003-.348.103-.397.413-.397 5.523.01 11.046.007 16.57.006.135 0 .27-.016.405-.024.096-.017.104-.09.104-.166 0-1.21 0-2.419-.004-3.627 0-.09.027-.213-.13-.213-.124-.003-.247-.01-.37-.01-5.538 0-11.075-.003-16.613.005-.285 0-.375-.062-.374-.36.012-2.628.012-5.255 0-7.881 0-.276.062-.352.345-.35 1.896.015 3.791.008 5.686.008 4.98 0 9.96-.003 14.94.008.328.001.413-.076.405-.409a76.208 76.208 0 0 1-.001-3.196ZM95.176 0H94.06a.546.546 0 0 1 .002.07l1.113-.013a.059.059 0 0 0 0-.056Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/react.createElement("path", {
    d: "m111.422 12.192.059.584c-.023.375-.012.753-.018 1.129.006-.377-.006-.754.018-1.13l-.059-.583-.019-.45c.075-.058.042-.098-.023-.134a45.84 45.84 0 0 0-.056-.385c.081-.067.045-.111-.029-.149-.014-.034-.035-.066-.041-.102-.508-2.672-1.793-4.907-3.813-6.713-2.478-2.216-5.455-3.334-8.683-3.879-1.185-.2-2.382-.286-3.581-.324L94.063.07c-2.468.044-4.879.418-7.201 1.27-2.521.926-4.733 2.314-6.416 4.444-1.879 2.378-2.675 5.109-2.61 8.127.045 2.006.49 3.902 1.422 5.67 1.839 3.494 4.784 5.665 8.436 6.965 2.13.758 4.337 1.088 6.591 1.136.022.05.058.076.115.066 0 .961 0 1.922-.002 2.884-.084-.017-.17-.054-.253-.046-1.324.126-2.653.21-3.947.561-.23.062-.308.145-.302.37.043 1.582-.094 3.17.083 4.749.093.835.274 1.66.637 2.426.999 2.1 2.555 3.74 4.31 5.218.195.164.31.076.443-.042 1.116-.998 2.188-2.037 3.097-3.237 1.098-1.448 1.766-3.06 1.829-4.88.049-1.41.009-2.824.018-4.236.002-.228-.081-.314-.304-.373-.766-.202-1.547-.312-2.329-.413-.546-.071-1.097-.135-1.652-.096-.008-.123-.022-.246-.022-.369-.002-2.168-.005-4.337.005-6.506.002-.287-.058-.364-.369-.348-2.656.135-5.24-.23-7.68-1.323-3.304-1.482-5.53-3.843-5.9-7.604-.207-2.126.21-4.12 1.475-5.883 1.39-1.94 3.365-3.014 5.588-3.696 2.03-.623 4.117-.82 6.234-.763 2.08.057 4.118.342 6.054 1.14 3.131 1.29 5.262 3.474 5.775 6.918.523 3.506-.593 6.427-3.461 8.588-1.724 1.3-3.712 1.996-5.823 2.354-.303.051-.408.143-.402.464.022 1.202.015 2.404.004 3.605-.002.235.058.299.296.265 2.85-.414 5.542-1.266 7.927-2.927 3.179-2.214 5.125-5.206 5.653-9.077.049-.05.055-.104.02-.164l.047-.285.087.003V12.2l-.112-.006h-.002ZM94.454 32.39c.156.357.492.574.845.515.458-.078.675-.338.704-.846.125-.019.208.032.278.138.318.477.182 1.274-.29 1.685a1.215 1.215 0 0 1-1.651-.033c-.478-.44-.569-1.186-.192-1.678.07-.093.115-.226.256-.253.055.153-.019.313.05.472Zm17.006-18.353ZM72.895 13.474c-5.6.008-11.202.011-16.803 0-.359-.002-.426.11-.42.44.022 1.04.027 2.082 0 3.122-.01.37.074.471.457.47 4.213-.016 8.426-.008 12.639-.016.265 0 .367.045.36.34-.023.855-.025 1.71-.007 2.565.006.298-.082.454-.358.587-3.342 1.602-6.843 2.557-10.562 2.67-2.444.075-4.807-.247-7.058-1.254-4.819-2.157-6.535-6.915-5.493-11.322.698-2.95 2.712-4.787 5.466-5.864 2.213-.866 4.53-1.003 6.87-.87 2.008.116 3.99.403 5.872 1.16 1.949.785 3.567 1.937 4.297 4.028.062.178.186.166.324.166 1.413-.002 2.826-.009 4.238.003.27.002.315-.077.247-.32a10.326 10.326 0 0 0-2.947-4.858c-1.926-1.8-4.245-2.87-6.756-3.569-2.037-.566-4.117-.841-6.23-.885A.417.417 0 0 0 57.033 0h-1.116c0 .022 0 .045.003.067-.049.004-.098.013-.147.014-2.863.065-5.596.67-8.135 2.023-2.225 1.185-4.017 2.837-5.25 5.055-1.535 2.76-1.837 5.715-1.345 8.784.556 3.47 2.214 6.3 4.998 8.445 2.978 2.293 6.424 3.276 10.12 3.483 2.849.16 5.66-.151 8.423-.869 2.985-.776 5.83-1.885 8.431-3.573.197-.127.288-.256.287-.502-.01-3.024-.012-6.049 0-9.073.001-.327-.113-.38-.406-.38h-.001ZM35.652 1.3c0-.27-.054-.36-.34-.357-1.276.017-2.552.016-3.827.003-.263-.003-.296.097-.295.326.006 4.212.004 8.424.004 12.637 0 4.212.003 8.424-.006 12.637 0 .285.058.382.361.378 1.25-.017 2.502-.014 3.753 0 .274.003.352-.066.351-.35-.009-8.425-.008-16.85-.001-25.274Z",
    fill: props.color,
    stroke: props.color
  })));
};
/* harmony default export */ var figo = (SvgFigo);
;// CONCATENATED MODULE: ./components/landing/SelectedClients/svg/goodfriend.svg
function goodfriend_extends() { goodfriend_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return goodfriend_extends.apply(this, arguments); }

var SvgGoodfriend = function SvgGoodfriend(props) {
  return /*#__PURE__*/react.createElement("svg", goodfriend_extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/react.createElement("g", {
    opacity: 0.5,
    fill: "#fff"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M19.817 11.37c1.386.005 2.775.009 4.155-.004.421 0 .575.113.594.565 0 2.674-.498 5.217-1.897 7.533-1.399 2.316-3.372 3.973-5.978 4.82-3.104 1.017-6.228.98-9.255-.3-2.683-1.13-4.618-3.07-5.96-5.613C.175 15.887-.266 13.269.156 10.52c.651-4.124 2.797-7.25 6.572-9.19C8.892.2 11.23-.138 13.682.05c2.146.17 4.158.716 5.96 1.864 1.916 1.205 3.238 2.9 4.1 4.953.115.282 0 .433-.287.433-1.054 0-2.108 0-3.162-.019-.153 0-.345-.17-.421-.301-1.265-2.279-3.335-3.37-5.845-3.71-1.667-.226-3.353-.188-4.943.47-1.61.66-2.913 1.696-3.833 3.146-1.762 2.824-2.03 5.818-1.015 8.944 1.341 4.124 5.078 6.29 9.236 5.913 3.755-.339 6.514-2.9 7.223-6.553.096-.527.039-.603-.517-.603h-8.527c-.709 0-.709 0-.709-.696v-1.921c0-.584.02-.603.633-.603h6.17c.688 0 1.379.002 2.07.005h.002Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.477 9.2c.92.867 1.59 1.922 2.03 3.108.652 1.789.786 3.616.46 5.48-.44 2.165-1.494 4.01-3.353 5.348-1.57 1.13-3.334 1.638-5.25 1.638-1.724 0-3.219-.64-4.464-1.77-.673-.615-1.268-1.317-1.86-2.015l-.001-.001a93.77 93.77 0 0 0-.4-.47l-.031-.035-.02-.023c-.163-.184-.245-.278-.326-.276-.082.001-.163.103-.326.308l-.006.007c-.958 1.243-2.031 2.373-3.373 3.24-1.38.884-2.874 1.186-4.483.979-2.127-.283-3.948-1.111-5.385-2.693-1.456-1.62-2.165-3.54-2.26-5.668-.116-2.637.555-5.01 2.452-6.968.996-1.036 2.223-1.732 3.621-2.109 1.265-.358 2.53-.527 3.833-.282 1.935.357 3.41 1.45 4.656 2.862.264.306.512.62.774.95.157.198.318.401.49.613.11-.14.215-.27.317-.394.13-.16.255-.313.373-.472.94-1.224 2.05-2.26 3.468-2.957 1.687-.828 3.43-.828 5.231-.414 1.457.339 2.76 1.017 3.833 2.015ZM49.61 21.367c1.858-.546 2.989-1.77 3.564-3.56.747-2.39.115-5.272-1.993-6.74-1.38-.98-3.602-1.394-5.116-.133-.587.467-1.133.974-1.683 1.485-.205.19-.41.38-.616.568-1.495 1.356-3.2 1.469-4.79.207-.637-.51-1.23-1.078-1.816-1.64l-.254-.243c-1.955-1.864-4.599-1.318-6.17.245-1.188 1.186-1.648 2.655-1.705 4.293.038.22.068.442.098.663.06.444.119.888.246 1.314.345 1.206 1.016 2.241 2.127 2.92 1.936 1.167 3.87 1.091 5.538-.547.652-.622 1.303-1.243 1.993-1.826 1.264-1.074 2.759-1.187 4.12-.208.61.427 1.154.949 1.698 1.47v.001c.224.215.448.43.677.638 1.17 1.074 2.491 1.563 4.082 1.093ZM72.43 22.307c.058.094.077.132.077.15 0 .19.005.377.01.566.005.188.01.376.01.565.019.621.057.659.651.659h2.146c.556 0 .632-.094.632-.64V1.197c0-.338-.134-.489-.479-.489-.255 0-.51-.002-.766-.004C74.2.7 73.689.696 73.178.708c-.632.019-.651.057-.651.697v8.078a.542.542 0 0 1-.03.014c-.035.015-.075.033-.105.062a6.692 6.692 0 0 0-.133-.095 2.275 2.275 0 0 1-.288-.226c-.997-.979-2.146-1.77-3.545-2.052-2.932-.603-5.519.132-7.665 2.165-1.36 1.281-2.126 2.9-2.471 4.727-.326 1.732-.211 3.427.383 5.047.958 2.617 2.74 4.463 5.48 5.31 1.61.49 3.257.546 4.886-.019 1.111-.395 2.07-1.035 2.932-1.808.11-.107.219-.167.328-.226a2.82 2.82 0 0 0 .132-.075Zm-2.069-1.563c-2.529 1.864-6.246 1.074-7.818-1.62-1.398-2.41-1.168-5.347.652-7.456 1.15-1.337 2.702-1.77 4.426-1.676 2.204.113 4.082 1.544 4.752 3.615.134.433.268.867.345 1.318.047.248.043.508.04.687l-.001.06v.044c.019 2.166-.767 3.823-2.396 5.028ZM164.443.69c.421-.02.575.169.555.564-.009.18-.009.353-.009.523 0 .17 0 .334-.01.494V23.4c0 .81 0 .829-.824.829-.217 0-.434-.004-.651-.008a16.901 16.901 0 0 0-1.303.008c-.498.038-.613-.17-.594-.603.013-.287.008-.582.004-.88v-.007c-.002-.15-.004-.3-.004-.45a.687.687 0 0 0-.173-.075c-.115.104-.234.203-.354.301-.12.1-.24.198-.355.302-1.782 1.563-3.87 2.24-6.227 1.864-3.276-.527-5.518-2.392-6.687-5.442-.92-2.373-.862-4.783.096-7.118 1.015-2.448 2.855-4.105 5.48-4.859 1.303-.376 2.625-.452 3.966-.17 1.226.246 2.261.848 3.181 1.658h.001c.306.264.612.528 1.014.885a13.1 13.1 0 0 1 .035-.253c.024-.165.042-.29.042-.406v-7.57c0-.697.019-.716.709-.716.237 0 .472.002.706.005.466.004.93.008 1.402-.005Zm-9.14 20.958c2.088.32 3.87-.282 5.193-1.92 1.456-1.808 1.686-3.861.958-6.045-.786-2.335-2.798-3.748-5.442-3.691-.747-.038-1.667.17-2.491.659-2.146 1.3-2.913 3.276-2.779 5.65.154 2.786 1.955 4.97 4.561 5.347ZM124.358 8.203c-1.878-1.149-3.909-1.469-6.055-1.13-2.434.395-4.331 1.62-5.634 3.672-1.513 2.41-1.743 5.009-.996 7.702.977 3.502 3.698 5.743 7.147 6.233 2.893.414 5.519-.283 7.588-2.448.651-.678 1.226-1.431 1.571-2.335a1.135 1.135 0 0 1-.13-.054c-.048-.022-.086-.04-.119-.04-.365 0-.727-.002-1.089-.005-.722-.004-1.441-.008-2.168.005-.173 0-.384.15-.518.282-1.494 1.733-3.87 2.09-5.94 1.168-1.609-.735-2.701-1.921-3.104-3.654-.153-.64-.096-.659.575-.659h11.88c.632 0 .709-.075.766-.696.096-1.356-.057-2.693-.555-3.974-.633-1.676-1.629-3.107-3.219-4.067Zm-.384 5.819h-8.507c-.479 0-.594-.113-.441-.565.843-2.561 3.047-3.936 5.863-3.352 1.821.376 2.951 1.638 3.526 3.37.134.415-.038.565-.441.547Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/react.createElement("path", {
    d: "M79.827.69h12.11c.594.018.651.075.651.62v2.016c-.019.564-.057.602-.651.602h-8.623c-.651 0-.67 0-.67.66-.02 1.863-.02 3.726-.02 5.59v.002c0 .565.039.621.633.621h7.856c.52 0 .778 0 .907.127.128.125.128.374.128.871V13.4c0 .584-.058.66-.69.66h-8.144c-.651 0-.67 0-.67.658-.02 2.918-.02 5.835-.02 8.753v.004c0 .715-.019.753-.747.753h-2.012c-.728 0-.766-.057-.766-.791V1.405c0-.678.019-.716.728-.716ZM145.646 13.061c-.402-2.862-1.801-4.934-4.733-5.837-2.299-.697-4.522-.095-6.093 1.694-.14.15-.271.309-.428.497-.08.096-.165.2-.262.313a5.188 5.188 0 0 0-.036-.342 1.685 1.685 0 0 1-.021-.223c0-.125-.003-.25-.005-.376-.004-.251-.008-.503.005-.754.019-.395-.115-.565-.537-.546-.473.013-.955.009-1.434.004-.239-.002-.476-.004-.712-.004-.652 0-.671.02-.671.66v15.422c0 .584.058.64.652.64h2.05c.632 0 .652-.019.652-.64 0-.81-.003-1.62-.005-2.43-.004-1.619-.008-3.238.005-4.858 0-.847.076-1.694.191-2.523.23-1.638 1.169-3.277 3.373-3.672 1.494-.264 3.046.056 3.966 1.525.556.904.728 1.883.728 2.919v9.133c0 .395.096.565.537.546.427-.021.854-.018 1.281-.015.32.002.64.004.96-.004.556 0 .633-.075.633-.64v-9.133l-.003-.053a15.89 15.89 0 0 0-.093-1.303ZM103.568 7.94v2.165c0 .358-.173.452-.498.433-.186-.011-.37-.026-.553-.04-.44-.034-.873-.068-1.306-.054-1.629.037-2.702 1.337-3.028 2.636-.21.829-.325 1.695-.345 2.542-.028 1.991-.025 3.971-.021 5.957l.002 1.99c0 .621-.038.678-.67.678H95.04c-.575-.019-.632-.057-.632-.622V8.09c0-.584.019-.603.613-.603.242 0 .486.002.73.004.493.005.987.009 1.473-.004.46-.019.614.15.594.603-.012.29-.008.587-.004.882v.001c.002.146.004.292.004.435a.378.378 0 0 0 .062-.008c.028-.005.06-.01.092-.01.194-.16.387-.324.58-.488a21.41 21.41 0 0 1 1.163-.944c1.016-.753 2.204-.734 3.392-.584.326.038.46.245.46.565ZM108.569 7.487c-.498.013-.997.009-1.495.004a89.001 89.001 0 0 0-.747-.004c-.306 0-.459 0-.536.075-.077.075-.077.226-.077.528v15.479c0 .659.019.678.709.678h1.916c.747 0 .766-.038.766-.772V7.995c0-.357-.172-.508-.536-.508ZM106.92 4.338c-.328-.004-.662-.008-.995.004-.364 0-.537-.131-.537-.47 0-.923 0-1.846-.019-2.768 0-.377.172-.528.556-.528.996.02 2.012.02 3.008 0 .364-.019.517.132.517.49a67.223 67.223 0 0 0 0 2.768c0 .358-.153.508-.517.508H107.4c-.158 0-.319-.002-.48-.004Z",
    fill: props.color,
    stroke: props.color
  })));
};
/* harmony default export */ var goodfriend = (SvgGoodfriend);
;// CONCATENATED MODULE: ./components/landing/SelectedClients/svg/ibm.svg
function ibm_extends() { ibm_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ibm_extends.apply(this, arguments); }

var SvgIbm = function SvgIbm(props) {
  return /*#__PURE__*/react.createElement("svg", ibm_extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/react.createElement("g", {
    opacity: 0.5,
    fill: "#fff"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M21.42 40.095H.525v2.714H21.42v-2.714ZM21.42 34.397H.525v2.714H21.42v-2.714ZM15.45 28.698H6.495v2.714h8.955v-2.714ZM15.45 23H6.495v2.713h8.955V23ZM15.45 17.301H6.495v2.714h8.955V17.3ZM15.45 11.602H6.495v2.714h8.955v-2.714ZM21.42 5.904H.525v2.714H21.42V5.904ZM21.42.206H.525v2.713H21.42V.206ZM24.404 40.095v2.714h21.98a11.35 11.35 0 0 0 7.378-2.714H24.404ZM24.404 34.397v2.714h31.849c.493-.852.873-1.764 1.13-2.714H24.405ZM39.329 28.698h-8.955v2.714h8.955v-2.714ZM53.963 23H30.374v2.713h25.78A11.441 11.441 0 0 0 53.963 23ZM30.374 17.301v2.714h23.687a11.438 11.438 0 0 0 2.19-2.714H30.374ZM57.384 8.618a11.325 11.325 0 0 0-1.131-2.714H24.404v2.714h32.98ZM53.762 2.92A11.35 11.35 0 0 0 46.384.205h-21.98v2.713h29.358ZM39.329 11.602h-8.955v2.714h8.955v-2.714ZM47.741 14.316h9.709a11.4 11.4 0 0 0 .331-2.714h-10.04v2.714ZM47.741 28.698v2.714h10.04a11.4 11.4 0 0 0-.331-2.714H47.74ZM77.048.19H60.224v2.714h17.765L77.05.191ZM75.153 40.094h-14.93v2.715h14.93v-2.715ZM75.153 34.394h-14.93v2.714h14.93v-2.714ZM75.154 28.693h-8.958v2.715h8.958v-2.715ZM75.154 22.993h-8.958v2.714h8.958v-2.714ZM107.999 40.094h-14.93v2.715H108v-2.715ZM107.999 34.394h-14.93v2.714H108v-2.714ZM102.027 28.693h-8.958v2.715h8.958v-2.715ZM102.027 22.993h-8.958v2.714h8.958v-2.714ZM93.07 20.007h8.958v-2.715H85.237l-.942 2.715h7.862l.913-2.585v2.585ZM82.987 17.293H66.196v2.714h8.958v-2.585l.913 2.585h7.862l-.942-2.715ZM102.028 11.592H87.214l-.942 2.715h15.756v-2.715ZM91.17.19l-.942 2.715h17.771V.191h-16.83ZM84.106 42.809l.959-2.715h-1.907l.948 2.715ZM82.104 37.108h4.014l.959-2.714h-5.931l.958 2.714ZM80.092 31.408h8.04l.958-2.715h-9.956l.958 2.715ZM78.08 25.707h12.064l.959-2.714H77.12l.959 2.714ZM66.196 14.307h15.755l-.941-2.715H66.196v2.715ZM88.25 8.606h19.749V5.892H89.192l-.942 2.714ZM79.031 5.892H60.224v2.714h19.75l-.943-2.714Z",
    fill: props.color,
    stroke: props.color
  })));
};
/* harmony default export */ var ibm = (SvgIbm);
;// CONCATENATED MODULE: ./components/landing/SelectedClients/svg/kinship.svg
var _circle;
function kinship_extends() { kinship_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return kinship_extends.apply(this, arguments); }

var SvgKinship = function SvgKinship(props) {
  return /*#__PURE__*/react.createElement("svg", kinship_extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/react.createElement("g", {
    opacity: 0.5,
    fill: "#fff"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M.491 0h10.814v42.763a15.822 15.822 0 0 0-10.814 0V0Z",
    fill: props.color,
    stroke: props.color
  }), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 5.898,
    cy: 52.102,
    r: 5.898
  })), /*#__PURE__*/react.createElement("path", {
    d: "M10.813 36.865 29.492 17.94h12.78L22.856 36.865l19.415 19.17h-12.78l-18.678-19.17Z",
    fill: props.color,
    stroke: props.color
  })));
};
/* harmony default export */ var kinship = (SvgKinship);
;// CONCATENATED MODULE: ./components/landing/SelectedClients/svg/mars.svg
function mars_extends() { mars_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mars_extends.apply(this, arguments); }

var SvgMars = function SvgMars(props) {
  return /*#__PURE__*/react.createElement("svg", mars_extends({
    width: props.width,
    height: props.height,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.905.071c-.633 0-.914.375-1.149.911-14.78 33.854-16.02 36.53-16.02 36.53h8.376l1.743-4.247h12.62l1.749 4.248h9.851s-.842-1.74-16.02-36.53c-.236-.537-.516-.912-1.15-.912Zm-4.387 26.717 3.637-8.863 3.649 8.863h-7.286Zm46.228-6.283c2.88-1.707 5.06-4.687 5.06-8.96 0-3.355-1.352-6.122-3.702-7.99-2.383-1.9-5.138-2.928-10.772-2.928H74.281v36.886h8.904v-13.73h2.762c3.003 0 4.518 1.13 5.778 4.123 1.064 2.534 1.815 5.54 2.794 9.607h9.93a426.697 426.697 0 0 0-3.173-9.109c-1.45-4.033-3.206-6.516-5.53-7.9Zm-5.693-4.525c-1.077.82-2.467 1.08-4.968 1.08h-1.9s-.02-9.833 0-9.833h1.9c2.612 0 3.91.285 4.962 1.073 1.201.905 1.736 2.263 1.736 3.833 0 1.714-.6 2.974-1.73 3.847Zm-73.295.278L1.632 1.273C1.175.827.718.511 0 .511v37.002h7.775V19.82l8.983 8.895 8.99-8.895v17.693h7.776V.51c-.718 0-1.175.316-1.633.762L16.759 16.258Zm115.417 2.85c-3.969-3.736-11.17-4.376-14.017-6.574-1.116-.86-1.514-2.127-1.149-3.335.451-1.5 1.959-2.483 4.172-2.483 3.049 0 5.784 1.377 7.678 3.607l5.085-5.268C130.948 1.9 126.162 0 121.122 0c-5.875 0-10.308 2.812-12.286 7.298-1.535 3.484-1.006 7.117.881 9.73 3.649 5.054 11.353 5.21 14.689 7.801 1.188.925 1.854 2.418 1.143 4.028-.614 1.409-2.161 2.366-4.694 2.43-3.513.084-6.646-1.545-8.951-4.395l-5.092 5.274c3.369 4.04 8.383 5.987 14.441 5.987 5.889 0 11.059-2.27 13.168-7.105 1.847-4.227 1.181-8.72-2.246-11.94Z",
    fill: props.color,
    opacity: 0.5,
    stroke: props.color
  }));
};
/* harmony default export */ var mars = (SvgMars);
;// CONCATENATED MODULE: ./components/landing/SelectedClients/svg/miracle-grow.svg
function miracle_grow_extends() { miracle_grow_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return miracle_grow_extends.apply(this, arguments); }

var SvgMiracleGrow = function SvgMiracleGrow(props) {
  return /*#__PURE__*/react.createElement("svg", miracle_grow_extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/react.createElement("g", {
    opacity: 0.5,
    fill: "#fff"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M23.052 40.355h-5.721V18.788h-.055c-1.458 8.06-2.999 14.827-4.512 21.567H9.16c-1.54-6.74-3.108-13.507-4.594-21.567h-.055v21.567H0V9.545h7.757c1.293 5.915 2.614 11.747 3.88 18.981h.054c1.21-7.207 2.503-13.066 3.741-18.98h7.593v30.81h.027ZM31.002 15.763h-5.419v24.592h5.42V15.764ZM38.622 22.09h.055l.413-1.981c.248-1.073.853-4.98 2.833-4.98 1.156 0 1.926.799 2.696 1.871l-1.678 7.18c-.357-.192-.688-.495-1.54-.495-1.238 0-2.751 1.073-2.751 6.107v10.536h-5.447V15.735h5.447v6.355h-.028ZM51.798 26.298c.193 6.602-1.182 8.886-2.118 8.886-.687 0-1.403-1.238-1.403-2.861 0-2.311.826-4.182 1.981-4.924l1.54-1.1Zm-.165 11.416c0 .88.11 2.119.248 2.641h5.64c-.358-1.705-.468-3.933-.468-5.97v-8.94c0-8.39-3.219-10.288-6.465-10.288-1.815 0-3.824.633-6.024 3.356l1.485 4.43c.908-1.486 2.09-2.67 3.576-2.67.88 0 1.843 1.129 2.201 2.477l-3.08 1.375c-3.715 1.678-5.365 4.236-5.365 9.518 0 4.374 2.063 7.317 3.934 7.317 1.238 0 2.53-1.513 3.603-2.503l.715-.743ZM70.56 39.09c-1.458 1.375-2.97 1.87-4.401 1.87-4.677 0-8.06-4.951-8.06-12.516 0-8.197 3.768-13.314 8.362-13.314 1.293 0 2.971.798 4.292 2.173L69.35 22.31c-.743-.605-1.568-.88-2.283-.88-1.789 0-3.247 1.98-3.247 6.739 0 5.062 2.009 6.547 3.191 6.547.826 0 1.624-.385 2.174-.798l1.375 5.172ZM77.327 7.978H71.88v32.377h5.447V7.978ZM84.424 25.033c-.165-3.934.605-5.804 1.733-5.804 1.266 0 2.008 1.76 1.87 5.804h-3.603Zm12.214 0h-2.833v4.154h2.833v-4.154Zm-4.044 4.154c.468-8.583-1.925-14.057-6.3-14.057-5.17 0-7.647 6.3-7.647 12.379 0 7.29 3.467 13.424 7.345 13.424 1.733 0 4.017-.385 6.575-2.586l-1.486-5.034c-.88.935-2.118 1.788-3.548 1.788-1.54 0-3.191-1.843-3.191-5.914h8.252ZM115.123 26.27v13.04c-2.31 1.1-4.236 1.596-5.969 1.596-6.299 0-11.526-6.162-11.526-16.258 0-9.353 4.759-15.625 11.168-15.625 1.238 0 3.494.578 4.842 1.54l-1.403 5.447c-.935-.44-2.613-.578-3.136-.578-2.696 0-5.474 2.861-5.474 9.574 0 6.574 2.998 9.49 4.951 9.49.193 0 .496-.055.826-.22v-7.978h5.721v-.027ZM122.771 22.09h.055l.413-1.981c.247-1.073.852-4.98 2.833-4.98 1.155 0 1.926.799 2.668 1.871l-1.678 7.18c-.357-.192-.687-.495-1.54-.495-1.238 0-2.724 1.073-2.724 6.107v10.536h-5.474V15.735h5.447v6.355ZM135.783 19.531c1.761 0 2.311 4.54 2.311 8.225 0 3.879-.495 8.803-2.311 8.803-1.816 0-2.283-4.924-2.283-8.803 0-3.686.522-8.225 2.283-8.225Zm0 21.43c4.676 0 7.812-5.557 7.812-13.205 0-7.977-3.823-12.599-7.812-12.599-3.989 0-7.785 4.65-7.785 12.6 0 7.62 3.136 13.203 7.785 13.203ZM33.203 3.19c.412.606.44 1.954-.275 3.357-.716 1.403-1.87 2.256-2.669 2.31-.412-.604-.44-1.98.275-3.355.716-1.403 1.898-2.229 2.669-2.311ZM26.408 0c1.183.523 2.476 2.668 2.696 5.777.22 3.108-.688 5.86-1.816 6.877-1.21-.468-2.476-2.668-2.695-5.777-.22-3.108.77-5.832 1.815-6.877ZM36.916 8.913c-1.017-.468-3.19-.385-5.364.66-2.173 1.045-3.466 2.558-3.493 3.549.99.495 3.19.385 5.364-.66 2.173-1.046 3.41-2.586 3.493-3.55ZM144.091 6.492c1.623 0 3.081 1.183 3.081 2.999 0 1.815-1.458 2.998-3.081 2.998s-3.081-1.183-3.081-2.998c0-1.816 1.458-2.999 3.081-2.999Zm0 5.364c1.238 0 2.255-.99 2.255-2.365 0-1.376-1.017-2.339-2.255-2.339-1.266 0-2.256.99-2.256 2.339 0 1.375.99 2.365 2.256 2.365Zm-1.183-4.043h1.265c.853 0 1.321.275 1.321.99 0 .605-.385.853-.881.908l.908 1.458h-.688l-.825-1.43h-.412v1.43h-.688V7.813Zm.66 1.403h.605c.385 0 .66-.055.66-.468 0-.358-.385-.413-.687-.413h-.55v.88h-.028Z",
    fill: props.color,
    stroke: props.color
  })));
};
/* harmony default export */ var miracle_grow = (SvgMiracleGrow);
;// CONCATENATED MODULE: ./components/landing/SelectedClients/svg/plume.svg
function plume_extends() { plume_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return plume_extends.apply(this, arguments); }

var SvgPlume = function SvgPlume(props) {
  return /*#__PURE__*/react.createElement("svg", plume_extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/react.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#plume_svg__a)",
    fill: "#fff"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M149.234 16.81c.066 0 .13-.003.187-.007a.444.444 0 0 0 .155-.035.264.264 0 0 0 .111-.091.299.299 0 0 0 .041-.175.272.272 0 0 0-.035-.149.342.342 0 0 0-.092-.088.425.425 0 0 0-.136-.042c-.051-.006-.098-.012-.149-.012h-.39v.602h.308v-.003Zm.126-.837c.226 0 .391.044.502.136.107.089.161.225.161.406 0 .168-.047.295-.142.374a.643.643 0 0 1-.356.143l.543.833h-.317l-.514-.811h-.311v.811h-.295v-1.892h.729Zm-1.332 1.49c.067.168.162.317.279.44.121.124.264.22.425.292.162.07.34.105.53.105a1.304 1.304 0 0 0 .945-.397c.121-.123.213-.269.279-.44.067-.168.102-.352.102-.552a1.394 1.394 0 0 0-.381-.976 1.304 1.304 0 0 0-.945-.393 1.331 1.331 0 0 0-.955.393 1.34 1.34 0 0 0-.279.434 1.458 1.458 0 0 0-.101.542c-.003.2.035.384.101.552Zm-.266-1.189c.089-.197.206-.368.352-.51a1.655 1.655 0 0 1 1.148-.463 1.628 1.628 0 0 1 1.142.463c.146.142.266.314.349.51.089.197.13.409.13.634 0 .235-.041.45-.13.647a1.59 1.59 0 0 1-1.491.973 1.633 1.633 0 0 1-1.148-.46 1.6 1.6 0 0 1-.482-1.16c0-.225.044-.438.13-.634ZM67.11 7.93h-9.655c-.336 0-.64.254-.66.59-.019.361.27.66.625.66h1.532c.19 0 .342.151.342.342v19.264a.34.34 0 0 1-.342.343h-1.516a.64.64 0 0 0-.631.494.623.623 0 0 0 .612.755h6.479a.64.64 0 0 0 .632-.495.623.623 0 0 0-.613-.754h-1.532a.34.34 0 0 1-.342-.343V9.522c0-.19.152-.343.343-.343h4.034c2.588 0 3.898 2.156 3.898 4.984 0 2.995-.964 5.233-3.898 5.233-.127 0-2.252.007-2.379.01a.627.627 0 0 0-.006 1.252H67.109c3.204 0 6.109-2.18 6.109-6.378 0-4.197-2.909-6.35-6.109-6.35ZM94.103 27.598s-1.713.843-2.34 1.024c-1.549.447-2.42-.533-2.42-2.245l-.01-9.941a.687.687 0 0 0-.689-.688h-3.898c-.336 0-.64.253-.66.593a.624.624 0 0 0 .626.656h1.532c.19 0 .342.152.342.342v8.315c0 2.857.013 4.286 2.046 4.895v-.006c.003 0 .003 0 .006.003 1.32.51 2.96.054 4.022-.577 1.062-.631 2.08-1.306 2.08-1.306.343-.235.406-.615.184-.916-.206-.286-.5-.324-.821-.15ZM100.095 29.132H99.527a.341.341 0 0 1-.342-.342V16.433a.687.687 0 0 0-.689-.688h-3.9c-.337 0-.642.253-.66.592-.02.362.27.657.624.657h1.532c.19 0 .343.152.343.342V29.69c0 .38.307.688.688.688h3.01a.628.628 0 0 0 .625-.66c-.022-.332-.327-.586-.663-.586ZM82.238 29.132h-1.532a.338.338 0 0 1-.34-.343l-.002-20.17a.687.687 0 0 0-.689-.689h-3.904c-.308 0-.59.21-.644.51a.625.625 0 0 0 .615.742h1.532c.19 0 .343.153.343.343v19.264c0 .19-.152.343-.343.343h-1.519c-.27 0-.526.165-.606.425a.625.625 0 0 0 .593.824h6.467c.308 0 .59-.21.644-.51a.624.624 0 0 0-.615-.74ZM140.324 20.655h-4.834c-.311 0-.6.213-.65.52-.064.39.238.73.618.73h7.279a.684.684 0 0 0 .688-.686v-.63c-.006-3.304-2.61-5.196-5.969-5.196-3.355 0-6.724 2.837-6.724 7.532 0 .228.007.552.023.773.329 5.298 5.607 8.23 10.396 5.938.641-.307 1.25-.767 1.751-1.16.232-.18.45-.51.209-.881-.241-.368-.596-.32-.913-.15-1.11.596-2.331 1.047-3.448 1.047-3.454 0-5.271-2.204-5.271-5.95l.003-.632a7.237 7.237 0 0 1 .21-1.771c.558-2.096 2.01-3.494 3.761-3.494 1.967 0 3.124 1.319 3.213 3.665a.338.338 0 0 1-.342.345ZM109.937 30.169a.594.594 0 0 0 .165-.38.624.624 0 0 0-.625-.657h-1.532a.34.34 0 0 1-.34-.342V16.433a.687.687 0 0 0-.688-.688h-3.01a.648.648 0 0 0-.225.044c-.006.003-.009.003-.016.003a.675.675 0 0 0-.177.114l-.019.016a.646.646 0 0 0-.121.168c-.003.01-.009.016-.013.026a.639.639 0 0 0-.05.206c0 .006-.004.01-.004.015 0 .007.004.013.004.02 0 .015-.004.031-.004.047.019.323.295.567.619.587l.009.003h.594a.34.34 0 0 1 .342.342v11.447a.34.34 0 0 1-.342.343h-.597a.628.628 0 0 0-.003 1.255H109.467c.159 0 .302-.06.413-.159.009-.006.015-.012.025-.022.009-.01.019-.022.032-.031ZM118.379 29.132h-.593a.342.342 0 0 1-.343-.343V20.5c0-2.856-.117-4.15-2.045-4.894-1.32-.51-2.96-.054-4.022.577a56.183 56.183 0 0 0-2.081 1.306c-.342.235-.406.615-.184.916.21.285.495.333.812.159 0 0 1.7-.866 2.357-1.034 1.56-.396 2.42.533 2.42 2.245V28.9a.228.228 0 0 1-.229.229h-.71a.627.627 0 1 0 0 1.255h4.621c.13 0 .247-.038.346-.105a.83.83 0 0 0 .009-.01c.029-.021.057-.04.083-.066l.016-.019c.022-.025.041-.044.06-.073l.019-.028c.016-.026.032-.048.038-.076a.19.19 0 0 0 .013-.038c.009-.026.019-.051.025-.076.003-.016.006-.029.006-.045a.728.728 0 0 0 .01-.057c0-.003 0-.01-.003-.012l.003-.023a.628.628 0 0 0-.628-.624ZM128.215 29.132h-.593a.341.341 0 0 1-.343-.342v-8.287c0-2.856-.117-4.15-2.045-4.895-1.32-.51-2.96-.053-4.022.577-1.063.631-2.081 1.306-2.081 1.306-.342.235-.406.615-.184.917.21.285.511.326.828.149 0 0 1.713-.844 2.341-1.024 1.548-.447 2.42.532 2.42 2.244v9.013c0 .19-.153.342-.343.342h-.596a.63.63 0 0 0-.561.352c-.004.003-.004.006-.007.013-.012.028-.025.057-.028.088l-.01.029c-.006.028-.009.054-.013.082 0 .013-.003.022-.006.032v.013c0 .006-.003.012-.003.022 0 .012.003.025.003.035a.622.622 0 0 0 .622.59l.003.002h4.615a.629.629 0 0 0 .625-.59.475.475 0 0 0-.01-.113.616.616 0 0 0-.612-.555ZM33.191 22.595a2.103 2.103 0 0 1-.006 2.092v-.003l-5.316 9.206a5.085 5.085 0 0 1-4.399 2.54l-11.97-.004c-.437 0-.837.298-.91.726a.874.874 0 0 0 .863 1.02l12.014.004c2.439 0 4.694-1.3 5.915-3.41l5.316-9.207v-.003a3.84 3.84 0 0 0 .51-1.921c0-.66-.168-1.322-.51-1.915l-.003-.003-4.418-7.659a.626.626 0 0 0-.546-.317h-1.386a.157.157 0 0 0-.136.235l4.982 8.62Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/react.createElement("path", {
    d: "M24.482 30.831a2.094 2.094 0 0 1-1.814 1.043h.003-10.637a5.078 5.078 0 0 1-4.4-2.54L1.656 18.979c-.228-.393-.723-.593-1.139-.403a.872.872 0 0 0-.4 1.234l6.005 10.404a6.84 6.84 0 0 0 5.915 3.414h10.637a3.868 3.868 0 0 0 3.328-1.915v-.003l4.424-7.656a.64.64 0 0 0 0-.63l-.691-1.199a.155.155 0 0 0-.27 0l-4.983 8.607Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/react.createElement("path", {
    d: "M12.997 27.414c-.37 0-.73-.102-1.043-.283a2.137 2.137 0 0 1-.77-.77v.003l-5.32-9.206a5.073 5.073 0 0 1 0-5.075l5.991-10.36c.216-.377.162-.875-.174-1.15a.877.877 0 0 0-1.316.234L4.35 11.208a6.816 6.816 0 0 0 0 6.825l5.316 9.203v.003a3.865 3.865 0 0 0 3.324 1.924h.003l8.85.004a.63.63 0 0 0 .545-.314l.691-1.198a.157.157 0 0 0-.136-.235l-9.947-.006Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/react.createElement("path", {
    d: "M10.213 15.757a2.103 2.103 0 0 1 .006-2.092v.003l5.316-9.206a5.085 5.085 0 0 1 4.399-2.539l11.97.003c.438 0 .837-.298.91-.726a.874.874 0 0 0-.863-1.02L19.934.175a6.833 6.833 0 0 0-5.915 3.411l-5.316 9.206v.003a3.84 3.84 0 0 0-.51 1.921c0 .66.168 1.322.51 1.915l.003.003 4.421 7.66c.111.196.32.316.546.316h1.386c.12 0 .197-.133.136-.234l-4.982-8.62Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/react.createElement("path", {
    d: "M18.92 7.524c.186-.32.45-.58.764-.76a2.14 2.14 0 0 1 1.05-.283h-.004 10.638c1.814 0 3.492.967 4.4 2.54l5.978 10.356c.228.393.723.593 1.138.403a.872.872 0 0 0 .4-1.233L37.28 8.142a6.839 6.839 0 0 0-5.915-3.414H20.73a3.867 3.867 0 0 0-3.327 1.915v.003l-4.424 7.662a.64.64 0 0 0 0 .631l.691 1.198c.06.105.21.105.27 0l4.98-8.613Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30.41 10.945c.37 0 .73.101 1.043.282.314.18.58.447.77.77v-.003L37.54 21.2a5.073 5.073 0 0 1 0 5.076l-5.988 10.356c-.216.378-.162.875.174 1.151a.877.877 0 0 0 1.316-.235l6.01-10.398a6.816 6.816 0 0 0 0-6.825l-5.315-9.206v-.003a3.865 3.865 0 0 0-3.324-1.924h-.003l-8.85-.003a.63.63 0 0 0-.545.314l-.691 1.198a.157.157 0 0 0 .136.234l9.95.01Z",
    fill: props.color,
    stroke: props.color
  })), /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "plume_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: props.color,
    transform: "translate(0 .176)",
    d: "M0 0h150.882v38H0z",
    stroke: props.color
  }))));
};
/* harmony default export */ var plume = (SvgPlume);
;// CONCATENATED MODULE: ./components/landing/SelectedClients/svg/spectrum-health.svg
function spectrum_health_extends() { spectrum_health_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return spectrum_health_extends.apply(this, arguments); }

var SvgSpectrumHealth = function SvgSpectrumHealth(props) {
  return /*#__PURE__*/react.createElement("svg", spectrum_health_extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/react.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#spectrum-health_svg__a)",
    fill: "#fff"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M74.414 21.94c0-.628-.208-1.098-.678-1.438-.443-.34-1.251-.679-2.398-1.07-1.148-.366-2.06-.732-2.738-1.098-1.825-.993-2.764-2.325-2.764-3.997 0-.862.235-1.646.73-2.325.495-.68 1.2-1.202 2.112-1.594.913-.392 1.956-.575 3.103-.575 1.147 0 2.19.209 3.076.627.913.418 1.59.993 2.112 1.75a4.63 4.63 0 0 1 .757 2.587h-3.338c0-.732-.235-1.306-.704-1.724-.47-.418-1.121-.627-1.955-.627-.809 0-1.46.183-1.904.522-.443.34-.678.784-.678 1.359 0 .522.261.966.782 1.306.522.366 1.304.68 2.347.993 1.904.575 3.285 1.28 4.146 2.116.86.836 1.303 1.881 1.303 3.135 0 1.385-.521 2.482-1.59 3.266-1.069.784-2.477 1.176-4.276 1.176-1.252 0-2.373-.236-3.39-.68-1.016-.444-1.799-1.07-2.346-1.855-.548-.783-.809-1.698-.809-2.743h3.338c0 1.777 1.069 2.665 3.207 2.665.782 0 1.408-.157 1.851-.47.47-.261.704-.732.704-1.307Zm16.218-1.646c0 1.854-.417 3.317-1.252 4.415-.834 1.097-1.981 1.672-3.39 1.672-1.225 0-2.19-.418-2.945-1.254v5.643h-3.207V14.206h2.972l.104 1.176c.782-.94 1.8-1.385 3.05-1.385 1.487 0 2.634.549 3.442 1.646.809 1.097 1.226 2.587 1.226 4.52v.13Zm-3.207-.236c0-1.097-.209-1.985-.6-2.586-.39-.601-.965-.915-1.72-.915-1.017 0-1.696.392-2.087 1.15v4.886c.391.783 1.096 1.175 2.086 1.175 1.539.052 2.32-1.202 2.32-3.71Zm10.403 6.349c-1.747 0-3.207-.549-4.302-1.62-1.095-1.071-1.669-2.508-1.669-4.31v-.314c0-1.202.235-2.273.704-3.214.47-.94 1.122-1.672 1.982-2.194.86-.523 1.825-.758 2.92-.758 1.643 0 2.947.523 3.885 1.542.939 1.045 1.408 2.481 1.408 4.389v1.306h-7.64c.105.784.418 1.41.94 1.881.52.47 1.173.706 1.98.706 1.226 0 2.191-.445 2.895-1.333l1.564 1.75c-.495.68-1.121 1.202-1.955 1.594-.782.366-1.695.575-2.712.575Zm-.365-9.85c-.625 0-1.147.21-1.538.654-.391.444-.652 1.045-.756 1.855h4.458v-.262c-.026-.705-.208-1.254-.573-1.646-.365-.392-.887-.6-1.59-.6Zm12.255 7.264c.6 0 1.069-.157 1.434-.497.365-.313.547-.758.573-1.306h2.999c0 .81-.235 1.541-.678 2.22a4.377 4.377 0 0 1-1.799 1.568c-.756.366-1.591.549-2.503.549-1.721 0-3.077-.549-4.068-1.62-.99-1.097-1.486-2.587-1.486-4.494v-.209c0-1.855.496-3.318 1.486-4.415.991-1.097 2.321-1.646 4.042-1.646 1.512 0 2.711.418 3.598 1.28.913.862 1.356 1.986 1.382 3.397h-2.999c-.026-.628-.208-1.124-.573-1.516-.365-.392-.861-.575-1.46-.575-.756 0-1.304.262-1.695.81-.391.549-.574 1.437-.574 2.64v.339c0 1.228.183 2.116.574 2.665.417.548.991.81 1.747.81Zm10.794-12.541v2.952h2.06v2.352h-2.06v5.956c0 .445.079.758.261.94.183.184.495.288.965.288.365 0 .678-.026.938-.078v2.43a6.892 6.892 0 0 1-1.929.287c-2.242 0-3.39-1.123-3.442-3.396v-6.454h-1.747v-2.35h1.747v-2.953l3.207.026Zm10.273 5.93a9.733 9.733 0 0 0-1.147-.078c-1.225 0-2.008.418-2.399 1.228v7.838h-3.207V14.232h3.025l.078 1.437c.652-1.097 1.538-1.646 2.686-1.646.365 0 .678.053.99.157l-.026 3.03Zm8.735 7.734c-.782.967-1.877 1.437-3.285 1.437-1.278 0-2.269-.366-2.947-1.097-.678-.732-1.016-1.83-1.043-3.24v-7.838h3.207v7.733c0 1.255.574 1.881 1.721 1.881 1.095 0 1.826-.365 2.243-1.123v-8.465h3.207v11.966h-3.025l-.078-1.254Zm8.448-10.738.104 1.333c.861-1.046 2.008-1.568 3.442-1.568 1.538 0 2.607.6 3.181 1.829.834-1.228 2.034-1.83 3.598-1.83 1.304 0 2.268.367 2.894 1.124.626.758.965 1.881.965 3.423v7.629h-3.207v-7.63c0-.678-.131-1.175-.391-1.488-.261-.314-.73-.47-1.408-.47-.965 0-1.617.47-2.008 1.358v8.204h-3.207v-7.63c0-.678-.13-1.201-.417-1.488-.287-.314-.73-.47-1.408-.47-.913 0-1.565.365-1.982 1.123v8.465h-3.155V14.154h2.999v.052ZM75.848 32.73v6.531h-6.492v-6.532h-3.338v16.094h3.338v-6.897h6.492v6.897h3.338V32.73h-3.338Zm10.925 16.302c-1.747 0-3.207-.548-4.302-1.62-1.095-1.07-1.669-2.508-1.669-4.31v-.314c0-1.202.235-2.273.704-3.213.47-.941 1.121-1.672 1.982-2.195.86-.523 1.825-.758 2.92-.758 1.643 0 2.946.523 3.885 1.542.939 1.045 1.408 2.482 1.408 4.389v1.306h-7.64c.105.784.418 1.411.939 1.881.522.47 1.173.706 1.982.706 1.225 0 2.19-.444 2.894-1.333l1.564 1.75c-.495.68-1.12 1.203-1.955 1.594-.809.392-1.695.575-2.712.575Zm-.365-9.823c-.626 0-1.147.209-1.538.653-.391.444-.652 1.045-.757 1.855h4.46v-.261c-.027-.706-.21-1.254-.574-1.646-.392-.418-.913-.601-1.591-.601Zm13.949 9.614c-.156-.287-.26-.653-.312-1.071-.783.862-1.8 1.306-3.025 1.306-1.173 0-2.164-.34-2.92-1.019-.782-.679-1.147-1.541-1.147-2.56 0-1.28.469-2.247 1.407-2.926.94-.68 2.295-1.019 4.094-1.019h1.486v-.68c0-.548-.156-.992-.417-1.332-.287-.34-.73-.496-1.356-.496-.547 0-.965.13-1.277.392-.313.261-.47.6-.47 1.071h-3.207a3.2 3.2 0 0 1 .652-1.933c.417-.601 1.043-1.045 1.825-1.385.782-.34 1.669-.496 2.634-.496 1.486 0 2.659.365 3.52 1.097.86.731 1.303 1.776 1.303 3.135v5.173c0 1.15.313 2.168.626 2.77h-.156l-3.26-.027Zm-2.66-2.22c.47 0 .913-.105 1.305-.314.39-.209.704-.496.886-.836v-2.064h-1.2c-1.616 0-2.45.549-2.555 1.646v.183c0 .392.13.731.418.993.287.26.651.392 1.147.392ZM108.65 31.84h-3.207v16.982h3.207V31.841Zm6.44 2.064v2.952h2.06v2.352h-2.06v5.956c0 .445.078.758.261.941.182.183.495.288.964.288.365 0 .678-.027.939-.079v2.43a6.903 6.903 0 0 1-1.929.287c-2.243 0-3.39-1.123-3.442-3.396v-6.453h-1.747V36.83h1.747V33.88h3.207v.026Zm6.831 4.259c.861-1.02 1.93-1.516 3.207-1.516 2.608 0 3.937 1.516 3.964 4.52v7.655h-3.208v-7.576c0-.68-.156-1.202-.443-1.516-.287-.34-.782-.496-1.486-.496-.939 0-1.617.366-2.034 1.071v8.491h-3.207V31.815h3.207v6.349ZM44.482.35c.209.105.417.21.574.393.156.156.286.366.39.575.105.209.131.47.131.705 0 .261-.052.496-.13.705-.105.21-.209.418-.391.575a2.229 2.229 0 0 1-.574.392c-.209.104-.47.13-.73.13s-.495-.052-.73-.13c-.209-.105-.417-.209-.574-.392a2.236 2.236 0 0 1-.39-.575c-.105-.209-.131-.444-.131-.705 0-.261.052-.496.13-.705.104-.21.209-.419.391-.575.157-.157.365-.288.574-.392.208-.105.47-.13.73-.13s.495.051.73.13Zm-1.33.236a1.53 1.53 0 0 0-.495.34 1.449 1.449 0 0 0-.313.496 1.536 1.536 0 0 0-.104.6c0 .21.026.419.104.602s.182.34.313.496c.13.13.287.261.495.34.183.078.391.13.626.13.209 0 .417-.052.6-.13a1.53 1.53 0 0 0 .495-.34 1.536 1.536 0 0 0 .417-1.097c0-.21-.052-.418-.104-.601a1.992 1.992 0 0 0-.313-.496 1.391 1.391 0 0 0-.495-.34 1.544 1.544 0 0 0-.6-.13c-.235.025-.443.052-.626.13ZM43.1.978h.808c.235 0 .417.052.522.157.104.104.156.235.156.444a.624.624 0 0 1-.052.235c-.026.078-.078.13-.104.183-.052.052-.105.078-.157.104a.49.49 0 0 1-.208.053l.626.94h-.313l-.6-.94h-.443v.94h-.261V.978h.026Zm.834.94a.49.49 0 0 0 .209-.052.545.545 0 0 0 .157-.104c.026-.053.052-.105.052-.21 0-.078-.026-.13-.052-.182a.204.204 0 0 0-.105-.105c-.052-.026-.104-.052-.156-.052-.052 0-.13-.026-.183-.026h-.47v.731h.548ZM41.118 43.511c-.182.784-.208 2.534.652 2.587.782.052 1.278-.967 1.486-1.463.183-.47.522-1.49.444-2.195-.079-.967-.522-1.41-1.148-1.228-.782.235-1.251 1.463-1.434 2.3Zm2.92-1.41c.261 1.097.991.862 1.487.26.287-.365.495-.914.626-1.306.338-1.07.338-3.16-.835-2.847-1.147.287-1.59 2.56-1.278 3.892Zm2.608-3.11c.104.419.391.81.73.784.782-.026 1.382-1.62 1.486-2.43.104-.966-.235-2.325-1.173-1.985-.939.34-1.408 2.351-1.043 3.632Zm2.399-3.474c.104.705.39 1.28.912 1.228.652-.053 1.07-.627 1.356-1.96.182-.888 0-2.795-1.225-2.325-.835.34-1.174 1.907-1.043 3.057Zm2.424-3.736c.13.705.418 1.202 1.017 1.175 1.095-.026 1.539-1.933 1.278-2.952-.183-.732-.678-1.254-1.33-.967-.808.366-1.147 1.777-.965 2.744Zm-1.512-4.18c.34 1.332 1.33 1.907 1.982.862.365-.601.521-1.725.182-2.64-.26-.678-.86-1.253-1.512-.94-.73.34-.913 1.75-.652 2.718Zm-.495-2.848c1.642-.366.547-4.781-1.121-4.076-1.278.575-.261 4.39 1.12 4.076Zm-4.407-6.584c.261 1.123 1.096 2.351 1.878 2.09 1.408-.444-.13-4.468-1.513-3.788-.521.261-.495 1.15-.365 1.698Zm-2.998-4.285c.235.784 1.121 2.038 1.747 1.803 1.043-.418-.522-3.605-1.538-3.109-.392.183-.365.784-.21 1.306Zm-3.963-5.303c-.183 1.306 1.564 3.605 2.45 3.292.183-.079.392-.418.366-.784-.079-1.307-1.643-3.475-2.556-2.926-.156.052-.234.235-.26.418ZM12.828 19.005c-.313.94.183 1.646.783 2.038 1.486 1.019 4.015.209 4.25-1.385.182-1.254-.965-2.43-2.582-2.404-1.2.027-2.138.81-2.45 1.751Zm21.25 30.097c-.678.81-1.199 2.326-1.095 3.475.052.47.235.862.678 1.019.939.314 1.93-.94 2.242-1.463.47-.732.809-1.777.861-2.508.026-.653-.078-1.49-.808-1.568-.86-.13-1.487.575-1.878 1.045Zm-5.345 6.558c-.182.888-.182 2.168.626 2.377.365.105.756 0 1.147-.34.913-.783 2.216-2.769 1.93-4.467-.13-.731-.678-1.045-1.33-.862-1.278.366-2.086 1.907-2.373 3.292Zm-1.668-4.86c-.105.889.13 2.352 1.173 2.326.443 0 1.043-.314 1.382-.575 1.043-.862 2.268-2.979 1.616-4.52-.287-.653-1.017-.862-1.747-.627-1.512.549-2.268 2.064-2.424 3.396Zm10.168-2.403c.209 1.776 1.695 1.176 2.477.209.652-.784 1.095-2.012.991-2.926-.104-.993-.678-1.437-1.408-1.202-1.304.418-2.216 2.586-2.06 3.919Zm-12.359-1.254c.418 1.071 1.695 1.385 2.895.6.964-.626 1.877-2.09 1.825-3.343-.052-1.385-.939-2.038-2.164-1.75-1.93.47-3.181 2.9-2.556 4.493Zm-3.128-4.99c.417 1.28 2.085 1.75 3.624.784.886-.55 1.799-2.012 1.747-3.136-.079-1.515-1.434-2.247-3.13-1.593-1.433.522-2.789 2.299-2.241 3.945Zm-2.816-7.394c-.86.862-1.434 2.822 0 3.71 1.408.888 3.467.078 4.354-.967.521-.6 1.069-1.855.443-2.926-.391-.68-1.486-1.097-2.581-.914-1.226.209-1.721.6-2.216 1.097Zm-4.694-3.135c-.443 1.123.157 2.142 1.017 2.534 1.512.68 3.703-.34 4.485-1.228.47-.548.886-1.358.652-2.273-.365-1.41-1.904-1.776-3.546-1.254-1.356.418-2.295 1.359-2.608 2.22ZM9.83 27.836c-.104.522.078 1.228.365 1.541 1.695 1.986 5.919-.026 6.284-1.907.39-2.038-1.956-2.822-3.677-2.273-1.46.444-2.711 1.41-2.972 2.639Zm-4.042-4.572c-.312 1.201.548 2.116 1.356 2.403 2.086.705 5.241-.81 5.371-2.822.105-1.593-1.486-2.69-3.546-2.246-1.46.313-2.842 1.437-3.18 2.665Zm12.229-8.282c-.965 1.463.73 3.344 2.45 3.135.94-.105 1.904-.784 1.644-1.96-.287-1.306-1.878-2.273-3.207-1.803-.47.157-.757.419-.887.628Zm3.624-2.56c-.417 1.41 1.513 3.16 3.05 2.638 2.113-.732-.547-4.154-2.45-3.292-.313.157-.521.418-.6.653Zm3.077-2.3c.026 1.15 1.669 2.404 2.66 1.986.26-.131.417-.47.39-.732-.078-1.15-1.799-2.273-2.633-1.88-.26.104-.417.417-.417.626Zm12.828 21.032c1.643.757 1.695-3.24.052-2.744-.938.288-.99 2.326-.052 2.744Zm3.103-3.136c.939-.209.339-2.638-.6-2.116-.652.366-.26 2.325.6 2.116Zm2.242-2.508c1.226-.183.313-3.187-.782-2.638-.834.418-.104 2.769.782 2.638Zm-2.503-4.546c.756-.287 0-2.481-.86-2.063-.782.418.078 2.35.86 2.063Zm-5.11 5.591c.886-.392.208-2.482-.991-2.037-1.252.444-.26 2.586.99 2.037Zm3.52 8.91c.182.444.625.835 1.095.783 1.017-.156 1.486-1.96.99-3.213-.234-.601-.808-.915-1.251-.732-.939.392-1.33 2.038-.834 3.161Zm3.859-2.796c.99-.235.678-3.057-.418-2.691-.964.34-.547 2.9.418 2.69Zm2.45-2.273c1.356-.34.757-4.285-.703-3.736-1.2.444-.678 4.076.703 3.736Zm-10.35 8.36c.156.392.52.836 1.042.862 1.382.079 2.243-1.855 1.982-2.952-.209-.914-.913-1.489-1.877-1.097-1.017.392-1.721 1.855-1.148 3.187Zm-1.904-4.023c.86.653 2.242.026 2.633-.94.496-1.229-.365-3.24-1.877-2.744-1.46.444-2.06 2.665-.756 3.684Zm-1.538-4.703c1.747-.392 1.12-3.344-.73-2.665-1.382.497-.991 3.031.73 2.665Zm-2.764-3.788c2.268-.888.678-4.154-1.46-3.632-2.686.627-1.252 4.703 1.46 3.632Zm3.207-3.501c1.773-.235.652-3.213-1.017-2.613-1.46.523-.287 2.796 1.017 2.613Zm2.998-3.083c1.095-.157.157-2.586-1.043-2.038-1.043.47.157 2.169 1.043 2.038Zm.73-3.971c.287 1.071 2.32 2.247 2.269.732-.026-.993-1.252-2.117-1.956-1.803-.39.183-.443.68-.313 1.071Zm4.72 23.461c0 .732.182 1.725.782 1.75 1.069.053 1.669-1.724 1.538-2.82-.104-.863-.521-1.438-1.173-1.203-.808.261-1.147 1.307-1.147 2.273Zm3.128-2.247c.105.288.313.601.626.575.756-.026 1.252-1.593.913-2.612-.157-.47-.548-.706-.834-.627-.678.182-1.096 1.645-.705 2.664Zm2.425-5.225c-.313.627-.443 3.318.704 3.266.913-.026 1.2-1.672 1.07-2.56-.131-.915-.6-1.594-1.252-1.28-.209.104-.443.391-.522.574Zm2.112-.731c.157.679.522 1.332 1.043 1.28.939-.105 1.304-1.934.965-3.057-.235-.81-.782-1.15-1.225-1.019-.809.261-1.043 1.698-.783 2.796Zm-15.8 16.46c.443 1.514 1.981.757 2.607 0 .287-.34.574-.89.73-1.386.287-.914.209-2.873-1.33-2.482-1.434.366-2.425 2.482-2.007 3.867Zm5.11-6.924c-.573.574-1.251 2.038-.782 3.213.13.288.417.706.886.732 1.539.13 2.347-2.247 2.217-3.24-.105-.967-.652-1.41-1.356-1.254-.391.104-.756.34-.965.549Zm-6.727 2.56c.365.444 1.147.653 1.956.183 1.147-.653 2.19-2.9 1.043-4.076-.313-.313-.965-.444-1.539-.235-1.486.523-2.555 2.796-1.46 4.128Zm-2.946-6.453c-.235 1.202.652 2.43 2.034 2.142 1.642-.34 2.763-2.821 1.381-3.971-.365-.313-1.12-.392-1.642-.209a2.801 2.801 0 0 0-1.773 2.038Zm-2.503-3.161c1.12 1.358 3.39-.236 3.311-1.463-.052-1.124-1.069-1.646-1.93-1.49-1.407.34-2.32 1.83-1.381 2.953Zm-3.729-4.128c1.434 1.907 5.163-.105 4.276-2.169-.495-1.123-1.747-1.384-2.868-1.019-1.303.418-2.373 1.907-1.408 3.188Zm-4.25-6.427c-.26.365-.573 1.228-.13 1.96 1.434 2.429 6.753.26 4.563-2.43-.782-.993-2.347-.837-3.103-.575-.756.26-1.095.705-1.33 1.045Zm30.298 4.702c1.434-.313.573-4.31-.86-3.762-1.278.497-.444 4.05.86 3.762Zm-2.138-4.389c1.303-.496-.026-4.31-1.382-3.631-1.174.574.026 4.154 1.382 3.631Zm-2.894-4.78c.782-.34-.261-3.084-1.252-2.483-.86.497.417 2.848 1.252 2.482Zm-4.355-4.338c.835 1.02 2.034 1.071 1.8-.366-.183-1.228-1.409-2.743-2.243-2.43-1.017.366 0 2.247.443 2.796Zm-13.714 8.151c3.259-.313 1.381-4.728-1.356-3.605-2.086.836-.913 3.814 1.355 3.605Zm1.538-5.669c-.417 1.672 2.425 3.684 3.546 2.064.99-1.437-1.278-3.449-2.738-2.9-.47.157-.756.523-.808.836Zm5.606-.731c1.12-.497-.574-2.953-1.825-2.3-1.174.627.73 2.796 1.825 2.3Zm-.365-5.095c-.34 1.045.912 2.456 1.799 2.822.808.34 1.564-.053 1.564-.706-.026-1.254-1.773-3.083-2.972-2.534-.209.104-.365.261-.391.418Zm1.512-2.639c.078 1.359 1.903 3.11 2.92 2.77.522-.183.548-.81.235-1.568-.34-.836-1.721-2.299-2.686-1.907-.339.13-.495.418-.469.705Zm-6.05-.862c.027 1.333 2.06 2.978 3.182 2.56.391-.13.47-.653.365-1.07-.26-1.124-2.086-2.666-3.129-2.143a.744.744 0 0 0-.417.653Zm6.962-2.247c.157.732.6 1.359 1.252 1.986.782.784 2.555 1.62 2.294-.026-.13-.732-.625-1.463-1.199-2.038-.547-.549-1.538-1.228-2.086-.915-.339.183-.339.654-.26.993Zm-5.631-.731c.104 1.332 2.268 3.344 3.441 2.847.626-.26.209-1.463-.234-2.064-.418-.548-1.121-1.175-1.617-1.384-.339-.157-.913-.261-1.277-.052-.261.13-.34.444-.313.653Zm1.069-2.691c.39 1.019 1.486 2.064 2.294 2.43 1.043.496 1.695-.027 1.2-1.202-.392-.993-2.269-3.005-3.286-2.535-.47.183-.417.706-.208 1.307Z",
    fill: props.color,
    stroke: props.color
  })), /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "spectrum-health_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: props.color,
    transform: "translate(0 .176)",
    d: "M0 0h170v58H0z",
    stroke: props.color
  }))));
};
/* harmony default export */ var spectrum_health = (SvgSpectrumHealth);
;// CONCATENATED MODULE: ./components/landing/SelectedClients/svg/starface.svg
function starface_extends() { starface_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return starface_extends.apply(this, arguments); }

var SvgStarface = function SvgStarface(props) {
  return /*#__PURE__*/react.createElement("svg", starface_extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/react.createElement("g", {
    opacity: 0.5,
    fill: "#fff"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M183.684 17.963c1.783-.8 3.612-1.63 3.397-4.013-.23-2.459-2.413-2.782-4.289-3.504 2.614-.17 5.165-.092 7.394-1.568 1.86-1.26 2.844-4.627-.215-6.287-5.319-2.598-17.985-3.551-19.445 4.043-.492 4.457-2.045 14.94 1.568 18.015 3.858 3.52 17.708 4.12 19.906-1.399v-1.23c-1.414-3.304-5.119-3.75-8.316-4.057ZM117.661 2.191C115.586.792 113.034.346 110.59.008c-4.688-.092-11.82.507-12.697 6.257-.722 5.41-.969 11.098.676 16.34 1.092 5.042 9.131 6.38 11.068 1.306.769-1.983.43-4.258.154-6.271 2.06-.57 4.458-.846 5.211-3.105.937-2.46-1.414-4.212-3.736-4.72 2.106-.322 4.274-.184 6.134-1.445 2.398-1.506 2.582-4.58.261-6.179ZM45.23 15.872c-.492 3.458-1.276 8.546 2.398 10.53 4.473 2.06 8.316-.646 9.976-5.289 1.276 7.748 12.943 8.086 12.574-.276C69.702-.883 50.948-9.4 45.23 15.872Zm12.39.369c-1.999.107-1.86-2.936.03-2.921 1.83-.062 2.014 3.043-.03 2.92ZM118.353 15.057c-.615 3.69-1.675 9.254 2.321 11.375 4.566 1.983 8.255-.768 9.9-5.334.768 6.671 11.605 8.593 12.42 1.168.646-6.702-1.537-13.373-5.78-18.553-8.516-9.592-17.431 2.659-18.861 11.344Zm12.282 1.184c-1.998.153-1.937-2.89-.046-2.921 1.829-.108 2.075 2.997.046 2.92ZM81.876.838c-11.437.385-11.867 17.632-7.086 24.81 3.781 4.028 9.853.846 8.87-4.642.06 0 .107-.015.168-.015 1.384 2.444 2.829 5.35 5.657 6.349 2.66.814 5.81-1.507 6.057-4.443.307-2.828-1.799-4.873-3.567-6.733C97.217 7.986 91.222-.238 81.876.838Zm1.706 12.467c-1.952.092-1.844-2.967.062-2.92 1.829-.047 1.952 3.043-.062 2.92Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/react.createElement("path", {
    d: "M163.869 16.195c-2.06-.047-5.519.676-6.134-1.953-.661-3.212 2.967-3.32 5.257-2.828 5.534.968 7.333-7.133 2.629-9.285-6.917-3.397-17.155-1.675-20.137 6.088-3.812 10.299 2.29 19.63 13.496 19.045 2.122.016 4.089-.2 5.98-.968 4.98-1.783 4.904-10.115-1.091-10.1ZM17.73 12.736c-1.937-1.445-3.982-1.983-6.38-2.66 2.09-.015 4.074-.061 5.95-1.06 3.273-1.584 2.474-6.38-.877-7.302C13.748.669 10.95.746 8.168.976c-9.315.784-9.5 13.481-.722 15.618-2.92-.046-6.871.722-7.333 3.874-1.214 6.41 7.625 7.332 12.236 6.486 6.533-.4 11.944-8.7 5.38-14.218Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/react.createElement("path", {
    d: "M45.553 5.972c.184-4.135-4.504-5.15-7.948-5.257-4.334-.385-8.639-.308-12.897.692-2.797.645-4.411 2.797-4.288 5.687-.047 3.597 4.211 4.72 7.516 4.612-.4 5.272-2.351 15.448 5.519 15.571 7.532-.338 5.626-10.76 5.211-15.879 3.474.108 6.933-1.506 6.887-5.426Z",
    fill: props.color,
    stroke: props.color
  })));
};
/* harmony default export */ var starface = (SvgStarface);
;// CONCATENATED MODULE: ./components/landing/SelectedClients/svg/superplastic.svg
function superplastic_extends() { superplastic_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return superplastic_extends.apply(this, arguments); }

var SvgSuperplastic = function SvgSuperplastic(props) {
  return /*#__PURE__*/react.createElement("svg", superplastic_extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#superplastic_svg__a)",
    fill: "#fff",
    opacity: 0.5
  }, /*#__PURE__*/react.createElement("path", {
    d: "M8.58 15.4 5.246 9.99l2.546-.855L0 .1l3.185 7.246-2.198.805 3.334 5.423-2.558.842 7.804 9.038-3.197-7.26 2.21-.793ZM178.67 9.232l2.546.856-3.334 5.41 2.21.793-3.197 7.26 7.804-9.038-2.558-.843 3.334-5.422-2.198-.806 3.185-7.246-7.792 9.036ZM155.028 1.351h3.615a.33.33 0 0 1 .318.33v21.805a.33.33 0 0 1-.318.33h-3.615a.324.324 0 0 1-.225-.1.334.334 0 0 1-.092-.23V1.683a.333.333 0 0 1 .095-.225.323.323 0 0 1 .222-.097v-.01ZM167.546 4.933c1.075 0 1.628.694 1.693 2.477a.298.298 0 0 0 .102.245.278.278 0 0 0 .257.053l3.42-.594c.228-.034.293-.198.293-.397-.195-3.766-2.28-5.681-5.828-5.681-2.931 0-4.723 1.32-5.504 3.732-.293.959-.423 1.982-.423 7.797 0 5.816.13 6.839.423 7.797.783 2.417 2.573 3.733 5.504 3.733 3.55 0 5.633-1.916 5.828-5.682 0-.198-.065-.364-.293-.396l-3.42-.595a.277.277 0 0 0-.337.163.298.298 0 0 0-.022.135c-.065 1.784-.618 2.478-1.693 2.478-.782 0-1.238-.33-1.464-1.025-.131-.496-.196-.892-.196-6.604 0-5.713.065-6.112.196-6.605.228-.695.683-1.025 1.464-1.025v-.006ZM152.342 1.351h-11.633a.306.306 0 0 0-.306.201.317.317 0 0 0-.02.13V4.92a.309.309 0 0 0 .326.322h3.491a.172.172 0 0 1 .188.118.18.18 0 0 1 .007.08v18.043a.324.324 0 0 0 .087.236.307.307 0 0 0 .23.094h3.615a.302.302 0 0 0 .231-.094.311.311 0 0 0 .087-.236V5.448a.175.175 0 0 1 .125-.19.17.17 0 0 1 .081-.003h3.491a.304.304 0 0 0 .228-.092.315.315 0 0 0 .09-.23V1.682a.324.324 0 0 0-.087-.237.308.308 0 0 0-.231-.094ZM90.547 1.351h-5.212a.304.304 0 0 0-.23.094.313.313 0 0 0-.087.236v21.805a.315.315 0 0 0 .192.308c.04.016.083.023.126.022h3.614a.304.304 0 0 0 .236-.091.314.314 0 0 0 .09-.24V15.69a.178.178 0 0 1 .049-.149.172.172 0 0 1 .146-.05h1.074c3.94 0 6.507-1.98 6.507-7.068 0-5.088-2.473-7.07-6.507-7.07h.002Zm-.317 10.297h-.951a.17.17 0 0 1-.146-.05.178.178 0 0 1-.05-.148V5.306a.178.178 0 0 1 .05-.148.173.173 0 0 1 .146-.05h.944c1.662 0 2.38.727 2.38 3.27 0 2.544-.721 3.27-2.38 3.27h.007ZM109.377 19.914h-5.593a.171.171 0 0 1-.188-.118.182.182 0 0 1-.008-.08V1.682a.316.316 0 0 0-.089-.24.31.31 0 0 0-.236-.09H99.64a.304.304 0 0 0-.23.093.313.313 0 0 0-.087.237v21.804a.315.315 0 0 0 .192.308c.04.016.082.023.125.022h9.737a.302.302 0 0 0 .231-.094.311.311 0 0 0 .087-.236v-3.238a.312.312 0 0 0-.318-.334ZM134.965 10.487l-1.335-.528c-1.726-.694-2.075-1.223-2.075-2.908 0-1.52.554-2.246 1.693-2.246s1.727.827 1.758 2.444c0 .198.159.298.359.264l3.321-.528a.326.326 0 0 0 .221-.12.34.34 0 0 0 .073-.244c-.159-3.535-1.987-5.584-5.862-5.584s-5.862 2.18-5.862 6.244c0 3.6 1.074 5.286 4.2 6.509l1.335.528c1.661.66 2.052 1.355 2.052 3.336 0 1.982-.554 2.676-1.758 2.676-1.27 0-1.857-.826-1.922-2.9 0-.198-.13-.298-.359-.264l-3.491.563c-.195.033-.26.16-.26.364.065 3.866 1.987 6.012 5.992 6.012 4.396 0 6.122-2.378 6.122-6.971 0-3.799-1.173-5.452-4.2-6.64l-.002-.007ZM120.672 1.351h-3.844c-.195 0-.294.132-.359.33l-4.819 21.803a.247.247 0 0 0-.008.124.248.248 0 0 0 .268.206h3.617a.33.33 0 0 0 .249-.087.347.347 0 0 0 .109-.243l.753-4.063h4.2l.719 4.063a.335.335 0 0 0 .359.33h3.608a.249.249 0 0 0 .269-.206.272.272 0 0 0-.008-.124l-4.761-21.802a.363.363 0 0 0-.116-.237.35.35 0 0 0-.243-.094h.007Zm-3.596 14.621 1.466-7.797h.098l1.4 7.797h-2.964ZM79.627 13.954c1.532-1.057 2.476-2.908 2.476-5.748 0-4.994-2.54-6.87-6.481-6.87h-5.277a.304.304 0 0 0-.235.09.314.314 0 0 0-.09.24V23.47a.316.316 0 0 0 .198.31c.04.016.084.023.127.02h3.615a.303.303 0 0 0 .236-.091.314.314 0 0 0 .09-.24V15.21a.178.178 0 0 1 .049-.148.172.172 0 0 1 .146-.05h1.238l2.515 8.524c.014.083.06.157.126.206.067.05.15.07.233.058H82.5c.159 0 .229-.161.159-.33l-3.033-9.516ZM75.49 11.28h-.945a.17.17 0 0 1-.146-.05.176.176 0 0 1-.049-.149V5.335a.178.178 0 0 1 .05-.149.173.173 0 0 1 .145-.05h.945c1.661 0 2.38.727 2.38 3.073 0 2.345-.719 3.072-2.38 3.072ZM39.758 1.337h-3.615a.304.304 0 0 0-.23.094.313.313 0 0 0-.087.236V18.25c0 1.189-.62 1.95-1.727 1.95-1.107 0-1.693-.761-1.693-1.95V1.667a.317.317 0 0 0-.087-.236.309.309 0 0 0-.23-.094h-3.631a.304.304 0 0 0-.306.2.315.315 0 0 0-.02.13v16.055c0 4.229 2.28 6.376 5.96 6.376s5.993-2.147 5.993-6.376V1.667a.316.316 0 0 0-.193-.308.303.303 0 0 0-.124-.022h-.01ZM67.254 1.337h-9.672a.303.303 0 0 0-.236.09.313.313 0 0 0-.09.24V23.47a.315.315 0 0 0 .198.31c.04.016.084.022.128.02h9.672a.304.304 0 0 0 .306-.201.317.317 0 0 0 .02-.13v-3.233a.316.316 0 0 0-.2-.303.305.305 0 0 0-.126-.019h-5.537a.17.17 0 0 1-.146-.05.176.176 0 0 1-.049-.148v-5.1a.178.178 0 0 1 .049-.149.172.172 0 0 1 .146-.05h4.788a.305.305 0 0 0 .303-.195.315.315 0 0 0 .022-.127V10.85a.315.315 0 0 0-.2-.303.303.303 0 0 0-.125-.019h-4.788a.17.17 0 0 1-.146-.05.176.176 0 0 1-.049-.148V5.432a.178.178 0 0 1 .049-.149.173.173 0 0 1 .146-.05h5.537a.303.303 0 0 0 .236-.09.313.313 0 0 0 .09-.24V1.667a.317.317 0 0 0-.199-.31.303.303 0 0 0-.127-.02ZM21.683 10.487l-1.335-.528c-1.726-.695-2.083-1.223-2.083-2.908 0-1.52.554-2.246 1.693-2.246 1.14 0 1.727.827 1.758 2.446 0 .198.159.298.359.264l3.315-.529a.329.329 0 0 0 .22-.12.339.339 0 0 0 .073-.244c-.158-3.534-1.986-5.583-5.861-5.583-3.876 0-5.858 2.18-5.858 6.244 0 3.6 1.076 5.285 4.202 6.51l1.335.528c1.661.66 2.052 1.355 2.052 3.336 0 1.982-.554 2.676-1.759 2.676-1.269 0-1.856-.826-1.921-2.9 0-.198-.13-.297-.359-.264l-3.491.563c-.195.033-.26.16-.26.364.065 3.866 1.986 6.012 5.992 6.012 4.396 0 6.122-2.378 6.122-6.97 0-3.8-1.173-5.452-4.2-6.641l.006-.01ZM48.49 1.337h-5.212a.303.303 0 0 0-.236.09.313.313 0 0 0-.09.24V23.47a.315.315 0 0 0 .199.31c.04.016.084.022.127.02h3.615a.305.305 0 0 0 .306-.201.319.319 0 0 0 .02-.13v-7.796a.178.178 0 0 1 .048-.149.172.172 0 0 1 .146-.05h1.075c3.94 0 6.506-1.981 6.506-7.068 0-5.088-2.468-7.07-6.506-7.07h.001Zm-.13 10.34h-.945a.17.17 0 0 1-.146-.05.176.176 0 0 1-.05-.148V5.333a.178.178 0 0 1 .05-.148.172.172 0 0 1 .146-.05h.944c1.662 0 2.38.727 2.38 3.27 0 2.544-.717 3.27-2.38 3.27v.002Z",
    fill: props.color,
    stroke: props.color
  })), /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "superplastic_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: props.color,
    transform: "translate(0 .1)",
    d: "M0 0h186.462v24H0z",
    stroke: props.color
  }))));
};
/* harmony default export */ var superplastic = (SvgSuperplastic);
;// CONCATENATED MODULE: ./components/landing/SelectedClients/svg/third-eye-health.svg
function third_eye_health_extends() { third_eye_health_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return third_eye_health_extends.apply(this, arguments); }

var SvgThirdEyeHealth = function SvgThirdEyeHealth(props) {
  return /*#__PURE__*/react.createElement("svg", third_eye_health_extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/react.createElement("g", {
    opacity: 0.5,
    fill: "#fff"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M51.174 16.596c1.634-.053 3.276 0 4.9-.16 3.88-.371 6.732-3.605 6.938-7.744.205-4.085-2.296-7.618-6.123-8.285C54.82.048 52.679.121 50.602 0c-.134.338-.18.401-.18.464-.01 5.15-.012 10.298-.033 15.448-.002.59.3.698.785.681v.003Zm1.83-14.085c2.57-.02 5.021.109 6.528 2.51 1.308 2.085 1.339 4.329.102 6.441-1.469 2.511-3.922 2.858-6.63 2.647V2.511ZM78.306 48.487v6.31h-6.98V48.49h-2.414v16.335h2.447V57.31h6.96v7.52h2.406V48.485h-2.421l.002.002ZM15.66 9.02h6.95v7.475h2.428V.188h-2.476V6.46h-6.947V.177H13.2v16.32h2.457V9.02h.002ZM11.62 54.794H4.725v-6.318H2.307v16.351h2.448v-7.51h6.95v7.485h2.419V48.508H11.62v6.286ZM43.022 9.435c2.284-.99 3.293-2.76 2.996-5.254-.245-2.058-1.71-3.55-4.045-3.863-1.607-.216-3.247-.195-4.964-.285v16.565c.526 0 .978-.044 1.418.008.842.1 1.078-.249 1.051-1.063-.056-1.636-.018-3.274-.008-4.91 0-.24.071-.479.159-1.035 1.408 2.033 2.63 3.797 3.852 5.564 1.076 1.555 1.914 1.833 3.922 1.229l-4.822-6.728c.196-.102.316-.171.44-.228Zm-3.498-1.824V2.528c1.409 0 2.81-.146 3.715 1.137.608.858.573 1.888-.008 2.75-.878 1.303-2.265 1.238-3.709 1.196h.002ZM29.361 64.901c.625 0 1.072-.052 1.5.01.905.132 1.417-.215 1.703-1.086.236-.723.646-1.387.915-2.102.228-.603.573-.846 1.24-.817 1.32.055 2.642.017 3.965.017 1.397 0 2.364.629 2.902 1.887.635 1.489 1.836 2.162 3.602 2.02-2.582-5.812-5.119-11.52-7.758-17.465-2.747 5.974-5.37 11.671-8.067 17.536h-.002Zm5.596-6.435c.796-1.776 1.548-3.46 2.425-5.415.836 1.94 1.567 3.635 2.336 5.415h-4.761ZM21.12 57.066h6.175v-2.392h-6.172v-3.895h6.348v-2.312h-8.857v16.347h8.861v-2.328h-6.354v-5.42h-.002ZM11.193 38.314h-6.37v-5.409h6.159v-2.399H4.824v-3.88h6.348v-2.285H2.305v16.29h8.888v-2.319.002ZM37.925 38.34H31.57v-5.446h6.193v-2.369h-6.19v-3.87h6.36v-2.308h-8.88v16.32h8.873v-2.33.002ZM18.812 37.067c-.123 1.19-.02 2.402-.02 3.585h2.467c.023-.238.048-.405.054-.575.061-2.252-.298-4.623.297-6.72.61-2.147 2.156-4.027 3.293-6.024.292-.514.587-1.028.877-1.544.251-.443.498-.889.842-1.507-.605 0-1.021.052-1.418-.01-1.08-.167-1.697.28-2.188 1.25-.877 1.729-1.895 3.39-2.956 5.26-1.17-2.06-2.221-3.943-3.312-5.8-.169-.288-.503-.629-.798-.666-.742-.095-1.504-.032-2.47-.032 1.27 2.232 2.338 4.342 3.628 6.308 1.314 2.002 1.951 4.08 1.704 6.475ZM3.669 16.532h2.5V2.467h3.634V.19H0v2.336h3.669v14.006ZM56.282 50.82h3.68v14.017h2.511V50.825h3.617v-2.33h-9.81v2.324h.002ZM50.186 48.483h-2.405v16.335h7.123v-2.343h-4.718V48.483ZM32.577 15.24c0-4.595.002-9.19.004-13.786V.169h-2.459v16.374c.418.019.76.046 1.103.05.901.006 1.353-.445 1.354-1.354h-.002ZM59.105 26.349c-3.387.185-5.953 1.81-7.658 4.91l1.4.687c1.563-2.708 3.849-4.066 6.887-4.062 3.073.006 5.348 1.46 6.953 4.076l1.377-.735c-2.115-3.464-5.088-5.092-8.957-4.879l-.002.003Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/react.createElement("path", {
    d: "M63.118 33.036a3.362 3.362 0 0 0-3.343-3.408 3.357 3.357 0 0 0-3.397 3.354 3.367 3.367 0 0 0 3.343 3.412 3.369 3.369 0 0 0 3.397-3.358Zm-5.173-.065c.01-.98.827-1.767 1.822-1.759a1.756 1.756 0 0 1 1.763 1.803c-.012.986-.835 1.8-1.807 1.785-.963-.015-1.788-.863-1.778-1.829Z",
    fill: props.color,
    stroke: props.color
  })));
};
/* harmony default export */ var third_eye_health = (SvgThirdEyeHealth);
;// CONCATENATED MODULE: ./components/landing/SelectedClients/svg/tovala.svg
function tovala_extends() { tovala_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tovala_extends.apply(this, arguments); }

var SvgTovala = function SvgTovala(props) {
  return /*#__PURE__*/react.createElement("svg", tovala_extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/react.createElement("g", {
    opacity: 0.5,
    fill: "#fff"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M134.862 23.415V1.272h2.924v19.554h11.086v2.589h-14.01Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m117.076 1.272-8.498 22.112h2.924l1.827-4.751h10.66l1.919 4.751h3.046l-8.62-22.112h-3.258Zm1.583 3.442-4.355 11.3h8.772l-4.417-11.3ZM162.121 1.242l-8.497 22.112h2.924l1.827-4.751h10.66l1.919 4.75H174l-8.62-22.11h-3.259Zm1.584 3.442-4.355 11.3h8.772l-4.417-11.3Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/react.createElement("path", {
    d: "m95.465 23.476-8.42-22.234h3.143l6.863 18.366 6.833-18.366h3.081l-8.328 22.234h-3.172Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.657 12.328c.146-9.137 6.76-11.4 10.048-11.39v2.437c-2.37.038-6.96 1.859-7.064 8.93-.103 7.074 4.608 8.924 7.064 8.977v2.498c-3.41-.01-10.195-2.315-10.048-11.452Zm10.049 8.954v2.498c3.41-.01 10.195-2.315 10.048-11.452-.147-9.137-6.76-11.4-10.048-11.39v2.437h.09v-.001c2.342-.008 7.052 1.767 7.156 8.93.105 7.164-4.726 8.97-7.155 8.979l-.091-.001Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/react.createElement("path", {
    d: "M0 1.242h7.492v7.492H0zM0 15.983h7.492v7.492H0zM14.741 1.242h7.492v7.492h-7.492zM14.741 15.983h7.492v7.492h-7.492zM40.629 3.861V1.272h18v2.59h-7.432v19.553h-2.954V3.86H40.63Z",
    fill: props.color,
    stroke: props.color
  })));
};
/* harmony default export */ var tovala = (SvgTovala);
;// CONCATENATED MODULE: ./components/landing/SelectedClients/index.tsx

function SelectedClients_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-height: 80svh;\n  "
    ]);
    SelectedClients_templateObject = function() {
        return data;
    };
    return data;
}
function SelectedClients_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  min-height: 100svh;\n  align-content: center;\n  justify-content: center;\n  padding: 6rem 0;\n  max-width: 100vw;\n  overflow: hidden;\n\n  ",
        "\n"
    ]);
    SelectedClients_templateObject1 = function() {
        return data;
    };
    return data;
}
function SelectedClients_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 5.625rem;\n    letter-spacing: -0.28125rem;\n    line-height; 1.1 !important;\n    max-width: unset;\n  "
    ]);
    SelectedClients_templateObject2 = function() {
        return data;
    };
    return data;
}
function SelectedClients_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: 3.25rem;\n  font-family: SpaceGroteskLight;\n  letter-spacing: -0.13rem;\n  line-height; 1.1 !important;\n  font-weight: 400;\n  max-width: 300px;\n  margin: 0 auto;\n\n  ",
        "\n"
    ]);
    SelectedClients_templateObject3 = function() {
        return data;
    };
    return data;
}
function SelectedClients_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    gap: 5rem;\n    max-width: 600px;\n  "
    ]);
    SelectedClients_templateObject4 = function() {
        return data;
    };
    return data;
}
function SelectedClients_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 4rem;\n    grid-template-columns: repeat(3, 1fr);\n    max-width: 1200px;\n  "
    ]);
    SelectedClients_templateObject5 = function() {
        return data;
    };
    return data;
}
function SelectedClients_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-columns: repeat(4, 1fr);\n  "
    ]);
    SelectedClients_templateObject6 = function() {
        return data;
    };
    return data;
}
function SelectedClients_templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  list-style-type: none;\n  margin-top: 3rem;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 2rem;\n  padding-right: 2rem;\n  gap: 1rem;\n  grid-template-columns: repeat(2, 1fr);\n  align-items: center;\n  justify-content: center;\n  justify-items: center;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    SelectedClients_templateObject7 = function() {
        return data;
    };
    return data;
}
function SelectedClients_templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    SelectedClients_templateObject8 = function() {
        return data;
    };
    return data;
}
function SelectedClients_templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    svg {\n      transform: unset;\n    }\n  "
    ]);
    SelectedClients_templateObject9 = function() {
        return data;
    };
    return data;
}
function SelectedClients_templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  position: relative;\n\n  svg {\n    transform: scale(0.7);\n  }\n\n  svg path,\n  svg circle {\n    fill: #fff;\n    opacity: 0.5;\n    transition: opacity 0.2s;\n  }\n\n  svg g {\n    opacity: 1;\n  }\n\n  ",
        "\n"
    ]);
    SelectedClients_templateObject10 = function() {
        return data;
    };
    return data;
}

















const clients = [
    {
        name: "Mars",
        url: "https://www.mars.com/",
        Logo: mars,
        width: 136,
        height: 39
    },
    {
        name: "Kinship",
        url: "https://kinship.co/",
        Logo: kinship,
        width: 43,
        height: 58
    },
    {
        name: "Miracle Grow",
        url: "https://miraclegro.com",
        Logo: miracle_grow,
        width: 148,
        height: 41
    },
    {
        name: "Figo",
        url: "https://figopetinsurance.com/",
        Logo: figo,
        width: 112,
        height: 44
    },
    {
        name: "Spectrum Health",
        url: "https://www.spectrumhealth.org/",
        Logo: spectrum_health,
        width: 170,
        height: 59
    },
    {
        name: "IBM",
        url: "https://www.ibm.com/",
        Logo: ibm,
        width: 108,
        height: 43
    },
    {
        name: "Tovala",
        url: "https://www.tovala.com/",
        Logo: tovala,
        width: 174,
        height: 24
    },
    {
        name: "Third Eye Health",
        url: "https://thirdeyehealth.net/",
        Logo: third_eye_health,
        width: 81,
        height: 65
    },
    {
        name: "Plume",
        url: "https://plume.com",
        Logo: plume,
        width: 151,
        height: 39
    },
    {
        name: "Starface",
        url: "https://starface.world/",
        Logo: starface,
        width: 192,
        height: 28
    },
    {
        name: "Superplastic",
        url: "https://superplastic.co",
        Logo: superplastic,
        width: 187,
        height: 25
    },
    {
        name: "GoodFriend",
        url: "https://goodfriend.com",
        Logo: goodfriend,
        width: 165,
        height: 25
    }
];
const SelectedClients_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b8e9f5f5-0"
})(SelectedClients_templateObject1(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(SelectedClients_templateObject());
});
const Title = (0,styled_components_browser_esm/* default */.ZP)(react_spring_web_modern/* animated.h2 */.q.h2).withConfig({
    componentId: "sc-b8e9f5f5-1"
})(SelectedClients_templateObject3(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(SelectedClients_templateObject2());
});
const ClientList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-b8e9f5f5-2"
})(SelectedClients_templateObject7(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.sm(SelectedClients_templateObject4());
}, (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(SelectedClients_templateObject5());
}, (param)=>{
    let { theme: { mq  }  } = param;
    return mq.lg(SelectedClients_templateObject6());
});
const ClientListItem = (0,styled_components_browser_esm/* default */.ZP)(react_spring_web_modern/* animated.li */.q.li).withConfig({
    componentId: "sc-b8e9f5f5-3"
})(SelectedClients_templateObject8());
const ClientLink = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-b8e9f5f5-4"
})(SelectedClients_templateObject10(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.sm(SelectedClients_templateObject9());
});
const SelectedClients = ()=>{
    const { ref , scrollPercentage  } = useElementScrollPercentage({
        startAtTop: false
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectedClients_Container, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                style: {
                    opacity: scrollPercentage.value.to([
                        0.1,
                        0.4
                    ], [
                        0,
                        1
                    ])
                },
                children: "Selected Clients"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientList, {
                children: clients.map((client, i)=>{
                    const offset = 0.3 * i / clients.length;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientListItem, {
                        style: {
                            opacity: scrollPercentage.value.to([
                                0.1 + offset,
                                0.3 + offset
                            ], [
                                0,
                                1
                            ])
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientLink, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(client.Logo, {
                                width: client.width,
                                height: client.height
                            }, client.name)
                        })
                    }, client.name);
                })
            })
        ]
    });
};
/* harmony default export */ var landing_SelectedClients = (SelectedClients);

;// CONCATENATED MODULE: ./components/landing/Quote/index.tsx

function Quote_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-columns: 1fr 1fr;\n\n    @media screen and (min-height: 850px) {\n      height: 100svh;\n      padding-top: calc(1.5rem + 70px);\n      padding-bottom: 1.5rem;\n    }\n  "
    ]);
    Quote_templateObject = function() {
        return data;
    };
    return data;
}
function Quote_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: sticky;\n  top: 0;\n  margin: 0 auto;\n  max-width: 1400px;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0.25rem;\n  padding: 0 1rem;\n\n  ",
        "\n"
    ]);
    Quote_templateObject1 = function() {
        return data;
    };
    return data;
}
function Quote_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-radius: 10rem;\n  "
    ]);
    Quote_templateObject2 = function() {
        return data;
    };
    return data;
}
function Quote_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  position: relative;\n  align-self: stretch;\n  border-radius: 5rem;\n  overflow: hidden;\n\n  ",
        "\n"
    ]);
    Quote_templateObject3 = function() {
        return data;
    };
    return data;
}
function Quote_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-clip: padding-box;\n  }\n"
    ]);
    Quote_templateObject4 = function() {
        return data;
    };
    return data;
}
function Quote_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n\n  ",
        " {\n    &:after {\n      background: linear-gradient(to top, ",
        " 85%, ",
        "),\n        linear-gradient(to bottom, ",
        " 85%, ",
        ");\n    }\n  }}\n"
    ]);
    Quote_templateObject5 = function() {
        return data;
    };
    return data;
}
function Quote_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    aspect-ratio: 1/1;\n    clip-path: none !important;\n    display: none;\n\n    &:first-child {\n      display: block;\n    }\n  "
    ]);
    Quote_templateObject6 = function() {
        return data;
    };
    return data;
}
function Quote_templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    align-self: stretch;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n\n    @media screen and (max-height: 850px) {\n      height: 50svh;\n      clip-path: none !important;\n      display: none;\n\n      &:first-child {\n        display: grid;\n        height: 100%;\n      }\n    }\n  "
    ]);
    Quote_templateObject7 = function() {
        return data;
    };
    return data;
}
function Quote_templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow: hidden;\n  display: grid;\n  align-items: center;\n  justify-content: stretch;\n  width: 100%;\n  height: 100%;\n  right: 0;\n\n  &:first-child {\n    ",
        "\n  }\n\n  &:last-child {\n    ",
        "\n  }\n\n  &:nth-child(2) {\n    ",
        "\n  }\n\n  video {\n    position: relative;\n    display: block;\n    aspect-ratio: 1/1;\n    object-fit: cover;\n    max-width: 100%;\n    width: 100%;\n    background-position: left center;\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    Quote_templateObject8 = function() {
        return data;
    };
    return data;
}
function Quote_templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        background: pink;\n\n        &:first-child {\n          background: magenta;\n        }\n\n        &:last-child {\n          background: cyan;\n        }\n      }\n    "
    ]);
    Quote_templateObject9 = function() {
        return data;
    };
    return data;
}
function Quote_templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    @media screen and (min-height: 850px) {\n      height: 220svh;\n    }\n  "
    ]);
    Quote_templateObject10 = function() {
        return data;
    };
    return data;
}
function Quote_templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  ",
        "\n"
    ]);
    Quote_templateObject11 = function() {
        return data;
    };
    return data;
}
function Quote_templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-radius: 10rem;\n  "
    ]);
    Quote_templateObject12 = function() {
        return data;
    };
    return data;
}
function Quote_templateObject13() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background: #171719;\n  border-radius: 5rem;\n\n  ",
        "\n"
    ]);
    Quote_templateObject13 = function() {
        return data;
    };
    return data;
}
function Quote_templateObject14() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 5rem 4.5rem;\n  "
    ]);
    Quote_templateObject14 = function() {
        return data;
    };
    return data;
}
function Quote_templateObject15() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    transition: filter 0.2s, opacity 0.2s, transform 0.2s;\n\n    @media screen and (max-height: 850px) {\n      position: relative;\n      opacity: unset !important;\n      transform: unset !important;\n      transition: unset !important;\n      filter: unset !important;\n      display: none;\n\n      &:first-child {\n        display: block;\n      }\n    }\n  "
    ]);
    Quote_templateObject15 = function() {
        return data;
    };
    return data;
}
function Quote_templateObject16() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    opacity: unset !important;\n    transform: unset !important;\n    filter: unset !important;\n    display: none;\n\n    &:first-child {\n      display: block;\n    }\n  "
    ]);
    Quote_templateObject16 = function() {
        return data;
    };
    return data;
}
function Quote_templateObject17() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  display: grid;\n  align-content: center;\n  justify-content: center;\n  gap: 1rem;\n  padding: 5rem 2rem;\n  overflow: hidden;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    Quote_templateObject17 = function() {
        return data;
    };
    return data;
}
function Quote_templateObject18() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 2rem;\n"
    ]);
    Quote_templateObject18 = function() {
        return data;
    };
    return data;
}
function Quote_templateObject19() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 2.25rem;\n    line-height: 1.1;\n  "
    ]);
    Quote_templateObject19 = function() {
        return data;
    };
    return data;
}
function Quote_templateObject20() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0;\n  font-size: 1.5rem;\n  font-weight: 500;\n  line-height: 1.5;\n\n  ",
        "\n"
    ]);
    Quote_templateObject20 = function() {
        return data;
    };
    return data;
}
function Quote_templateObject21() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 3.875rem 0 0;\n  padding: 0;\n  color: #878787;\n  font-family: SpaceGroteskLight;\n  font-size: 1.125rem;\n  line-height: 1.2;\n  align-self: end;\n"
    ]);
    Quote_templateObject21 = function() {
        return data;
    };
    return data;
}








const Quote_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-21a2d3bb-0"
})(Quote_templateObject1(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(Quote_templateObject());
});
const ImageSlidesContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-21a2d3bb-1"
})(Quote_templateObject3(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(Quote_templateObject2());
});
const VideoEdge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-21a2d3bb-2"
})(Quote_templateObject4());
const featheredEdge = (color)=>(0,styled_components_browser_esm/* css */.iv)(Quote_templateObject5(), color, VideoEdge, (0,tinycolor/* default */.Z)(color).setAlpha(0).toRgbString(), color, (0,tinycolor/* default */.Z)(color).setAlpha(0).toRgbString(), color);
const OfficeImageContainer = (0,styled_components_browser_esm/* default */.ZP)(react_spring_web_modern/* animated.div */.q.div).withConfig({
    componentId: "sc-21a2d3bb-3"
})(Quote_templateObject8(), featheredEdge("rgba(75, 74, 77, 1)"), featheredEdge("rgba(26, 24, 22, 1)"), featheredEdge("rgba(4, 41, 62, 1)"), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.ltMd(Quote_templateObject6());
}, (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(Quote_templateObject7());
});
const SlideContainer = (0,styled_components_browser_esm/* default */.ZP)(react_spring_web_modern/* animated.section */.q.section).withConfig({
    componentId: "sc-21a2d3bb-4"
})(Quote_templateObject11(), (param)=>{
    let { $debug  } = param;
    return $debug && (0,styled_components_browser_esm/* css */.iv)(Quote_templateObject9(), OfficeImageContainer);
}, (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(Quote_templateObject10());
});
const VideoPlayer = (param)=>{
    let { innerRef , src , alt , ...props } = param;
    const { ref: videoRef , isVisible  } = hooks_useIsVisible();
    (0,react.useEffect)(()=>{
        if (videoRef.current) {
            if (isVisible) {
                videoRef.current.play();
            } else {
                videoRef.current.pause();
            }
        }
    }, [
        isVisible,
        videoRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoEdge, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
            autoPlay: true,
            muted: true,
            loop: true,
            controls: false,
            playsInline: true,
            preload: "auto",
            ref: (current)=>{
                videoRef.current = current;
                if (innerRef) {
                    innerRef.current = current;
                }
            },
            ...props,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: src,
                    type: "video/mp4"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: alt
                })
            ]
        })
    });
};
const QuoteSlidesContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-21a2d3bb-5"
})(Quote_templateObject13(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(Quote_templateObject12());
});
const QuoteContainer = (0,styled_components_browser_esm/* default */.ZP)(react_spring_web_modern/* animated.div */.q.div).withConfig({
    componentId: "sc-21a2d3bb-6"
})(Quote_templateObject17(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.lg(Quote_templateObject14());
}, (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(Quote_templateObject15());
}, (param)=>{
    let { theme: { mq  }  } = param;
    return mq.ltMd(Quote_templateObject16());
});
const QuoteIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-21a2d3bb-7"
})(Quote_templateObject18());
const QuoteText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-21a2d3bb-8"
})(Quote_templateObject20(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.xl(Quote_templateObject19());
});
const QuoteAttribution = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-21a2d3bb-9"
})(Quote_templateObject21());
const Quote = (param)=>{
    let { debug  } = param;
    const timestamp = (0,react.useRef)(0);
    const { ref , scrollPercentage  } = useElementScrollPercentage({
        startAtTop: true
    });
    const { ref: fadeRef , scrollPercentage: fadeScrollPercentage  } = useElementScrollPercentage({
        startAtTop: false,
        inertia: true
    });
    // first video that subsequent videos should sync to
    const firstVideoRef = (0,react.useRef)(null);
    const secondVideoRef = (0,react.useRef)(null);
    const thirdVideoRef = (0,react.useRef)(null);
    const syncVideos = (0,react.useCallback)(()=>{
        if (!firstVideoRef.current || !secondVideoRef.current || !thirdVideoRef.current) {
            return;
        }
        const currentTime = firstVideoRef.current.currentTime;
        secondVideoRef.current.currentTime = currentTime;
        thirdVideoRef.current.currentTime = currentTime;
    }, []);
    // keep videos in sync
    (0,react.useEffect)(()=>{
        window.addEventListener("resize", syncVideos);
        return ()=>{
            window.removeEventListener("resize", syncVideos);
        };
    }, [
        syncVideos
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideContainer, {
        $debug: debug,
        ref: ref,
        style: {
            opacity: fadeScrollPercentage.value.to([
                0.1,
                0.3
            ], [
                0,
                1
            ], "clamp")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Quote_Container, {
            ref: fadeRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageSlidesContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OfficeImageContainer, {
                            children: !debug && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayer, {
                                alt: "An iPad displaying the #Halfthestory app",
                                src: "/videos/HTS-ipad-asset.mp4",
                                innerRef: firstVideoRef,
                                onTimeUpdate: (ev)=>{
                                    const nextTime = ev.target.currentTime;
                                    if (nextTime < timestamp.current) {
                                        syncVideos();
                                    }
                                    timestamp.current = nextTime;
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OfficeImageContainer, {
                            style: {
                                maskImage: scrollPercentage.value.to([
                                    0.25,
                                    0.5
                                ], [
                                    -0.02,
                                    1
                                ], "clamp").to((val)=>"linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0) ".concat(val * 100, "%, rgba(0, 0, 0, 1) ").concat(val * 100 + 2, "%, rgba(0, 0, 0, 1))"))
                            },
                            children: !debug && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayer, {
                                alt: "An app displaying an product page",
                                src: "/videos/PbP-ipad-asset.mp4",
                                innerRef: secondVideoRef
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OfficeImageContainer, {
                            style: {
                                maskImage: scrollPercentage.value.to([
                                    0,
                                    0.25
                                ], [
                                    -0.02,
                                    1
                                ], "clamp").to((val)=>"linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0) ".concat(val * 100, "%, rgba(0, 0, 0, 1) ").concat(val * 100 + 2, "%, rgba(0, 0, 0, 1))"))
                            },
                            children: !debug && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayer, {
                                alt: "An iPad displaying the GoodFriend website",
                                src: "/videos/GF-ipad-asset.mp4",
                                innerRef: thirdVideoRef
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuoteSlidesContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuoteContainer, {
                            style: {
                                opacity: scrollPercentage.value.to((val)=>val > 0.01 ? 0 : 1),
                                y: scrollPercentage.value.to((val)=>val > 0.01 ? -50 : 0),
                                filter: scrollPercentage.value.to((val)=>"blur(".concat(val > 0.01 ? 8 : 0, "px)"))
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuoteText, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(QuoteIconContainer, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/icons/quotes.svg",
                                                width: 48,
                                                height: 34.16,
                                                alt: "quotation marks"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Our project could not have existed without the Graveflex team. They are true partners, and have deep expertise that contributed strategically to our product while executing at a high level"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(QuoteAttribution, {
                                    children: "- Christopher Gonzalez, Former Director of Product @ GoodFriend / Kinship & Current Head of Finance @ A.Team"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuoteContainer, {
                            style: {
                                opacity: scrollPercentage.value.to((val)=>{
                                    if (val < 0.01) {
                                        return 0;
                                    } else if (val > 0.25) {
                                        return 0;
                                    } else {
                                        return 1;
                                    }
                                }),
                                y: scrollPercentage.value.to((val)=>{
                                    if (val < 0.01) {
                                        return 50;
                                    } else if (val > 0.25) {
                                        return -50;
                                    } else {
                                        return 0;
                                    }
                                }),
                                filter: scrollPercentage.value.to((val)=>{
                                    if (val < 0.01) {
                                        return "blur(8px)";
                                    } else if (val > 0.25) {
                                        return "blur(8px)";
                                    } else {
                                        return "blur(0px)";
                                    }
                                })
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuoteText, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(QuoteIconContainer, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/icons/quotes.svg",
                                                width: 48,
                                                height: 34.16,
                                                alt: "quotation marks"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "We could not speak more highly for the project management of the Graveflex team. They delivered as projected, on time, and always exceeded expectations."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(QuoteAttribution, {
                                    children: "- Lauri Pastrone, Founder & CEO of Peace by Piece"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuoteContainer, {
                            style: {
                                opacity: scrollPercentage.value.to((val)=>{
                                    if (val > 0.25) {
                                        return 1;
                                    }
                                    return 0;
                                }),
                                y: scrollPercentage.value.to((val)=>{
                                    if (val > 0.25) {
                                        return 0;
                                    }
                                    return 50;
                                }),
                                filter: scrollPercentage.value.to((val)=>{
                                    if (val > 0.25) {
                                        return "blur(0px)";
                                    }
                                    return "blur(8px)";
                                })
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuoteText, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(QuoteIconContainer, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/icons/quotes.svg",
                                                width: 48,
                                                height: 34.16,
                                                alt: "quotation marks"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Their proactive approach to addressing potential flaws before they arose was commendable and ensured that our platform met the highest standards of usability and functionality."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(QuoteAttribution, {
                                    children: "- Larissa May, CEO of #HalfTheStory"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var landing_Quote = (Quote);

// EXTERNAL MODULE: ./node_modules/axios/index.js + 40 modules
var axios = __webpack_require__(50196);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/LottiePlayer/index.tsx

function LottiePlayer_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 1;\n    "
    ]);
    LottiePlayer_templateObject = function() {
        return data;
    };
    return data;
}
function LottiePlayer_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  opacity: 0;\n  transition: opacity 1s;\n\n  ",
        "\n"
    ]);
    LottiePlayer_templateObject1 = function() {
        return data;
    };
    return data;
}
function LottiePlayer_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    LottiePlayer_templateObject2 = function() {
        return data;
    };
    return data;
}






const Lottie = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(9260)]).then(__webpack_require__.t.bind(__webpack_require__, 69260, 23)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69260)
            ]
    },
    ssr: false
});
const LottiePlayer_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cbe417cb-0"
})(LottiePlayer_templateObject1(), (param)=>{
    let { $visible  } = param;
    return $visible && (0,styled_components_browser_esm/* css */.iv)(LottiePlayer_templateObject());
});
const LottiePlayer = (param)=>{
    let { src , loop , ...props } = param;
    const [lottie, setLottie] = (0,react.useState)(null);
    const lottieRef = (0,react.useRef)(null);
    const [ref, inView] = (0,react_spring_web_modern/* useInView */.YD)({
        amount: 0.2
    });
    (0,react.useEffect)(()=>{
        const fetchLottie = async ()=>{
            if (src) {
                const res = await axios/* default.get */.ZP.get(src);
                if ((res === null || res === void 0 ? void 0 : res.status) === 200) setLottie(res === null || res === void 0 ? void 0 : res.data);
            }
        };
        fetchLottie();
    }, [
        src
    ]);
    (0,react.useEffect)(()=>{
        if (inView) {
            var ref, ref1;
            (ref = lottieRef.current) === null || ref === void 0 ? void 0 : ref.setDirection(1);
            (ref1 = lottieRef.current) === null || ref1 === void 0 ? void 0 : ref1.goToAndPlay(0);
        } else {
            var ref2, ref3;
            (ref2 = lottieRef.current) === null || ref2 === void 0 ? void 0 : ref2.setDirection(-1);
            (ref3 = lottieRef.current) === null || ref3 === void 0 ? void 0 : ref3.play();
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LottiePlayer_Container, {
        ref: ref,
        $visible: inView,
        ...props,
        children: lottie && /*#__PURE__*/ (0,jsx_runtime.jsx)(Lottie, {
            lottieRef: lottieRef,
            animationData: lottie,
            loop: !!loop
        })
    });
};
/* harmony default export */ var components_LottiePlayer = ((0,styled_components_browser_esm/* default */.ZP)(LottiePlayer).withConfig({
    componentId: "sc-cbe417cb-1"
})(LottiePlayer_templateObject2()));

;// CONCATENATED MODULE: ./components/landing/ImpactCards/index.tsx

function ImpactCards_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  align-items: start;\n  justify-content: center;\n  aspect-ratio: 26.375 / 25.6875;\n\n  img {\n    margin-top: 2rem;\n    max-width: 100%;\n    object-fit: contain;\n  }\n"
    ]);
    ImpactCards_templateObject = function() {
        return data;
    };
    return data;
}
function ImpactCards_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border: dotted red 4px;\n\n      ",
        " {\n        border: dotted blanchedalmond 4px;\n      }\n    "
    ]);
    ImpactCards_templateObject1 = function() {
        return data;
    };
    return data;
}
function ImpactCards_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  width: 100%;\n  min-height: 80svh;\n  gap: 1rem;\n  padding: 6rem 1rem;\n  align-content: center;\n  font-family: SpaceGroteskLight;\n\n  ",
        "\n"
    ]);
    ImpactCards_templateObject2 = function() {
        return data;
    };
    return data;
}
function ImpactCards_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 5.625rem;\n  "
    ]);
    ImpactCards_templateObject3 = function() {
        return data;
    };
    return data;
}
function ImpactCards_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  font-size: 3.25rem;\n  font-weight: 400;\n  letter-spacing: -0.13rem;\n  text-align: center;\n\n  ",
        "\n"
    ]);
    ImpactCards_templateObject4 = function() {
        return data;
    };
    return data;
}
function ImpactCards_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-columns: repeat(3, 1fr);\n  "
    ]);
    ImpactCards_templateObject5 = function() {
        return data;
    };
    return data;
}
function ImpactCards_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n  max-width: 1200px;\n  list-style-type: none;\n  display: grid;\n  gap: 0.25rem;\n  grid-template-columns: 1fr;\n\n  ",
        "\n"
    ]);
    ImpactCards_templateObject6 = function() {
        return data;
    };
    return data;
}
function ImpactCards_templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    transform: unset !important;\n    opacity: 1 !important;\n  "
    ]);
    ImpactCards_templateObject7 = function() {
        return data;
    };
    return data;
}
function ImpactCards_templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-radius: 2.25rem;\n  "
    ]);
    ImpactCards_templateObject8 = function() {
        return data;
    };
    return data;
}
function ImpactCards_templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background-color: #171719;\n  border-radius: 2rem;\n  padding: 1rem;\n  margin-bottom: 0;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    ImpactCards_templateObject9 = function() {
        return data;
    };
    return data;
}
function ImpactCards_templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 2.8125rem;\n    height: 2.8125rem;\n  "
    ]);
    ImpactCards_templateObject10 = function() {
        return data;
    };
    return data;
}
function ImpactCards_templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 2.24rem;\n  height: 2.24rem;\n  border: solid #fff 1px;\n  border-radius: 50%;\n\n  ",
        "\n"
    ]);
    ImpactCards_templateObject11 = function() {
        return data;
    };
    return data;
}
function ImpactCards_templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 1.5rem;\n  "
    ]);
    ImpactCards_templateObject12 = function() {
        return data;
    };
    return data;
}
function ImpactCards_templateObject13() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  align-items: center;\n  grid-template-columns: 1fr max-content;\n  gap: 1rem;\n  justify-content: space-between;\n  margin: 0;\n  padding: 0;\n  font-weight: 400;\n  font-size: 1.2rem;\n\n  ",
        "\n"
    ]);
    ImpactCards_templateObject13 = function() {
        return data;
    };
    return data;
}
function ImpactCards_templateObject14() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 5.625rem;\n    font-size: clamp(3rem, 5vw, 5.625rem);\n    letter-spacing: 0;\n  "
    ]);
    ImpactCards_templateObject14 = function() {
        return data;
    };
    return data;
}
function ImpactCards_templateObject15() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0;\n  font-weight: 400;\n  font-size: 4.49269rem;\n  letter-spacing: -0.22463rem;\n  line-height: 1;\n  margin-top: 2rem;\n  font-family: SpaceGroteskRegular;\n\n  ",
        "\n"
    ]);
    ImpactCards_templateObject15 = function() {
        return data;
    };
    return data;
}
function ImpactCards_templateObject16() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 1.5rem;\n  "
    ]);
    ImpactCards_templateObject16 = function() {
        return data;
    };
    return data;
}
function ImpactCards_templateObject17() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0;\n  font-weight: 400;\n  font-size: 1.2rem;\n  line-height: 1;\n  margin-top: 1rem;\n  margin-bottom: 2rem;\n  font-family: SpaceGroteskLight;\n\n  ",
        "\n"
    ]);
    ImpactCards_templateObject17 = function() {
        return data;
    };
    return data;
}






const cards = [
    {
        heading: "Created",
        stat: "$50M+",
        label: "In shareholder value",
        icon: "/icons/created.svg",
        lottie: "/lotties/Impact-Lottie-1.json",
        width: 422,
        height: 397
    },
    {
        heading: "Converted",
        stat: "3x",
        label: "More customers",
        icon: "/icons/converted.svg",
        lottie: "/lotties/Impact-Lottie-2.json",
        width: 422,
        height: 411
    },
    {
        heading: "Helped raise",
        stat: "$100M+",
        label: "In funding",
        icon: "/icons/raised.svg",
        lottie: "/lotties/Impact-Lottie-3.json",
        width: 386,
        height: 386
    }
];
const ImpactListItemSvgContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a45c403-0"
})(ImpactCards_templateObject());
const ImpactCards_Container = (0,styled_components_browser_esm/* default */.ZP)(react_spring_web_modern/* animated.section */.q.section).withConfig({
    componentId: "sc-1a45c403-1"
})(ImpactCards_templateObject2(), (param)=>{
    let { $debug  } = param;
    return $debug && (0,styled_components_browser_esm/* css */.iv)(ImpactCards_templateObject1(), ImpactListItemSvgContainer);
});
const ImpactCards_Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-1a45c403-2"
})(ImpactCards_templateObject4(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(ImpactCards_templateObject3());
});
const ImpactList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-1a45c403-3"
})(ImpactCards_templateObject6(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(ImpactCards_templateObject5());
});
const ImpactListItem = (0,styled_components_browser_esm/* default */.ZP)(react_spring_web_modern/* animated.li */.q.li).withConfig({
    componentId: "sc-1a45c403-4"
})(ImpactCards_templateObject9(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.ltMd(ImpactCards_templateObject7());
}, (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(ImpactCards_templateObject8());
});
const Circle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a45c403-5"
})(ImpactCards_templateObject11(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(ImpactCards_templateObject10());
});
const ImpactListItemHeading = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    componentId: "sc-1a45c403-6"
})(ImpactCards_templateObject13(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.lg(ImpactCards_templateObject12());
});
const ImpactListItemStat = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-1a45c403-7"
})(ImpactCards_templateObject15(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(ImpactCards_templateObject14());
});
const ImpactListItemLabel = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-1a45c403-8"
})(ImpactCards_templateObject17(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.lg(ImpactCards_templateObject16());
});
const ImpactCards = (param)=>{
    let { debug  } = param;
    const { ref , scrollPercentage  } = useElementScrollPercentage({
        startAtTop: false
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImpactCards_Container, {
        $debug: debug,
        style: {
            opacity: scrollPercentage.value.to([
                0.1,
                0.25
            ], [
                0,
                1
            ])
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImpactCards_Title, {
                ref: ref,
                children: "Our Impact"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImpactList, {
                children: cards.map((card, i)=>{
                    const offset = 0.1 * i / cards.length;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImpactListItem, {
                        style: {
                            opacity: scrollPercentage.value.to([
                                0.1 + offset,
                                0.4 + offset
                            ], [
                                0,
                                1
                            ]),
                            y: scrollPercentage.value.to([
                                0.1,
                                0.6
                            ], [
                                100 + 200 * i,
                                0
                            ], "clamp")
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImpactListItemHeading, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: card.heading
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImpactListItemSvgContainer, {
                                children: !debug && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LottiePlayer, {
                                    src: card.lottie
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImpactListItemStat, {
                                children: card.stat
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImpactListItemLabel, {
                                children: card.label
                            })
                        ]
                    }, card.heading);
                })
            })
        ]
    });
};
/* harmony default export */ var landing_ImpactCards = (ImpactCards);

;// CONCATENATED MODULE: ./components/landing/Stars/index.tsx





const Stars = (param)=>{
    let { starsCount =1000 , starSize =0.5  } = param;
    const meshRef = (0,react.useRef)(null);
    // Generate random positions for the stars
    const starsPositions = (0,react.useMemo)(()=>{
        const positions = [];
        for(let i = 0; i < starsCount; i++){
            const r = 300 + Math.random() * 300 - 300 / 2; // Distance from the center of the scene
            const theta = three_module.MathUtils.randFloatSpread(360); // Random angle for the latitude
            const phi = three_module.MathUtils.randFloatSpread(180); // Random angle for the longitude
            const x = r * Math.sin(theta) * Math.cos(phi);
            const y = r * Math.sin(theta) * Math.sin(phi);
            const z = r * Math.cos(theta);
            positions.push(x, y, z);
        }
        return new Float32Array(positions);
    }, [
        starsCount
    ]);
    // Update loop for animation or dynamic changes
    (0,index_673ef987_esm.A)(()=>{
        if (meshRef.current) {
            // Example of dynamic update, rotate the star field slowly
            meshRef.current.rotation.x += 0.0003;
            meshRef.current.rotation.z += 0.0002;
            meshRef.current.rotation.y += 0.0002;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spring_three_modern/* animated.group */.q.group, {
        ref: meshRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("points", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("bufferGeometry", {
                    attach: "geometry",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("bufferAttribute", {
                        attach: "attributes-position",
                        count: starsPositions.length / 3,
                        array: starsPositions,
                        itemSize: 3
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("pointsMaterial", {
                    attach: "material",
                    size: starSize,
                    sizeAttenuation: true,
                    color: "#777",
                    transparent: false,
                    alphaTest: 0.5,
                    opacity: 1.0
                })
            ]
        })
    });
};
/* harmony default export */ var landing_Stars = (Stars);

;// CONCATENATED MODULE: ./components/landing/OutrunGrid.tsx

function OutrunGrid_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));\n  z-index: 1;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 20lvh;\n  z-index: 1;\n"
    ]);
    OutrunGrid_templateObject = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: linear-gradient(to top, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));\n  z-index: 1;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 20lvh;\n  z-index: 1;\n"
    ]);
    OutrunGrid_templateObject1 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  height: 100%;\n  top: 0;\n  width: 100%;\n"
    ]);
    OutrunGrid_templateObject2 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: sticky;\n  top: 0;\n  height: 100lvh;\n  width: 100%;\n"
    ]);
    OutrunGrid_templateObject3 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border: dotted blue 4px;\n\n      ",
        " {\n        border: dotted blanchedalmond 4px;\n      }\n    "
    ]);
    OutrunGrid_templateObject4 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: 350lvh;\n  width: 100%;\n\n  ",
        "\n"
    ]);
    OutrunGrid_templateObject5 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 30lvh;\n  height: 200lvh;\n  width: 100%;\n"
    ]);
    OutrunGrid_templateObject6 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    h4 {\n      font-size: 1.375rem;\n      letter-spacing: 0.055rem;\n    }\n\n    p {\n      font-size: 5.625rem;\n      letter-spacing: -0.28125rem;\n    }\n\n    ",
        " {\n      margin-top: 2rem;\n    }\n  "
    ]);
    OutrunGrid_templateObject7 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-color: pink;\n  position: sticky;\n  top: 0;\n  height: 100lvh;\n  width: 100%;\n  display: grid;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  text-align: center;\n  z-index: 2;\n\n  h4 {\n    color: #878787;\n    font-size: 1.125rem;\n    font-weight: 700;\n    letter-spacing: 0.045rem;\n    text-transform: uppercase;\n    font-family: SpaceMonoRegular;\n  }\n\n  p {\n    font-size: 8vw;\n    font-weight: 400;\n    color: #fff;\n    line-height: 1.1;\n  }\n\n  ",
        " {\n    margin-top: 1rem;\n    width: auto;\n    justify-self: center;\n  }\n\n  ",
        "\n"
    ]);
    OutrunGrid_templateObject8 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 2rem;\n  "
    ]);
    OutrunGrid_templateObject9 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100lvh;\n  position: sticky;\n  display: grid;\n  align-content: space-between;\n  justify-items: center;\n  top: 0;\n  width: 100%;\n  padding: 0.5rem;\n  z-index: 2;\n\n  ",
        "\n"
    ]);
    OutrunGrid_templateObject10 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-columns: 1fr max-content;\n  "
    ]);
    OutrunGrid_templateObject11 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: calc(100% - 4rem);\n    padding: 1.5rem;\n    grid-template-columns: 1fr 1fr 1fr max-content;\n    justify-content: space-between;\n    gap: 2rem;\n  "
    ]);
    OutrunGrid_templateObject12 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject13() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: solid #666 1px;\n  background: rgba(0, 0, 0, 0.5);\n  position: relative;\n  left: 0;\n  bottom: 0;\n  margin: 1rem;\n  width: calc(100% - 2rem);\n  max-width: 1200px;\n  padding: 1rem;\n  border-radius: 1rem;\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: 1fr max-content;\n\n  ",
        "\n\n  ",
        "\n\n  small {\n    color: #878787;\n    font-size: 0.75rem;\n    line-height: 1;\n  }\n\n  a {\n    transition: opacity 0.2s;\n    opacity: 1;\n    font-family: SpaceGroteskLight;\n    font-weight: 300;\n\n    &:hover {\n      opacity: 0.8;\n    }\n\n    &:focus {\n      opacity: 0.7;\n    }\n  }\n"
    ]);
    OutrunGrid_templateObject13 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject14() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    &:first-child, &:last-child {\n      grid-column: span 2;\n    }\n  "
    ]);
    OutrunGrid_templateObject14 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject15() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      justify-content: space-between;\n      grid-template-columns: 1fr max-content;\n      text-align: left;\n    "
    ]);
    OutrunGrid_templateObject15 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject16() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    &:nth-child(2) {\n      text-align: right;\n      justify-content: end;\n    }\n  "
    ]);
    OutrunGrid_templateObject16 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject17() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-rows: 3rem max-content;\n  "
    ]);
    OutrunGrid_templateObject17 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject18() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  align-content: space-between;\n\n  ",
        "\n\n  &:last-child {\n    text-align: right;\n    justify-content: end;\n\n    ",
        "\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    OutrunGrid_templateObject18 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject19() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.125rem;\n  color: #878787;\n  padding: 0;\n  margin: 0;\n  line-height: 0.9;\n"
    ]);
    OutrunGrid_templateObject19 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject20() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style-type: none;\n  font-size: 1.125rem;\n  align-self: end;\n"
    ]);
    OutrunGrid_templateObject20 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject21() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n"
    ]);
    OutrunGrid_templateObject21 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject22() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: calc(100% - 4rem);\n    margin: 2rem auto;\n    padding: 2rem 0;\n  "
    ]);
    OutrunGrid_templateObject22 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject23() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: sticky;\n  overflow: hidden;\n  top: 70px;\n  left: 0;\n  width: calc(100% - 2rem);\n  max-width: 100vw;\n  margin: 0 1rem;\n  max-width: 1200px;\n  padding: 1rem 0;\n\n  ",
        "\n"
    ]);
    OutrunGrid_templateObject23 = function() {
        return data;
    };
    return data;
}
function OutrunGrid_templateObject24() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1400px;\n  position: relative;\n  height: 100%;\n  aspect-ratio: 1391/124;\n"
    ]);
    OutrunGrid_templateObject24 = function() {
        return data;
    };
    return data;
}
function _templateObject25() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject25 = function() {
        return data;
    };
    return data;
}













react_spring_three_modern/* Globals.assign */.OH.assign({
    frameLoop: "always"
});
const FadeIn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4bd36ab-0"
})(OutrunGrid_templateObject());
const FadeOut = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4bd36ab-1"
})(OutrunGrid_templateObject1());
const CanvasContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4bd36ab-2"
})(OutrunGrid_templateObject2());
const CanvasContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4bd36ab-3"
})(OutrunGrid_templateObject3());
const OutrunGrid_Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-b4bd36ab-4"
})(OutrunGrid_templateObject5(), (param)=>{
    let { $debug  } = param;
    return $debug && (0,styled_components_browser_esm/* css */.iv)(OutrunGrid_templateObject4(), CanvasContent);
});
const TextContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4bd36ab-5"
})(OutrunGrid_templateObject6());
const TextContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4bd36ab-6"
})(OutrunGrid_templateObject8(), landing_CTAButton, (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(OutrunGrid_templateObject7(), landing_CTAButton);
});
const OutrunGrid_FooterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4bd36ab-7"
})(OutrunGrid_templateObject10(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(OutrunGrid_templateObject9());
});
const OutrunGrid_FooterContent = (0,styled_components_browser_esm/* default */.ZP)(react_spring_web_modern.a.div).withConfig({
    componentId: "sc-b4bd36ab-8"
})(OutrunGrid_templateObject13(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.sm(OutrunGrid_templateObject11());
}, (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(OutrunGrid_templateObject12());
});
const OutrunGrid_FooterColumn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4bd36ab-9"
})(OutrunGrid_templateObject18(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.ltSm(OutrunGrid_templateObject14());
}, (param)=>{
    let { theme: { mq  }  } = param;
    return mq.ltSm(OutrunGrid_templateObject15());
}, (param)=>{
    let { theme: { mq  }  } = param;
    return mq.smOnly(OutrunGrid_templateObject16());
}, (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(OutrunGrid_templateObject17());
});
const OutrunGrid_FooterColumnHeader = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    componentId: "sc-b4bd36ab-10"
})(OutrunGrid_templateObject19());
const OutrunGrid_FooterColumnList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-b4bd36ab-11"
})(OutrunGrid_templateObject20());
const OutrunGrid_FooterColumnItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-b4bd36ab-12"
})(OutrunGrid_templateObject21());
const OutrunGrid_LogoContainer = (0,styled_components_browser_esm/* default */.ZP)(react_spring_web_modern.a.div).withConfig({
    componentId: "sc-b4bd36ab-13"
})(OutrunGrid_templateObject23(), (param)=>{
    let { theme: { mq  }  } = param;
    return mq.md(OutrunGrid_templateObject22());
});
const LogoInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4bd36ab-14"
})(OutrunGrid_templateObject24());
const Logo = (0,styled_components_browser_esm/* default */.ZP)((0,react_spring_web_modern.a)((image_default()))).withConfig({
    componentId: "sc-b4bd36ab-15"
})(_templateObject25());
const Rig = (param)=>{
    let { progress  } = param;
    (0,index_673ef987_esm.A)((state, dt)=>{
        const z = progress.value.to([
            0,
            0.1,
            1
        ], [
            110,
            110,
            70
        ]).get();
        const y = progress.value.to([
            0,
            0.1,
            0.3,
            1
        ], [
            10,
            10,
            1,
            1
        ]).get();
        const pitch = progress.value.to([
            0.1,
            0.3
        ], [
            -0.5,
            0
        ], "clamp").get();
        maath_easing_esm/* damp3 */.G0(state.camera.position, [
            1,
            y,
            z
        ], 0.25, dt);
        maath_easing_esm/* dampE */.Tp(state.camera.rotation, [
            Math.PI * pitch,
            0,
            0
        ], 0.25, dt);
    });
    return null;
};
const Orb = (param)=>{
    let { progress  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_spring_three_modern/* animated.mesh */.q.mesh, {
        scale: 450,
        "position-z": -900,
        "position-x": progress.value.to([
            0.3,
            1
        ], [
            -200,
            100
        ]),
        "position-y": progress.value.to([
            0.3,
            1
        ], [
            -550,
            100
        ]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("sphereGeometry", {
                args: [
                    1,
                    64,
                    64
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
                color: "#fff"
            })
        ]
    });
};
const Plane = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("mesh", {
        "rotation-x": Math.PI * -0.5,
        scale: 250,
        "position-y": -1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("planeGeometry", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
                color: "#000000"
            })
        ]
    });
};
const Grid = (param)=>{
    let { debug  } = param;
    const { ref , scrollPercentage , onScreen  } = useElementScrollPercentage({
        startAtTop: true
    });
    const { showContactModal  } = (0,Contact/* useContactModal */.s)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OutrunGrid_Container, {
        ref: ref,
        $debug: debug,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeIn, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CanvasContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CanvasContent, {
                        children: !debug && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_three_fiber_esm/* Canvas */.Xz, {
                            camera: {
                                position: [
                                    1,
                                    10,
                                    110
                                ],
                                rotation: [
                                    Math.PI * -0.5,
                                    0,
                                    0
                                ]
                            },
                            frameloop: onScreen ? "always" : "never",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ambientLight", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Rig, {
                                    progress: scrollPercentage
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Plane, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Orb, {
                                    progress: scrollPercentage
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_Stars, {
                                    radius: 500,
                                    progress: scrollPercentage,
                                    starsCount: 2000
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("gridHelper", {
                                    args: [
                                        30,
                                        300,
                                        "#444",
                                        "#444"
                                    ],
                                    scale: 10
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OutrunGrid_FooterContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OutrunGrid_LogoContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoInner, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                                        style: {
                                            opacity: scrollPercentage.value.to([
                                                0.62,
                                                0.72
                                            ], [
                                                0,
                                                1
                                            ], "clamp"),
                                            transform: scrollPercentage.value.to([
                                                0.62,
                                                0.72
                                            ], [
                                                100,
                                                0
                                            ], "clamp").to((val)=>"translate3d(0, -".concat(val, "%, 0)"))
                                        },
                                        src: "/svg/footer-logo-desktop.svg",
                                        alt: "Graveflex",
                                        fill: true
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OutrunGrid_FooterContent, {
                                style: {
                                    opacity: scrollPercentage.value.to([
                                        0.62,
                                        0.72
                                    ], [
                                        0,
                                        1
                                    ], "clamp"),
                                    transform: scrollPercentage.value.to([
                                        0.62,
                                        0.72
                                    ], [
                                        100,
                                        0
                                    ], "clamp").to((val)=>"translate3d(0, ".concat(val, "%, 0)"))
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OutrunGrid_FooterColumn, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OutrunGrid_FooterColumnHeader, {
                                                children: "Contact"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OutrunGrid_FooterColumnList, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OutrunGrid_FooterColumnItem, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "mailto: dispatch@graveflex.com",
                                                            children: "dispatch@graveflex.com"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OutrunGrid_FooterColumnItem, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "tel: +13122100686",
                                                            children: "(312) 210-0686"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OutrunGrid_FooterColumn, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OutrunGrid_FooterColumnHeader, {
                                                children: "Follow Us"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OutrunGrid_FooterColumnList, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OutrunGrid_FooterColumnItem, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "https://www.instagram.com/graveflex_/?hl=en",
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            children: "Instagram"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OutrunGrid_FooterColumnItem, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "https://www.linkedin.com/company/graveflex/",
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            children: "LinkedIn"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OutrunGrid_FooterColumn, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OutrunGrid_FooterColumnHeader, {
                                                children: "Links"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OutrunGrid_FooterColumnList, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OutrunGrid_FooterColumnItem, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/projects",
                                                            children: "Work"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OutrunGrid_FooterColumnItem, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/team",
                                                            children: "Team"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OutrunGrid_FooterColumn, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OutrunGrid_FooterColumnHeader, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                                    children: [
                                                        "Graveflex",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        "All rights reserved"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OutrunGrid_FooterColumnList, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OutrunGrid_FooterColumnItem, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                                        children: [
                                                            "\xa9 ",
                                                            new Date().getFullYear()
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: "Contact Us"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "Let's build",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                " the next big thing",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                " together"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_CTAButton, {
                            onClick: showContactModal,
                            children: "Get in touch"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeOut, {})
        ]
    });
};
/* harmony default export */ var OutrunGrid = (Grid);

;// CONCATENATED MODULE: ./components/landing/index.tsx











const LandingPage = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(landing_AppContainer, {
        showFooter: false,
        pad: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_Tree, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_Intro, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_WhatWeDo, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_Slides, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_SelectedClients, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_Quote, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_ImpactCards, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OutrunGrid, {})
        ]
    });
};
/* harmony default export */ var landing = (LandingPage);

// EXTERNAL MODULE: ./node_modules/lodash/defaultsDeep.js
var defaultsDeep = __webpack_require__(66913);
var defaultsDeep_default = /*#__PURE__*/__webpack_require__.n(defaultsDeep);
// EXTERNAL MODULE: ./node_modules/@refract-ui/core/dist/index.esm.js
var index_esm = __webpack_require__(43319);
;// CONCATENATED MODULE: ./blocks/index.ts

const defaultOpts = {
    suspense: true,
    ssr: true
};
const ChipBlock = dynamic_default()(()=>__webpack_require__.e(/* import() */ 8117).then(__webpack_require__.bind(__webpack_require__, 98117)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(98117)
            ]
    },
    ...defaultOpts
});
const ProjectListBlock = dynamic_default()(()=>__webpack_require__.e(/* import() */ 5620).then(__webpack_require__.bind(__webpack_require__, 45620)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(45620)
            ]
    },
    ...defaultOpts
});
const KitchenSink = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(8820), __webpack_require__.e(4825), __webpack_require__.e(1421)]).then(__webpack_require__.bind(__webpack_require__, 81421)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(81421)
            ]
    },
    ...defaultOpts
});
const PageHero = dynamic_default()(()=>__webpack_require__.e(/* import() */ 1507).then(__webpack_require__.bind(__webpack_require__, 61507)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(61507)
            ]
    },
    ...defaultOpts
});
const FullWidthImage = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(8820), __webpack_require__.e(746)]).then(__webpack_require__.bind(__webpack_require__, 20746)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(20746)
            ]
    },
    ...defaultOpts
});
const TextBlock = dynamic_default()(()=>__webpack_require__.e(/* import() */ 7977).then(__webpack_require__.bind(__webpack_require__, 27977)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(27977)
            ]
    },
    ...defaultOpts
});
const ThemeSliderBlock = dynamic_default()(()=>__webpack_require__.e(/* import() */ 7306).then(__webpack_require__.bind(__webpack_require__, 37306)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(37306)
            ]
    },
    ...defaultOpts
});
const ResultsBlock = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2870).then(__webpack_require__.bind(__webpack_require__, 52870)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(52870)
            ]
    },
    ...defaultOpts
});
const SpacerBlock = dynamic_default()(()=>__webpack_require__.e(/* import() */ 3691).then(__webpack_require__.bind(__webpack_require__, 3691)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(3691)
            ]
    },
    ...defaultOpts
});
const ProgressCirclesBlock = dynamic_default()(()=>__webpack_require__.e(/* import() */ 5061).then(__webpack_require__.bind(__webpack_require__, 75061)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(75061)
            ]
    },
    ...defaultOpts
});
const QuoteBlock = dynamic_default()(()=>__webpack_require__.e(/* import() */ 7661).then(__webpack_require__.bind(__webpack_require__, 67661)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(67661)
            ]
    },
    ...defaultOpts
});
const ThreeColumnImageAndTextBlock = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2836).then(__webpack_require__.bind(__webpack_require__, 12836)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(12836)
            ]
    },
    ...defaultOpts
});
const ProcessBlock = dynamic_default()(()=>__webpack_require__.e(/* import() */ 3411).then(__webpack_require__.bind(__webpack_require__, 13411)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(13411)
            ]
    },
    ...defaultOpts
});
const HorizontalSlideshow = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(8913), __webpack_require__.e(674)]).then(__webpack_require__.bind(__webpack_require__, 90674)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(90674)
            ]
    },
    ...defaultOpts
});
const ProjectHero = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(8820), __webpack_require__.e(1566)]).then(__webpack_require__.bind(__webpack_require__, 91566)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(91566)
            ]
    },
    ...defaultOpts
});
const AnimatedMap = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2172).then(__webpack_require__.bind(__webpack_require__, 72172)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(72172)
            ]
    },
    ...defaultOpts
});
const ContactForm = dynamic_default()(()=>__webpack_require__.e(/* import() */ 7485).then(__webpack_require__.bind(__webpack_require__, 27485)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(27485)
            ]
    },
    ...defaultOpts
});
const TextImageBlock = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(8820), __webpack_require__.e(5681)]).then(__webpack_require__.bind(__webpack_require__, 15681)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(15681)
            ]
    },
    ...defaultOpts
});
const VideoBlock = dynamic_default()(()=>__webpack_require__.e(/* import() */ 8651).then(__webpack_require__.bind(__webpack_require__, 98651)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(98651)
            ]
    },
    ...defaultOpts
});
const BlendedText = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2673).then(__webpack_require__.bind(__webpack_require__, 42673)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(42673)
            ]
    },
    ...defaultOpts
});
const BlendedContactBlock = dynamic_default()(()=>__webpack_require__.e(/* import() */ 1615).then(__webpack_require__.bind(__webpack_require__, 41615)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(41615)
            ]
    },
    ...defaultOpts
});
const AnimatedColumnBlock = dynamic_default()(()=>__webpack_require__.e(/* import() */ 8070).then(__webpack_require__.bind(__webpack_require__, 88070)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(88070)
            ]
    },
    ...defaultOpts
});
const TextWithColumnsBlock = dynamic_default()(()=>__webpack_require__.e(/* import() */ 3359).then(__webpack_require__.bind(__webpack_require__, 43359)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(43359)
            ]
    },
    ...defaultOpts
});
const CGRRiverBlock = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2061).then(__webpack_require__.bind(__webpack_require__, 82061)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(82061)
            ]
    },
    ...defaultOpts
});
const ContainedImage = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(8820), __webpack_require__.e(8023)]).then(__webpack_require__.bind(__webpack_require__, 88023)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(88023)
            ]
    },
    ...defaultOpts
});
const Landing = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(8820), __webpack_require__.e(8913), __webpack_require__.e(7023)]).then(__webpack_require__.bind(__webpack_require__, 67023)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(67023)
            ]
    },
    ...defaultOpts
});
const AboutHero = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(8820), __webpack_require__.e(9146)]).then(__webpack_require__.bind(__webpack_require__, 79146)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(79146)
            ]
    },
    ...defaultOpts
});
const AboutItem = dynamic_default()(()=>__webpack_require__.e(/* import() */ 7780).then(__webpack_require__.bind(__webpack_require__, 87780)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(87780)
            ]
    },
    ...defaultOpts
});
const TextAndIcons = dynamic_default()(()=>__webpack_require__.e(/* import() */ 8832).then(__webpack_require__.bind(__webpack_require__, 8832)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(8832)
            ]
    },
    ...defaultOpts
});
const QuoteShowcase = dynamic_default()(()=>__webpack_require__.e(/* import() */ 3388).then(__webpack_require__.bind(__webpack_require__, 53388)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(53388)
            ]
    },
    ...defaultOpts
});
const Team = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(8820), __webpack_require__.e(4122)]).then(__webpack_require__.bind(__webpack_require__, 84122)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(84122)
            ]
    },
    ...defaultOpts
});
const ScrollableImage = dynamic_default()(()=>__webpack_require__.e(/* import() */ 3356).then(__webpack_require__.bind(__webpack_require__, 53356)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(53356)
            ]
    },
    ...defaultOpts
});
const BackgroundImage = dynamic_default()(()=>__webpack_require__.e(/* import() */ 718).then(__webpack_require__.bind(__webpack_require__, 70718)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(70718)
            ]
    },
    ...defaultOpts
});
const ProjectsIndex = dynamic_default()(()=>__webpack_require__.e(/* import() */ 3992).then(__webpack_require__.bind(__webpack_require__, 53992)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(53992)
            ]
    },
    ...defaultOpts
});
const QuoteWithAuthor = dynamic_default()(()=>__webpack_require__.e(/* import() */ 3898).then(__webpack_require__.bind(__webpack_require__, 33898)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(33898)
            ]
    },
    ...defaultOpts
});
const NumbersBlock = dynamic_default()(()=>__webpack_require__.e(/* import() */ 4025).then(__webpack_require__.bind(__webpack_require__, 54025)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(54025)
            ]
    },
    ...defaultOpts
});
const ToolsBlock = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9060).then(__webpack_require__.bind(__webpack_require__, 49060)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(49060)
            ]
    },
    ...defaultOpts
});

// EXTERNAL MODULE: ./node_modules/tinacms/dist/react.es.js
var react_es = __webpack_require__(49462);
// EXTERNAL MODULE: ./theme/index.ts + 8 modules
var theme = __webpack_require__(2466);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./lib/analytics/index.ts + 10 modules
var analytics = __webpack_require__(64595);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/MainNav/MainNav.tsx

function MainNav_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    // DESKTOP RESETS\n    visibility: visible;\n    opacity: 1;\n    transition-property: none;\n    position: relative;\n    width: auto;\n    height: auto;\n    background-image: none;\n    margin-right: 1.5rem;\n  "
    ]);
    MainNav_templateObject = function() {
        return data;
    };
    return data;
}
function MainNav_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // MOBILE BASICS\n  position: fixed;\n  top: 0;\n  left: 0;\n\n  // BACKGROUND & ANIMATION\n  background-image: url('/uploads/GFX_bg02.png');\n  background-size: cover;\n  opacity: ",
        ";\n  visibility: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n\n  transition: opacity 300ms ease-in-out, height 0ms linear ",
        ",\n    width 0ms linear ",
        ",\n    visibility 0ms linear ",
        ";\n\n  ",
        ";\n"
    ]);
    MainNav_templateObject1 = function() {
        return data;
    };
    return data;
}
function MainNav_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    overflow: visible;\n    height: 100%;\n    top: 0;\n  "
    ]);
    MainNav_templateObject2 = function() {
        return data;
    };
    return data;
}
function MainNav_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  align-items: center;\n  height: calc(100% - 71px);\n  position: relative;\n  top: 71px;\n  overflow: scroll;\n\n  ",
        ";\n"
    ]);
    MainNav_templateObject3 = function() {
        return data;
    };
    return data;
}
function MainNav_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 0 !important;\n    flex-direction: row;\n    gap: 1.5rem;\n  "
    ]);
    MainNav_templateObject4 = function() {
        return data;
    };
    return data;
}
function MainNav_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 !important;\n  margin: 0 0 2rem 0 !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 2rem;\n  ",
        ";\n"
    ]);
    MainNav_templateObject5 = function() {
        return data;
    };
    return data;
}
function MainNav_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style-type: none;\n  margin: 0 !important;\n"
    ]);
    MainNav_templateObject6 = function() {
        return data;
    };
    return data;
}
function MainNav_templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n        text-decoration: underline;\n      "
    ]);
    MainNav_templateObject7 = function() {
        return data;
    };
    return data;
}
function MainNav_templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: inline-block;\n      font-size: 1.125rem;\n\n      color: ",
        ";\n      background-color: ",
        ";\n\n      &:hover {\n        transition: 0.3s;\n        transition: 0.22s;\n      }\n    "
    ]);
    MainNav_templateObject8 = function() {
        return data;
    };
    return data;
}
function MainNav_templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    font-size: 1.5rem;\n    padding: 0;\n    margin: 0;\n    cursor: pointer;\n    text-align: center;\n\n    ",
        "\n\n    ",
        ";\n  }\n"
    ]);
    MainNav_templateObject9 = function() {
        return data;
    };
    return data;
}





const LINKS = [
    {
        title: "Work",
        link: "/projects"
    },
    {
        title: "Team",
        link: "/team"
    },
    {
        title: "Contact",
        link: "/contact"
    }
];
const linkArray = LINKS.map((param)=>{
    let { link  } = param;
    return link;
});
const Nav = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-fc9e5e8e-0"
})(MainNav_templateObject1(), (param)=>{
    let { menu  } = param;
    return menu ? "1" : "0";
}, (param)=>{
    let { menu  } = param;
    return menu ? "visible" : "hidden";
}, (param)=>{
    let { menu  } = param;
    return menu ? "100vw" : "0";
}, (param)=>{
    let { menu  } = param;
    return menu ? "100%" : "0";
}, (param)=>{
    let { menu  } = param;
    return !menu && "300ms";
}, (param)=>{
    let { menu  } = param;
    return !menu && "300ms";
}, (param)=>{
    let { menu  } = param;
    return !menu && "300ms";
}, (param)=>{
    let { theme  } = param;
    return theme.mq.md(MainNav_templateObject());
});
const NavInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc9e5e8e-1"
})(MainNav_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.mq.md(MainNav_templateObject2());
});
const Ul = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-fc9e5e8e-2"
})(MainNav_templateObject5(), (param)=>{
    let { theme  } = param;
    return theme.mq.md(MainNav_templateObject4());
});
const Li = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-fc9e5e8e-3"
})(MainNav_templateObject6());
const StyledLink = (0,styled_components_browser_esm/* default */.ZP)((link_default())).withConfig({
    componentId: "sc-fc9e5e8e-4"
})(MainNav_templateObject9(), (param)=>{
    let { $active  } = param;
    return $active && (0,styled_components_browser_esm/* css */.iv)(MainNav_templateObject7());
}, (param)=>{
    let { theme , $landing  } = param;
    return theme.mq.md(MainNav_templateObject8(), theme.themeColors.fg, $landing ? "rgba(0,0,0,0)" : theme.themeColors.bg);
});
const MainNav = (param)=>{
    let { menu , landing  } = param;
    const { asPath  } = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav, {
        menu: menu,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavInner, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Ul, {
                children: LINKS.map((param, i)=>{
                    let { link , title  } = param;
                    const active = linkArray.includes(link) ? asPath === link : "/projects" === link;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Li, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            $landing: landing ? landing : false,
                            $active: active,
                            href: link,
                            children: title
                        })
                    }, "nav-item-".concat(i));
                })
            })
        })
    });
};
/* harmony default export */ var MainNav_MainNav = (MainNav);

;// CONCATENATED MODULE: ./components/MainNav/index.ts


// EXTERNAL MODULE: ./components/Icons/index.ts
var Icons = __webpack_require__(21358);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(65820);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 110 modules
var motion = __webpack_require__(86909);
;// CONCATENATED MODULE: ./components/Header/Header.tsx

function Header_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      top: 0;\n      z-index: 100;\n    "
    ]);
    Header_templateObject = function() {
        return data;
    };
    return data;
}
function Header_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    // DESKTOP RESETS\n    position: ",
        ";\n    z-index: ",
        "\n    background-image: none;\n    background: ",
        ";\n    border-bottom: 1px solid ",
        ";\n\n    // DESKTOP GRID\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr auto;\n    grid-template-areas:\n      \"logo . nav\";\n\n    // RESET FALSE BORDER\n    &:after {\n      content: '';\n      border-bottom: none;\n    }\n  "
    ]);
    Header_templateObject1 = function() {
        return data;
    };
    return data;
}
function Header_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // MOBILE BASICS\n  width: 100vw;\n  max-width: 100vw;\n  position: ",
        ";\n  background: ",
        ";\n  z-index: 50;\n\n  ",
        "\n\n  // MOBILE GRID\n  display: grid;\n  grid-template-rows: ",
        ";\n  grid-template-columns: auto 1fr auto;\n  grid-template-areas: 'logo . nav';\n\n  // MIMIC BORDER BOTTOM\n  &:after {\n    content: '';\n    border-bottom: 1px solid\n      ",
        ";\n    transition: border 300ms ease-in-out;\n    width: 100%;\n    position: absolute;\n    display: block;\n    top: 70px;\n  }\n\n  ",
        ";\n"
    ]);
    Header_templateObject2 = function() {
        return data;
    };
    return data;
}
function Header_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: ",
        ";\n  overflow-x: visible;\n"
    ]);
    Header_templateObject3 = function() {
        return data;
    };
    return data;
}
function Header_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n  "
    ]);
    Header_templateObject4 = function() {
        return data;
    };
    return data;
}
function Header_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: nav;\n  border-left: 1px solid\n    ",
        ";\n  transition: border 300ms ease-in-out;\n  padding: 0.9375rem 1rem;\n  z-index: ",
        ";\n\n  ",
        ";\n"
    ]);
    Header_templateObject5 = function() {
        return data;
    };
    return data;
}
function Header_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Header_templateObject6 = function() {
        return data;
    };
    return data;
}
function Header_templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: nav;\n  display: flex;\n  align-items: center;\n"
    ]);
    Header_templateObject7 = function() {
        return data;
    };
    return data;
}








const Header_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bf32c69d-0"
})(Header_templateObject2(), (param)=>{
    let { menu , landing , teamLayout  } = param;
    if (menu || landing) return "fixed";
    else if (teamLayout) return "sticky !important";
    return "absolute";
}, (param)=>{
    let { theme , landing  } = param;
    return landing ? "rgba(0,0,0,0)" : theme.themeColors.bg;
}, (param)=>{
    let { teamLayout , menu  } = param;
    return teamLayout && !menu && (0,styled_components_browser_esm/* css */.iv)(Header_templateObject());
}, (param)=>{
    let { menu  } = param;
    return menu ? "min-content 1fr" : "auto";
}, (param)=>{
    let { theme , menu  } = param;
    return menu ? theme.themeColorOpacities.light30 : theme.themeColorOpacities.fg30;
}, (param)=>{
    let { theme , landing , teamLayout  } = param;
    return theme.mq.md(Header_templateObject1(), landing ? "fixed" : "static", teamLayout ? 1 : "99", landing ? "rgba(0,0,0,0)" : theme.themeColors.bg, theme.themeColorOpacities.fg30);
});
const Header_LogoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bf32c69d-1"
})(Header_templateObject3(), (param)=>{
    let { teamLayout  } = param;
    return teamLayout ? 100 : 2;
});
const MenuContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bf32c69d-2"
})(Header_templateObject5(), (param)=>{
    let { theme , menu  } = param;
    return menu ? theme.themeColorOpacities.light30 : theme.themeColorOpacities.fg30;
}, (param)=>{
    let { teamLayout  } = param;
    return teamLayout ? 100 : 2;
}, (param)=>{
    let { theme  } = param;
    return theme.mq.md(Header_templateObject4());
});
const StyledLogo = (0,styled_components_browser_esm/* default */.ZP)(Icons/* default */.Z).withConfig({
    componentId: "sc-bf32c69d-3"
})(Header_templateObject6());
const MainNavContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bf32c69d-4"
})(Header_templateObject7());
const Header_Header = (param)=>{
    let { landing , teamLayout  } = param;
    const [menu, setMenu] = (0,react.useState)(false);
    const theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    // Lock app scrolling when menu is shown
    (0,useLockBodyScroll/* default */.Z)(menu);
    const animationProps = {
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        },
        transition: {
            duration: 0.15
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_Container, {
        menu: menu,
        landing: landing ? landing : undefined,
        teamLayout: teamLayout,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/",
                "aria-label": "Graveflex Logo",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_LogoContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogo, {
                        name: "Logo",
                        color: menu ? "#FFF" : theme.themeColors.fg
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuContainer, {
                menu: menu,
                onClick: ()=>setMenu(!menu),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                    mode: "wait",
                    initial: false,
                    children: menu ? /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                        ...animationProps,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* default */.Z, {
                            name: "Close",
                            color: "#FFF"
                        })
                    }, "close-icon") : /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                        ...animationProps,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* default */.Z, {
                            name: "Menu",
                            color: theme.themeColors.fg
                        })
                    }, "menu-icon")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainNavContainer, {
                onClick: ()=>setMenu(false),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainNav_MainNav, {
                    menu: menu,
                    landing: landing ? landing : undefined
                })
            })
        ]
    });
};
/* harmony default export */ var components_Header_Header = (Header_Header);

;// CONCATENATED MODULE: ./components/Header/index.ts


// EXTERNAL MODULE: ./components/Icons/Icon.tsx + 51 modules
var Icon = __webpack_require__(82218);
;// CONCATENATED MODULE: ./layouts/CapabilitiesLayout/CapabilitiesLayout.tsx

function CapabilitiesLayout_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    grid-template-columns: 1fr;\n    padding-top: 0;\n  "
    ]);
    CapabilitiesLayout_templateObject = function() {
        return data;
    };
    return data;
}
function CapabilitiesLayout_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 71px;\n  border-bottom: 1px solid ",
        ";\n  display: flex;\n  flex-direction: column;\n\n  ",
        ";\n"
    ]);
    CapabilitiesLayout_templateObject1 = function() {
        return data;
    };
    return data;
}
function CapabilitiesLayout_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n  "
    ]);
    CapabilitiesLayout_templateObject2 = function() {
        return data;
    };
    return data;
}
function CapabilitiesLayout_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-column: 1 / span 2;\n\n  ",
        ";\n"
    ]);
    CapabilitiesLayout_templateObject3 = function() {
        return data;
    };
    return data;
}
function CapabilitiesLayout_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'SpaceMonoRegular';\n  font-weight: 400;\n  font-size: 16px;\n  float: right;\n  padding: 0.5rem 1.375rem;\n  margin: 1.875rem 1.5rem 0.5rem auto;\n  width: 13.875rem;\n  border: 1px solid ",
        ";\n  border-radius: 54px;\n  background: transparent;\n  color: ",
        ";\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    CapabilitiesLayout_templateObject4 = function() {
        return data;
    };
    return data;
}






const CapabilitiesLayout_Main = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
    componentId: "sc-4abac5cf-0"
})(CapabilitiesLayout_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.themeColorOpacities.fg50;
}, (param)=>{
    let { theme  } = param;
    return theme.mq.md(CapabilitiesLayout_templateObject());
});
const CapabilitiesButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4abac5cf-1"
})(CapabilitiesLayout_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.mq.md(CapabilitiesLayout_templateObject2());
});
const CapabilitiesMobileMenuButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-4abac5cf-2"
})(CapabilitiesLayout_templateObject4(), (param)=>{
    let { theme  } = param;
    return theme.themeColors.fg;
}, (param)=>{
    let { theme  } = param;
    return theme.themeColors.fg;
});
const CapabilitiesLayout = (param)=>{
    let { children  } = param;
    const [menuVisibility, setMenuVisibility] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        document.body.style.overflow = menuVisibility ? "hidden" : "unset";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Header_Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CapabilitiesLayout_Main, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CapabilitiesButtonContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CapabilitiesMobileMenuButton, {
                            type: "button",
                            onClick: ()=>setMenuVisibility(!menuVisibility),
                            children: [
                                "What we do",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    name: "SmallMenu"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Footer, {})
        ]
    });
};
/* harmony default export */ var CapabilitiesLayout_CapabilitiesLayout = (CapabilitiesLayout);

;// CONCATENATED MODULE: ./layouts/CapabilitiesLayout/index.ts


;// CONCATENATED MODULE: ./layouts/CapabilityCanvasLayout/CapabilityCanvasLayout.tsx



const CapabilityCanvasLayout = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CapabilitiesLayout_CapabilitiesLayout, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: "Canvas"
                })
            ]
        })
    });
};
/* harmony default export */ var CapabilityCanvasLayout_CapabilityCanvasLayout = (CapabilityCanvasLayout);

;// CONCATENATED MODULE: ./layouts/CapabilityCanvasLayout/index.ts


;// CONCATENATED MODULE: ./layouts/LandingLayout/LandingLayout.tsx



const LandingLayout = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Header_Header, {
                landing: true
            }),
            children
        ]
    });
};
/* harmony default export */ var LandingLayout_LandingLayout = (LandingLayout);

;// CONCATENATED MODULE: ./layouts/LandingLayout/index.ts


;// CONCATENATED MODULE: ./layouts/TeamLayout/TeamLayout.tsx

function TeamLayout_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  main {\n    position: unset !important;\n  }\n"
    ]);
    TeamLayout_templateObject = function() {
        return data;
    };
    return data;
}




const SAppContainer = (0,styled_components_browser_esm/* default */.ZP)(landing_AppContainer).withConfig({
    componentId: "sc-a97e3e12-0"
})(TeamLayout_templateObject());
const TeamLayout = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SAppContainer, {
        showFooter: false,
        children: children
    });
};
/* harmony default export */ var TeamLayout_TeamLayout = (TeamLayout);

;// CONCATENATED MODULE: ./layouts/TeamLayout/index.ts


;// CONCATENATED MODULE: ./layouts/index.ts





const layouts = {
    DefaultLayout: landing_AppContainer,
    CapabilitiesLayout: CapabilitiesLayout_CapabilitiesLayout,
    CapabilityCanvasLayout: CapabilityCanvasLayout_CapabilityCanvasLayout,
    LandingLayout: LandingLayout_LandingLayout,
    TeamLayout: TeamLayout_TeamLayout
};
/* harmony default export */ var layouts_0 = (layouts);

;// CONCATENATED MODULE: ./pages/[[...slug]].tsx

function _slug_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  // this fixes the black boxes at the bottom of the project pages\n  // for some reason, having a border makes the background take the entire span like its supposed to.\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _slug_templateObject = function() {
        return data;
    };
    return data;
}















const StyledSubTheme = (0,styled_components_browser_esm/* default */.ZP)(index_esm/* SubTheme */.xZ).withConfig({
    componentId: "sc-36100719-0"
})(_slug_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.themeColors.bg;
}, (param)=>{
    let { theme  } = param;
    return theme.themeColors.bg;
});
const variants = {
    initial: {
        opacity: 0
    },
    out: {
        opacity: 0,
        transition: {
            duration: 0
        }
    },
    in: {
        opacity: 1,
        transition: {
            duration: 0.33
        }
    }
};
// if theme is provided, render SubTheme with given theme
const MaybeThemed = (param)=>{
    let { theme , children  } = param;
    return theme ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubTheme, {
        theme: theme,
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: children
    });
};
const PageRoot = (param)=>{
    let { data , query , variables  } = param;
    var ref, ref1, ref2, ref3;
    const page = (0,react_es/* useTina */.UL)({
        data: data,
        query: query,
        variables: variables
    }).data.page;
    const [pageTheme, setPageTheme] = (0,react.useState)(undefined);
    const [pageThemeName, setPageThemeName] = (0,react.useState)(undefined);
    const pageLayoutName = ((ref = data.page.pageConfig) === null || ref === void 0 ? void 0 : ref.layout) || "DefaultLayout";
    const PageLayout = layouts_0[pageLayoutName];
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        var ref;
        // set page theme after navigation to new route to prevent style jumping
        const pageThemeName = (ref = data.page.pageConfig) === null || ref === void 0 ? void 0 : ref.theme;
        setPageTheme(theme/* default */.Z[pageThemeName]);
        setPageThemeName(pageThemeName);
        // log pageviews to analytics services
        try {
            analytics/* default */.Z === null || analytics/* default */.Z === void 0 ? void 0 : analytics/* default.page */.Z.page();
        } catch (err) {
            console.log("page view error.");
        }
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
        initial: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
            variants: variants,
            initial: "initial",
            animate: "in",
            exit: "out",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MaybeThemed, {
                theme: pageTheme,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                        title: (ref1 = data.page.pageConfig) === null || ref1 === void 0 ? void 0 : ref1.title,
                        description: (ref2 = data.page.pageConfig) === null || ref2 === void 0 ? void 0 : ref2.description
                    }),
                    router.asPath === "/" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(landing, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout, {
                        ...data.page.pageConfig,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: page === null || page === void 0 ? void 0 : (ref3 = page.pageSections) === null || ref3 === void 0 ? void 0 : ref3.map((props, idx)=>{
                                var ref, ref1;
                                const name = props === null || props === void 0 ? void 0 : (ref = props.__typename) === null || ref === void 0 ? void 0 : ref.replace(/^PagePageSections/, "");
                                const key = "".concat(props === null || props === void 0 ? void 0 : props.__typename, "/").concat(idx);
                                const Block = blocks_namespaceObject[name];
                                const blockProps = omit_default()(props, [
                                    "__typename",
                                    "blockConfig"
                                ]);
                                const blockThemeName = (props === null || props === void 0 ? void 0 : (ref1 = props.blockConfig) === null || ref1 === void 0 ? void 0 : ref1.theme) || pageThemeName || "dark";
                                const blockSettings = omit_default()(props === null || props === void 0 ? void 0 : props.blockConfig, [
                                    "__typename",
                                    "theme"
                                ]) || {};
                                const blockTheme = defaultsDeep_default()({
                                    gfx: {
                                        block: {
                                            settings: blockSettings
                                        }
                                    }
                                }, theme/* default */.Z[blockThemeName]);
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MaybeThemed, {
                                    theme: blockTheme,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        ...blockProps
                                    })
                                }, key);
                            })
                        })
                    })
                ]
            })
        }, router.asPath)
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (PageRoot);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3737,5703,9774,2888,179], function() { return __webpack_exec__(95759); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);